export const Languages = {
  Hindi: {
    "no_data_found":"कोई डेटा नहीं मिला।",
"Subscribe to watch":"देखने के लिए सब्सक्राइब करें",
 "Drama": "नाटक",
  "Romance": "प्रेम कथा",
  "Fantasy": "कल्पना",
  "Contemporary Fiction": "समकालीन कथा साहित्य",
  "History": "इतिहास",
  "Mystery": "रहस्य",
  "Thriller": "थ्रिलर",
  "Horror": "डरावनी",
  "Educational": "शैक्षिक",
  "Health": "स्वास्थ्य",
  "Biography": "जीवनी",
  "Musical Drama": "संगीत नाटक",
  "Music & Dance": "संगीत और नृत्य",
  "Dance Drama": "नृत्य नाटक",
  "Music": "संगीत",
  "War": "युद्ध",
  "Carnatic Music": "कर्नाटक संगीत",
"Finance": "वित्त",
"Hobbies And Crafts": "शौक और शिल्प",
"Business and Finance": "व्यापार और वित्त",
"Industrial design": "औद्योगिक डिजाइन",
  "Rom-Com": "रॉम-कॉम",
  "Sports": "खेल",
  "Survival": "जीवित रहना",
    "Wildlife": "वन्यजीव",
  "Adventure": "साहसिक",
  "Animation": "एनीमेशन",
  "Literature": "साहित्य",
  "Arts & Culture": "कला और संस्कृति",
  "Religious": "धार्मिक",
  "Crime": "अपराध",
  "Spiritual": "आध्यात्मिक",
  "Detective": "जासूसी",
  "Mythology": "पौराणिक",
  "Entertainment": "मनोरंजन",
  "Historical Fiction": "ऐतिहासिक कथा",
  "Political": "राजनीतिक",
  "Classical Music": "शास्त्रीय संगीत",
  "Comedy": "कॉमेडी",
  "Satire": "व्यंग्य",
  "Humor": "हास्य",
  "Autobiography": "आत्मकथा",
  "Lifestyle": "जीवनशैली",
  "Kids & Family": "बच्चे और परिवार",
  "Devotional": "भक्ति",
  "Nature & Wildlife": "प्रकृति और वन्यजीव",
  "Travelogue": "यात्रा-वृत्तांत",
  "Folk Music": "लोक संगीत",
  "Recent Live": "हाल ही में लाइव", 
  "Storytelling": "कहानी सुनाना",
  "Dance": "नृत्य",
  "Talk Shows": "टॉक शो",
  "Inspirational": "प्रेरणादायक",
  "Reality": "रियलिटी",
  "Action": "एक्शन",
  "Agriculture": "कृषि",
  "International": "अंतरराष्ट्रीय",
  "Anime": "एनीमे",
  "Period Drama": "कालखंड नाटक",
  "Sci-Fi": "विज्ञान-कथा",
  "Patriotic": "देशभक्ति",
  "Performing Arts": "प्रदर्शन कला",
  "Astrology": "ज्योतिष",
  "Fashion": "फैशन",
  "Talent Hunt": "प्रतिभा खोज",
  "Cookery": "खाना बनाना",
  "Talk Show": "टॉक शो",
  "Superhero": "सुपरहीरो",
  "Literary Fiction": "साहित्यिक कथा",
  "Science": "विज्ञान",
  "Scientific": "वैज्ञानिक",
  "Cooking": "खानपान",
  "Food": "भोजन",
  "Travel": "यात्रा",
  "Paintings": "चित्रकला",
  "Design": "डिजाइन",
  "Art": "कला",
  "Nature": "प्रकृति",
  "Arts And Culture": "कला और संस्कृति",
  "Educational Books": "शैक्षणिक पुस्तकें",
  "Young Adult Fiction": "युवा वयस्क कथा",
  "News": "समाचार",
  "Technology": "प्रौद्योगिकी",
  "Open World": "खुली दुनिया",
  "Business": "व्यवसाय",
  "Home Decor": "गृह सजावट",
  "Chat Show": "चैट शो",
  "Edutainment": "शिक्षा के साथ मनोरंजन",
  "Social Awareness": "सामाजिक जागरूकता",
  "Event": "कार्यक्रम",
  "Hindustani Classical Music": "हिंदुस्तानी शास्त्रीय संगीत",
  "Semi-Classical Music": "अर्ध-शास्त्रीय संगीत",
  "Kids": "बच्चे",
  "Science Fiction": "विज्ञान कथा",
  "Celebration": "उत्सव",
  "Casual": "अनौपचारिक",
  "Medical": "चिकित्सा",
  "Yojna": "योजना",
  "Sculptures": "मूर्तिकला",
  "Carbatic Music": "कर्नाटिक संगीत",
  "Digital Literacy": "डिजिटल साक्षरता",
  "Legal And Ethical": "कानूनी और नैतिक",
  "Digital art": "डिजिटल कला",
  "Parenting": "पालन-पोषण",
  "Tracks": "ट्रैक्स",
    Sports: "खेल",
    inviteReferr:"अपने दोस्त को इस अनुभव में शामिल होने के लिए आमंत्रित करें",
    refer_friend:"मित्र को रेफ़र करें",
    Left:"शेष",
    "pbApp":"अपनी प्रोफ़ाइल संपादित करने के लिए Waves PB मोबाइल ऐप का उपयोग करें",
     "Okay, Got it":"ठीक है, समझ गया",
     dislike:"नापसंद",
    Yes: "हाँ",
    No: "नहीं",
    "Referral code is empty": "रेफरल कोड खाली है",
    "Enter a valid referral code": "मान्य रिफ़रल कोड दर्ज करें",
    rentalDescriptionMsg:"www.wavespb.com से सामग्री खरीदना जारी रखें",
    Movies: "फ़िल्में",
    Audio: "ऑडियो",
    Shows: "शो",
    Music: "संगीत",
    All: "सभी",
    Live: "लाइव",
    Documentary: "डॉक्यूमेंट्री",
    "Recently Added": "हाल ही में जोड़ा गया",
    Nostalgia: "पुरानी यादें",
    "News Features": "समाचार विशेषताएं",
    "Waves Originals": "वेव्स ओरिजिनल्स",
    Action: "एक्शन",
    Kids: "बच्चे",
    Romance: "रोमांस",
    Comedy: "कॉमेडी",
    startOver: "फिर से शुरू करें",
    Thriller: "थ्रिलर",
    Devotional: "भक्ति",
    Shorts: "शॉर्ट्स",
    // ALL: "सभी",
    // Movies: "फ़िल्में",
    // Audio: "ऑडियो",
    // Music: "संगीत",
    Scan_using_app_or_mobile_camera1:
      "ऐप या मोबाइल कैमरा का उपयोग करके स्कैन करें",
    Having_Trouble_Logging_in:
      "लॉग इन करने में समस्या है? कृपया www.wavespb.com पर जाएं",
    have_refferel_code: "क्या आपके पास रेफ़रल कोड है?",
    view_more: "और देखें",
    view_less: "कम देखें",
    streaming_from: "से स्ट्रीमिंग",
    RentAvailable: "किराये पर उपलब्ध ₹",
    RentMsg:
      "खरीदारी के दिन से इस सामग्री को देखने के लिए 30 दिनों का किराया शामिल है।",
    "Error!": "त्रुटि!",
    "Success!": "सफलता!",
    availableOnRent: "किराए पर उपलब्ध",
    WatchlistError: "वॉचलिस्ट में जोड़ने में असमर्थ। कृपया पुनः प्रयास करें।",
    WatchlistSuccess: "सफलतापूर्वक वॉचलिस्ट में जोड़ा गया।",
    GamePlay: "मैं कैसे खेलूं?",
    PlayMsg:
      "इस खेल को खेलने के लिए, कृपया Waves PB ऐप का उपयोग करें या www.wavespb.com पर जाएं।",
    Prasar_Bharti_Mobile_App:
      "और प्रसार भारती मोबाइल ऐप पर अपना प्रोफ़ाइल संपादित करें।",
    go_to_account: '"मेरा खाता" पर जाएं',
    RefferalMsg: "जो नंबर पहले से पंजीकृत हैं, उन पर लागू नहीं होता!",
    clear: "साफ़ करें",
    del: "हटाएं",
    subtitle: "उपशीर्षक",
    no_subtitle: "कोई उपशीर्षक उपलब्ध नहीं है",
    space: "स्पेस",
    streaming_start: "स्ट्रीमिंग से",
    midnight: " की आधी रात से शुरू होगी",
    RefferalCode: "रेफरल कोड",
    having_trouble_loggin_in_please_visit_our_website:
      "लॉग इन करने में समस्या हो रही है? कृपया हमारी वेबसाइट पर जाएँ।",
    available_to_rent: "किराये के लिए उपलब्ध",
    log_out: "लॉगआउट करें",
    login_with: "लॉग इन करें",
    Subscribewatch: "देखने के लिए सदस्यता लें",
    SubscribeMsg:
      "इस सामग्री को देखने के लिए, कृपया हमारी वेबसाइट www.wavespb.com पर अपनी खरीदारी पूरी करें।",
    Subscribelisten: "सुनने के लिए सदस्यता लें",
    LoginToWatch: "अभी देखें",
    Watchnow: "अभी देखें",
    or: "या",
    ListenToWatch: "अभी सुनें",
    Listennow: "अभी सुनें",
    Logout: "लॉगआउट",
    get_a_new_code: "नया कोड प्राप्त करें",
    "Help&Support": "ग्राहक सहायता",
    "Privacy-Policy": "गोपनीयता नीति",
    "Term&Conditions": "नियम और शर्तें",
    "About-Us": "हमारे बारे में",
    referal_code: "रेफरल कोड",
    Search_: "खोज",
    "Top-Results": "शीर्ष परिणाम",
    enter_mobile_number: "मोबाइल नंबर दर्ज करें",
    "Popular-Searches": "लोकप्रिय खोजें",
    "Popular-Search": "लोकप्रिय खोज",
    searchplaceholder: "कलाकार, शो, प्लेलिस्ट या सामग्री खोजें",
    sign_in_with_mobile_or_email: "मोबाइल या ईमेल से साइन इन करें",
    enter_your_mobile_number_or_email_to_continue:
      "जारी रखने के लिए अपना मोबाइल नंबर या ईमेल दर्ज करें",
    Home_: "होम",
    done: "हो गया",
    Live_: "टीवी/रेडियो",
    logout: "लॉगआउट",
    Live_Events: "लाइव इवेंट",
    "Delete-Account": "खाता हटाएं",
    Watchlist: "वॉचलिस्ट",
    "My-Profile": "मेरी प्रोफ़ाइल",
    Edit: "संपादित करें",
    Add: "जोड़ें",
    "Edit-Profile": "प्रोफ़ाइल संपादित करें",
    "Add-Profile": "प्रोफ़ाइल जोड़ें",
    "Who’sWatching?": "कौन देख रहा है?",
    "placeholder-profile": "नाम दर्ज करें",
    "Kid’sprofile?": "बच्चे की प्रोफ़ाइल ?",
    "Onlyshowkid-friendlyvideos": "केवल बच्चों के अनुकूल वीडियो दिखाएं",
    "No-Result-Found": "कोई परिणाम नहीं मिला",
    "try-other-keyword": "कृपया किसी भिन्न कीवर्ड के साथ पुनः प्रयास करें",
    "No-data-found": "कोई डेटा नहीं मिला",
    "No-list-found": "कोई सूची नहीं मिली। कृपया देखें और अपने पसंदीदा जोड़ें",
    "Continue-Watching": "देखना जारी रखें",
    Login: "लॉग इन करें",
    Guest: "अतिथि",
    "Login-to-your-account": "अपने खाते में लॉग इन करें",
    "Login-enter-no":
      "विभिन्न प्रकार की फिल्मों, खेलों और श्रृंखलाओं को खोजने के लिए कृपया अपना नंबर दर्ज करें।",
    "Login-enter-no-email":
      "विभिन्न प्रकार की फिल्मों, खेलों और श्रृंखलाओं को खोजने के लिए कृपया अपना ईमेल  दर्ज करें।",
    "Phone-Number": "मोबाइल नंबर",
    "sms-verify":
      "आपको अपना नंबर सत्यापित करने के लिए एक ओ.टी.पी प्राप्त होगा।",
    "email-verify":
      "आपको अपना ईमेल सत्यापित करने के लिए एक ओ.टी.पी प्राप्त होगा।",
    "Send-OTP": "ओटीपी भेजें",
    "confirm-that-agree": "आगे बढ़कर, आप पुष्टि करते हैं कि आप",
    "OTP-Verification": "ओटीपी सत्यापन",
    "verification-code": "वह सत्यापन कोड दर्ज करें जो हमने अभी आपके ",
    "not-receive-code": "कोड प्राप्त नहीं हुआ?",
    Resend: "ओटीपी पुनः भेजें",
    "Having-Issue?": "समस्या हो रही है?",
    "Contact-Us": "हमसे संपर्क करें!",
    "Enter-Phone-Number": "मोबाइल नंबर दर्ज करें",
    "Resend-OTP-in": "ओटीपी पुनः भेजें",
    verify: "जांचें",
    "cofirm-logout": "क्या आप वाकई ऐप से लॉगआउट करना चाहते हैं?",
    welcome_to_dds_world_of_entertainment: "मनोरंजन की लहर",
    Confirm: "पुष्टि करें",
    Cancel: "रद्द करें",
    "Content-Language-Changed": "सामग्री भाषा बदल गई",
    "App-Language-Changed": "ऐप भाषा बदल गई",
    "Change-Language": "भाषा बदलें",
    Previous: "पिछला",
    More: "अधिक",
    audio_quality: "ऑडियो गुणवत्ता",
    speed: "गति",
    Delete: "हटाएं",
    Notification: "सूचना",
    no_noti_found: "सूचना नहीं मिली",
    Artist: "कलाकार",
    just_now: " अभी",
    Skip: "छोड़ें",
    skip_start_browsing: "छोड़ें और ब्राउज़िंग शुरू करें",
    title_activity_purchase_history: "खरीद इतिहास",
    first_fragment_label: "पहला खंड",
    second_fragment_label: "दूसरा खंड",
    Next: "अगला",
    next_episode: "अगला एपिसोड",
    Download: "डाउनलोड",
    transaction_history: "लेनदेन इतिहास",
    no_transaction_history: "कोई लेनदेन इतिहास नहीं",
    str_watch_list: "वॉचलिस्ट",
    my_purchased_video: "मेरे खरीदे गए वीडियो",
    subscribe_: "सब्सक्राइब करें",
    plan_price: "योजना मूल्य",
    remaining_balance: "शेष राशि",
    total_amount: "कुल रकम",
    n_a: "उपलब्ध नहीं (N/A)",
    run_on_physical_device_only: "केवल भौतिक डिवाइस पर चलाएं",
    btn_ok: "ठीक है",
    Live_Events: "लाइव इवेंट" ,
    msg_vpn_error: "वीपीएन त्रुटि",
    note_your_code_will_be_updated_after_5_min:
      "ध्यान दें: आपका कोड 5 मिनट बाद अपडेट हो जाएगा",
    payable_amount: "देय राशि",
    plan_name: "प्लान का नाम",
    didnt_receive_otp: "ओटीपी प्राप्त नहीं हुआ",
    hello_first_fragment: "नमस्ते",
    hello_second_fragment: "खरीद विवरण",
    Coming_soon: "जल्द ही आ रहा है",
    packages: "पैकेज",
    str_support: "समर्थन",
    delete_acct: "खाता हटाएं",
    delete_conform: "क्या आप वाकई अपना खाता हटाना चाहते हैं?",
    delete_profile_success: "प्रोफ़ाइल सफलतापूर्वक हटाई गई",
    Dlt_Accnt_msg: "खाता हटाने की पुष्टि संदेश",
    some_error_occurred_please_try_again:
      "कुछ त्रुटि हुई। कृपया पुनः प्रयास करें।",
    auto: "स्वचालित",
    player_not_ready_try_again: "प्लेयर तैयार नहीं है। कृपया पुनः प्रयास करें।",
    edit_profile: "प्रोफ़ाइल संपादित करें",
    learn_more: "और जानें",
    wishlist: "इच्छा सूची",
    category_name: "श्रेणी का नाम",
    str_my_download: "मेरी डाउनलोड",
    language: "भाषा",
    added_watch_list: "वॉचलिस्ट में जोड़ा गया",
    removed_watch_list: "वॉचलिस्ट से हटाया गया",
    viewall: "सभी देखें",
    msg_video_expired:
      "यह वीडियो एक्सपायर हो चुका है। देखने के लिए कृपया इसे फिर से खरीदें।",
    skip_intro: "इंट्रो छोड़ें",
    settings: "सेटिंग्स",
    video_quality: "वीडियो गुणवत्ता",
    video_speed: "वीडियो गति",
    like: "पसंद",
    unlike: "अनपसंद",
    refund: "वापसी",
    userProfile: "उपयोगकर्ता प्रोफ़ाइल",
    signup_create_new_account: "साइन अप करें: एक नया खाता बनाएं",
    already_acc_login: "पहले से ही एक खाता है? लॉग इन करें",
    accept_terms_and_condition: "नियम और शर्तों को स्वीकार करें",
    new_password: "नया पासवर्ड",
    api_failure_msg: "एपी विफलता",
    remove_profile_pic: "प्रोफ़ाइल तस्वीर निकालें",
    remove: "हटाएं",
    msg_remove_profile_pic: "प्रोफ़ाइल तस्वीर हटाने के लिए पुष्टि संदेश",
    profile_photo: "प्रोफ़ाइल फोटो",
    purchased_video: "खरीदा गया वीडियो",
    upgrade: "अपग्रेड करें",
    msg_send_otp: "ओटीपी भेजें",
    forgot_your_password: "अपना पासवर्ड भूल गए ?",
    msg_search_content: "सामग्री खोजें",
    current_plan: "मौजूदा प्लान",
    more_like_this: "इसी तरह के और",
    download_channel_id: "चैनल आईडी डाउनलोड करें",
    download_video_service_channel: "डाउनलोड वीडियो सेवा चैनल",
    searchLikehotStar: "कोई डाउनलोड नहीं मिला",
    don_t_have_an_account: "खाता नहीं है?",
    delete_video: "वीडियो हटाएं",
    sign_up: "स्वीकार करें",
    having_forget_password: "अपना पासवर्ड याद रखने में परेशानी हो रही है?",
    complete_profile: "प्रोफ़ाइल पूरा करें",
    add_profile: "प्रोफ़ाइल जोड़ें",
    wait_to_play_video: "वीडियो चलाने के लिए प्रतीक्षा करें",
    buy_now_at: "अभी खरीदें",
    upgrade_now_at: "अभी अपग्रेड करें",
    new_text: "नया पाठ",
    rate_app_title: "रेट करें",
    rate_app_message:
      "यदि आप हमारे ऐप का आनंद ले रहे हैं, तो कृपया PlayStore पर इसे रेट करने के लिए कुछ समय निकालें। आपके समर्थन के लिए धन्यवाद",
    rate_btn_pos: "अभी रेट करें",
    rate_btn_neg: "बाद में याद दिलाएं",
    rate_btn_nut: "नहीं धन्यवाद",
    change_name: "नाम बदलें",
    download_options: "डाउनलोड विकल्प",
    low_quality: "निम्न गुणवत्ता",
    medium_quality: "मध्यम गुणवत्ता",
    high_quality: "उच्च गुणवत्ता",
    downloading: "डाउनलोड हो रहा है",
    download_pause: "डाउनलोड रोकें",
    ResuminWating: "जारी रखें",
    downloaded: "डाउनलोड हो चुका",
    download_url_is_not_found: "डाउनलोड URL नहीं मिला",
    download_running: "डाउनलोड चल रहा है",
    no_plan_subscribed: "कोई प्लान सब्सक्राइब नहीं किया",
    privacypolicy: "गोपनीयता नीति",
    termsuse: "सेवा की शर्तें",
    resendotp_in: "ओटीपी पुनः भेजें (लॉग इन के लिए आवश्यक)",
    login_required: "लॉग इन जरूरी",
    sorry_we_couldn_t_complete_your_request_please_try_again_in_a_moment:
      "क्षमा करें, हम आपका अनुरोध पूरा नहीं कर सके। कृपया कुछ देर में पुनः प्रयास करें।",
    trailer: "ट्रेलर",
    no_additional_track: "कोई अतिरिक्त ऑडियो ट्रैक उपलब्ध नहीं है",
    subscribe_now_to_watch: "देखने के लिए अभी सब्सक्राइब करें",
    app_version: "ऐप संस्करण",
    select_all: "सभी चुनें",
    enter_name: "कृपया नाम दर्ज करें",
    choose_avatar: "कृपया अवतार चुनें",
    please_enter_valid_name: "कृपया एक वैध नाम दर्ज करें",
    unselect_all: "सभी का चयन हटाएं",
    enter_mobile_number: "मोबाइल नंबर दर्ज करें",
    title_activity_scan_qr_code: "क्यूआर कोड से साइन इन करें",
    Scan_using_app_or_mobile_camera: "मोबाइल ऐप का उपयोग करके स्कैन करें",
    left: "बचा है",
    plz_enter_name: "कृपया नाम दर्ज करें",
    plz_change_name: "कृपया नाम बदलें",
    plz_choose_avtar: "कृपया अवतार चुनें",
    plz_select_profile: "कृपया प्रोफ़ाइल चुनें",
    who_s_watching: "कौन देख रहा है",
    my_profile: "मेरी प्रोफ़ाइल",
    profiles: "प्रोफाइल",
    // "clear": "हटाएं",
    recent_searches: "हालिया खोजें",
    Recommended_searches: "सुझाई गई खोजें",
    please_enter_your_number_to_discover_a_variety_nof_movies_sports_series:
      "विभिन्न प्रकार की फिल्मों, खेलों और श्रृंखलाओं को खोजने के लिए कृपया अपना नंबर दर्ज करें",
    mobile_number: "मोबाइल नंबर",
    having_issue_contact_us: "समस्या हो रही है? संपर्क करें",
    didn_t_receive_code_resend: "कोड प्राप्त नहीं हुआ? पुनः भेजें",
    enter_the_verification_code_we_just_sent_to_your_number:
      "हमने अभी आपके नंबर पर भेजे गए सत्यापन कोड को दर्ज करें",
    incorrect_otp_entered_please_enter_again:
      "गलत ओटीपी दर्ज किया गया। कृपया पुनः प्रयास करें।",
    app_update_title: "ऐप अपडेट",
    app_update_msg: "ऐप का नया संस्करण अब उपलब्ध है",
    watch_now: "अभी देखें",
    my_list: "मेरी सूची",
    cast_and_crew: "कलाकार और दल",
    similar_to_this: "इसी तरह के",
    similar_channels: "समान चैनल",
    delete_account: "खाता हटाएं",
    delete_account_desc: "क्या आप वाकई प्रोफ़ाइल हटाना चाहते हैं ",
    delete_conform: "प्रोफ़ाइल?",
    log_out_desc: "क्या आप इस खाते से लॉगआउट करना चाहते हैं?",
    pb_on_tv: "प्रसार भारती पर टीवी का उपयोग करें",
    link_device: "डिवाइस से लिंक करें",
    linked_tv: "लिंक्ड टीवी",
    link_with_tv: "क्या आप वाकई टीवी से लिंक करना चाहते हैं?",
    no_result_found: "कोई परिणाम नहीं मिला",
    search_again: "फिर से खोजें",
    no_list_found: "कोई सूची नहीं मिली",
    no_list_found_desc:
      "कोई लिस्टिंग नहीं मिली, कृपया समीक्षा करें और अपनी पसंदीदा जानकारी जोड़ें",
    no_notifications: "कोई सूचनाएं नहीं",
    no_notifications_desc:
      "आपके पास अभी कोई सूचनाएं नहीं हैं। कृपया बाद में वापस आएं",
    notifications: "सूचनाएं",
    registered_devices: "पंजीकृत डिवाइस",
    clear_search_history: "खोज इतिहास साफ़ करें",
    subscription_and_devices: "सदस्यता और डिवाइस",
    subscription: "सदस्यता",
    my_device: "मेरा डिवाइस",
    payment_details: "भुगतान विवरण",
    other_devices: "अन्य  डिवाइस",
    deregister: "अपंजीकृत",
    network_error: "नेटवर्क त्रुटि",
    retry: "पुनः प्रयत्न करें",
    open_setting: "सेटिंग खोलें",
    internal_server: "आंतरिक सर्वर त्रुटि",
    internal_server_error:
      "आपके अनुरोध को संसाधित करते समय सर्वर को एक त्रुटि का सामना करना पड़ा।",
    go_back: "वापस जाएं",
    page_not_found: "पृष्ठ नहीं मिला",
    page_not_found_desc: "आप जिस पेज को देख रहे हैं वह मौजूद नहीं है",
    popular_search: "लोकप्रिय खोज",
    top_results: "शीर्ष परिणाम",
    guest_user: "अतिथि उपयोगकर्ता",
    channels: "चैनल",
    Radio: "रेडियो",
    Begins_on:"यह कार्यक्रम अभी लाइव नहीं है",
    TV: "टीवी",
    favorites: "पसंदीदा",
    content_language: "सामग्री भाषा",
    app_language: "ऐप भाषा",
    change_account: "खाता बदलें",
    move_account: "क्या आप वाकई किसी अन्य प्रोफ़ाइल पर स्विच करना चाहते हैं?",
    update_profile: "आपका प्रोफ़ाइल सफलतापूर्वक अपडेट हो गया",
    added_profile: "आपकी प्रोफ़ाइल सफलतापूर्वक जोड़ दी गई है",
    edit_update: "अपडेट करें",
    cast_crew: "कलाकार और दल",
    episodes: "एपिसोड",
    no_record: "कोई रिकॉर्ड नहीं मिला",
    free_time_up: "नि: शुल्क समय समाप्त!",
    free_create_account:
      "देखना जारी रखने के लिए साइन इन करें या एक निःशुल्क खाता बनाएं।",
    adventure: "साहसिक",
    prasar_bharti: "प्रसार भारती",
    ind_broadcast: "(भारत का सार्वजनिक सेवा प्रसारक)",
    back_to_home: "वापस होम पर",
    oops_page_not_found: "उफ़ पेज नहीं मिला",
    page_looking: "आप जिस पेज को ढूंढ रहे हैं वह मौजूद नहीं है",
    go_to_home: "होमपेज पर जाएं",
    popular_genres: "लोकप्रिय शैलियां",
    watchLanguage: "अपनी भाषा में देखें",
    help_support: "सहायता और समर्थन",
    customer_support: "ग्राहक सहायता",
    contact_number: "संपर्क नंबर",
    email_address: "ईमेल पता",
    share: "साझा करें",
    copy: "कॉपी करें",
    copied: "कॉपी किया गया",
    bharat_ott: "भारत ओटीटी",
    Home_: "होम",
    policy: "वापसी और रद्द करने की नीति",
    terms_condition: "नियम और शर्तें",
    your_account: "आपके पास एक खाता है?",
    continue: "जारी रखें",
    "login_here!": "यहाँ लॉग इन करें!",
    mobile: "मोबाइल",
    password: "पासवर्ड",
    forgot_password: "पासवर्ड भूल गए?",
    sign_up_here: "यहां साइन अप करें!",
    social_media: "सोशल मीडिया के साथ जारी रखें",
    search_data: "सभी खोज डेटा",
    description: "परिचय",
    episode_name: "एपिसोड का नाम",
    episode_num: "एपिसोड नंबर",
    page_looking_might:
      "आप जिस पेज को ढूंढ रहे हैं, उसे हटा दिया गया हो सकता है, उसका नाम बदल दिया गया है या यह अस्थायी रूप से अनुपलब्ध है।",
    Ok: "ठीक है",
    otp_sent: "ओटीपी सफलतापूर्वक भेजा गया",
    success: "सफलता",
    could_not_sent: "ओटीपी नहीं भेजा जा सका",
    error: "त्रुटि",
    resent_otp: "ओटीपी भेजा गया",
    enter_valid_otp: "कृपया वैध ओटीपी दर्ज करें",
    enter_six_digit_valid: "कृपया 6 अंकों का वैध ओटीपी दर्ज करें",
    profile_creation: "प्रोफ़ाइल सफलतापूर्वक बनाया गया",
    error_name: "कृपया उपयोगकर्ता नाम जोड़ें",
    "Delete-Profile": "प्रोफ़ाइल हटाएं",
    add_to_watchlist: "वॉचलिस्ट में जोड़ें",
    added_to_watchlist: "वॉचलिस्ट में जोड़ा गया",
    like_it: "इसे पसंद करें",
    not_for_me: "मेरे लिए नहीं",
    "n-number": "नंबर",
    "e-email": "ईमेल",
    "account-subscribe": "अभी सब्सक्राइब करें",
    "account-subscribe-upgrade": "अभी अपग्रेड करें",
    "user-details-text": "उपयोगकर्ता विवरण",
    "acc-username": "उपयोगकर्ता नाम",
    "acc-enterusername": "उपयोगकर्ता नाम दर्ज करें",
    "acc-mobile": "मोबाइल नंबर",
    "acc-entermobile": "मोबाइल नंबर दर्ज करें",
    "acc-email": "ईमेल पता",
    "acc-enteremail": "ईमेल पता दर्ज करें",
    "acc-Gender": "लिंग",
    "acc-Gender1": "पुरुष",
    "acc-Gender2": "महिला",
    "acc-Gender3": "अन्य",
    "acc-dob": "जन्म तिथि",
    "acc-save": "अपडेट करें",
    "my-account": "मेरा खाता",
    "trans-history": "लेन-देन इतिहास ",
    "acc-varified": "सत्यापित",
    "network-error": "नेटवर्क त्रुटि",
    "network-unable":
      "कनेक्ट करने में असमर्थ। कृपया अपने इंटरनेट कनेक्शन की जाँच करें",
    "network-retry": "पुन: प्रयास करें",
    "download-apps": "हमारा ऐप डाउनलोड करें",
    "PB-OTT": "पीबी ओटीटी",
    "copy-right": "कॉपीराइट",
    all_right: "सर्वाधिकार सुरक्षित",
    versions: "संस्करण-",
    "Help-Support": "ग्राहक सहायता",
    "internet-connection": "इंटरनेट कनेक्ट हो गया है",
    "nointernet-connection": "कोई इंटरनेट कनेक्शन नहीं है",
    "Terms-and-Conditions": "नियम और शर्तें",
    "Help-&-Support": "गोपनीयता नीति",
    "unmute-tra": "ट्रेलर को अनम्यूट करें",
    "mute-tra": "ट्रेलर को म्यूट करें",
    favourite_lang: "पसंदीदा में जोड़ें",
    added_lang: "जोड़ा गया",
    "no-notfication": "सूचनाएं नहीं हैं",
    "notfication-dt": "अभी कोई सूचना नहीं है। कृपया बाद में वापस आएं।",
    or: "या",
    and: "&",
    sahmat: "से सहमत हैं|",
    "par-bheje": "पर भेजा है|",
    "watch-lang": "अपनी भाषा में देखें",
    "popular-genre": "लोकप्रिय शैलियाँ",
    subscription_heading: "PB OTT पर सभी सामग्री देखने के लिए सदस्यता लें",
    add: "Add",
    proceed: "आगे बढ़ें",
    proceed_to_pay_btn: "भुगतान के लिए आगे बढ़ें",
    have_promo: "आपके पास प्रोमो कोड है?",
    promo_code: "प्रोमो कोड",
    enter_promo_code: "प्रोमो कोड दर्ज करें",
    apply_code_btn: "प्रोमो लागू करें",
    select_live_channel_radio: "लाइव चैनल और रेडियो चुनें",
    radio_channels: "रेडियो चैनल",
    submit_btn: "सबमिट करें",
    add_channel_radio: "टीवी चैनल और रेडियो चैनल जोड़ें",
    live_tv_channels: "लाइव टीवी चैनल",
    live_radio_channels: "लाइव रेडियो चैनल",
    upgrade_subscription: "सदस्यता अपग्रेड करें",
    you_pay: "आप इसके लिए भुगतान करेंगे",
    rem_amt_curr_plan: "आपके मौजूदा प्लान में शेष राशि",
    payble_amt: "आपके द्वारा देय राशि",
    live_channel: "लाइव चैनल",
    continue_watching: "देखना जारी रखें",
    Apply: "लागू करें",
    Exit: "बाहर निकलें",
    ExitMsg: "क्या आप वाकई ऐप से बाहर निकलना चाहते हैं?",
    "Login to Continue": "जारी रखने के लिए लॉगिन करें",
    LoginContinue:
      "कृपया हमारे ऐप की पूरी पहुंच का आनंद लेने के लिए लॉगिन करें।",
    "Session-Expired": "सत्र समाप्त हो गया",
    "session-desc": "आपकी सत्र समय सीमा समाप्त हो गई है।",
  },
  English: {
    "back-to-login": "You can log out from other devices to log in on your current device.",
    "no_data_found":"No Data Found",
 "Subscribe to watch":"Subscribe to watch",   
"Drama": "Drama",
  "Romance": "Romance",
  "Fantasy": "Fantasy",
  "Contemporary Fiction": "Contemporary Fiction",
  "History": "History",
  "Mystery": "Mystery",
  "Thriller": "Thriller",
  "Horror": "Horror",
  "War": "War",
  "Rom-Com": "Rom-Com",
  "Educational": "Educational",
  "Health": "Health",
  "Biography": "Biography",
  "Musical Drama": "Musical Drama",
  "Music & Dance": "Music & Dance",
  "Dance Drama": "Dance Drama",
  "Music": "Music",
  "Sports": "Sports",
  "Science Fiction": "Science Fiction",
  "Adventure": "Adventure",
  "Animation": "Animation",
  "Literature": "Literature",
  "Arts & Culture": "Arts & Culture",
  "Religious": "Religious",
  "Crime": "Crime",
  "Spiritual": "Spiritual",
  "Detective": "Detective",
  "Mythology": "Mythology",
  "Entertainment": "Entertainment",
  "Historical Fiction": "Historical Fiction",
  "Political": "Political",
  "Classical Music": "Classical Music",
  "Comedy": "Comedy",
  "Satire": "Satire",
  "Humor": "Humor",
  "Autobiography": "Autobiography",
  "Lifestyle": "Lifestyle",
  "Kids & Family": "Kids & Family",
  "Devotional": "Devotional",
  "Nature & Wildlife": "Nature & Wildlife",
  "Travelogue": "Travelogue",
  "Folk Music": "Folk Music",
  "Storytelling": "Storytelling",
  "Dance": "Dance",
  "Survival": "Survival",
   "Recent Live": "Recent Live",  
  "Talk Shows": "Talk Shows",
  "Inspirational": "Inspirational",
  "Reality": "Reality",
  "Action": "Action",
  "Agriculture": "Agriculture",
  "International": "International",
  "Anime": "Anime",
  "Period Drama": "Period Drama",
  "Sci-Fi": "Sci-Fi",
  "Patriotic": "Patriotic",
  "Performing Arts": "Performing Arts",
  "Astrology": "Astrology",
  "Fashion": "Fashion",
  "Talent Hunt": "Talent Hunt",
  "Cookery": "Cookery",
  "Talk Show": "Talk Show",
  "Superhero": "Superhero",
  "Literary Fiction": "Literary Fiction",
  "Science": "Science",
  "Scientific": "Scientific",
  "Cooking": "Cooking",
  "Food": "Food",
  "Carnatic Music": "Carnatic Music",
"Finance": "Finance",
"Hobbies And Crafts": "Hobbies And Crafts",
"Business and Finance": "Business and Finance",
"Industrial design": "Industrial design",
  "Wildlife": "Wildlife",
  "Travel": "Travel",
  "Paintings": "Paintings",
  "Design": "Design",
  "Art": "Art",
  "Nature": "Nature",
  "Arts And Culture": "Arts And Culture",
  "Educational Books": "Educational Books",
  "Young Adult Fiction": "Young Adult Fiction",
  "News": "News",
  "Technology": "Technology",
  "Open World": "Open World",
  "Business": "Business",
  "Home Decor": "Home Decor",
  "Chat Show": "Chat Show",
  "Edutainment": "Edutainment",
  "Social Awareness": "Social Awareness",
  "Event": "Event",
  "Hindustani Classical Music": "Hindustani Classical Music",
  "Semi-Classical Music": "Semi-Classical Music",
  "Kids": "Kids",
  "Celebration": "Celebration",
  "Casual": "Casual",
  "Medical": "Medical",
  "Yojna": "Yojna",
  "Sculptures": "Sculptures",
  "Carbatic Music": "Carbatic Music",
  "Digital Literacy": "Digital Literacy",
  "Legal And Ethical": "Legal And Ethical",
  "Digital art": "Digital Art",
  "Tracks": "Tracks",
  "Parenting": "Parenting",
    Sports: "Sports",
    inviteReferr:"Invite your friend to join the experience",
     refer_friend:"Refer a Friend",
    Left: "Left",
    "pbApp":"Waves PB Mobile app to edit your profile.",
    dislike:"Dislike",
    "Okay, Got it":"Okay, Got it",
    "rentalDescriptionMsg":"Continue purchasing the content from https://www.wavespb.com",
    Yes: "Yes",
    No: "No",
    "Referral code is empty": "Referral code is empty",
    "Enter a valid referral code": "Enter a valid referral code",
    Movies: "Movies",
    Audio: "Audio",
    Shows: "Shows",
    Music: "Music",
    All: "All",
    Begins_on:"This program is not live yet",
    Live: "Live",
    Documentary: "Documentary",
    "Recently Added": "Recently Added",
     Nostalgia: "Nostalgia",
    "News Features": "News Features",
     "Waves Originals": "Waves Originals",
     Action: "Action",
     Kids: "Kids",
     Romance: "Romance",
     Comedy: "Comedy",
     startOver: "Start Over",
     Thriller: "Thriller",
     Devotional: "Devotional",
    Shorts: "Shorts",
    Scan_using_app_or_mobile_camera1: "Scan using app or mobile camera",
    Having_Trouble_Logging_in:
      "Having Trouble Logging in? Please visit www.wavespb.com",
    have_refferel_code: "Have a Referral Code?",
    streaming_from: "Streaming From",
    view_more: "View More",
    view_less: "View Less",
    "Session-Expired": "Session Expired",
    "session-desc": "Your Session has timed out.",
    RentAvailable: "Available to Rent at ₹",
    RentMsg:
      "Rentals include 30 days to watch this content from the day of purchase.",
    "Error!": "Error!",
    "Success!": "Success!",
    WatchlistError: "Unable to add in Watchlist. Please try again.",
    WatchlistSuccess: "Successfully added to Watchlist.",
    GamePlay: "How do I Play?",
    RefferalMsg: "Not applicable to numbers that are already registered!",
    PlayMsg:
      "To play this game, please use the Waves PB app or visit www.wavespb.com",
    "Login to Continue": "Login to Continue",
    SubscribeMsg:
      "To watch this content, please complete your purchase on our website at www.wavespb.com",
    LoginContinue: "Please login to enjoy full access of our app.",
    Prasar_Bharti_Mobile_App:
      "Prasar Bharti Mobile App to edit your profile.",
    go_to_account: 'Go to "My Account" on',
    clear: "Clear",
    HowToPlay: "How to Play?",
    del: "Del",
   Live_Events:  "Live Event",
    RefferalCode: "Referral Code",
    Apply: "Apply",
    space: "space",
    having_trouble_loggin_in_please_visit_our_website:
      "Having trouble logging in? Please visit our website",
    Subscribewatch: "Subscribe To Watch",
    Subscribelisten: "Subscribe To Listen",
    available_to_rent: "Available To Rent",
    login_with: "Login with",
    LoginToWatch: "Watch Now",
    Watchnow: "Watch Now",
    skip_start_browsing: "Skip & Start Browsing",
    ListenToWatch: "Listen Now",
    or: "or",
    done: "Done",
    proceed: "Proceed",
    Listennow: "Listen Now",
    Logout: "Logout",
    "Help&Support": "Help & Support",
    "Privacy-Policy": "Privacy Policy",
    "Term&Conditions": "Terms & Conditions",
    "About-Us": "About Us",
    referal_code: "Referral Code",
    get_a_new_code: "Get a New Code",
    Search_: "Search",
    "Top-Results": "Top Results",
    enter_mobile_number: "Enter your mobile number",
    "Popular-Searches": "Popular Searches",
    "Popular-Search": "Popular Search",
    searchplaceholder: "Search Artist, Shows, Playlists or Content",
    sign_in_with_mobile_or_email: "Sign in with Mobile or Email",
    enter_your_mobile_number_or_email_to_continue:
      "Enter your mobile number or email to continue",
    Home_: "Home",
    Live_: "TV/Radio",
    TV: "TV",
    left: "Left",
    no_additional_track: "No additional audio track available",
    "Delete-Account": "Delete Account",
    Watchlist: "Watchlist",
    "My-Profile": "My Profile",
    Edit: "Edit",
    Add: "Add",
    subtitle: "Subtitle",
    no_subtitle: "No subtitles available",
    streaming_start: "Streaming From",
    midnight: "Midnight",
    "Edit-Profile": "Edit Profile",
    "Add-Profile": "Add Profile",
    "Who’sWatching?": "Who’s Watching ?",
    "placeholder-profile": "Enter Profile Name",
    "Kid’sprofile?": "Kid’s profile ?",
    "Onlyshowkid-friendlyvideos": "Only show kid-friendly videos",
    "No-Result-Found": "No Result Found",
    "No-list-founded": "No list found",
    "try-other-keyword": "Please try again with different keyword",
    "No-data-found": "No data found",
    "No-list-found": "No list found. Please explore and add your favorites",
    "Continue-Watching": "Continue Watching",
    Login: "Login",
    Guest: "Guest",
    "Login-to-your-account": "Login to your account",
    "Login to Continue": "Login to Continue",
    LoginContinue: "Please login to enjoy full access of our app.",
    "Login-enter-no":
      "Please enter your number to discover a variety of movies, sports & series.",
    "Login-enter-no-email":
      "Please enter your email to discover a variety of movies, sports & series.",
    "Phone-Number": "Mobile Number",
    "sms-verify": "You’ll get an OTP to verify your mobile number.",
    "email-verify": "You’ll get an OTP to verify your email address.",
    "Send-OTP": "Send OTP",
    "confirm-that-agree": "By proceeding, you confirm that you agree to the",
    "OTP-Verification": "OTP Verification",
    "verification-code": "Enter the verification code we just sent to your",
    "not-receive-code": "Didn't receive code?",
    Scan_using_app_or_mobile_camera: "Scan Using Mobile App",
    welcome_to_dds_world_of_entertainment: "Entertainment Ki Lehar",
    Resend: "Resend",
    "Having-Issue?": "Having Issue?",
    "Contact-Us": "Contact Us!",
    "Enter-Phone-Number": "Enter Mobile Number",
    "Resend-OTP-in": "Resend OTP in",
    verify: "Verify",
    "cofirm-logout": "Are you sure you want to logout from the app?",
    Confirm: "Confirm",
    logout: "Logout",
    notifications: "Notifications",
    registered_devices: "Registered Devices",
    clear_search_history: "Clear Search History",
    subscription_and_devices: "Subscription & Devices",
    subscription: "Subscription",
    my_device: "My Device",
    Cancel: "Cancel",
    payment_details: "Payment Details",
    other_devices: "Other Devices",
    deregister: "Deregister",
    "Content-Language-Changed": "Content Language Changed",
    "App-Language-Changed": "App Language Changed",
    "Change-Language": "Change Language",
    Previous: "Previous",
    More: "More",
    audio_quality: "Audio Quality",
    speed: "Speed",
    Delete: "Delete",
    Notification: "Notification",
    no_noti_found: "Notification not found",
    Artist: "Artist",
    just_now: "Just now",
    title_activity_purchase_history: "Purchase history",
    first_fragment_label: "First fragment",
    second_fragment_label: "Second fragment",
    Next: "Next",
    next_episode: "Next Episode",
    Download: "Download",
    transaction_history: "Transaction History",
    no_transaction_history: "No transaction history",
    str_watch_list: "Watchlist",
    my_purchased_video: "My purchased videos",
    subscribe_: "Subscribe",
    plan_price: "Plan Price",
    remaining_balance: "Remaining balance",
    total_amount: "Total Amount",
    n_a: "N/A",
    run_on_physical_device_only: "Run on physical device only",
    btn_ok: "OK",
    msg_vpn_error: "VPN Error",
    note_your_code_will_be_updated_after_5_min:
      "Note: Your code will be updated after 5 minutes",
    payable_amount: "Plan name",
    didnt_receive_otp: "Didn't receive code",
    hello_first_fragment: "Hello",
    hello_second_fragment: "Purchase Details",
    coming_soon: "Coming Soon",
    packages: "Packages",
    str_support: "Support",
    delete_acct: "Delete Account",
    delete_conform: "Are you sure you want to delete account?",
    delete_profile_success: "Profile removed successfully",
    Dlt_Accnt_msg: "Delete account confirmation message",
    some_error_occurred_please_try_again:
      "Some error occurred. Please try again.",
    auto: "Auto",
    player_not_ready_try_again: "Player not ready. Please try again.",
    edit_profile: "Edit Profile",
    learn_more: "Learn More",
    wishlist: "Wishlist",
    category_name: "Category",
    str_my_download: "My Downoads",
    language: "Language",
    added_watch_list: "Added to Watchlist",
    removed_watch_list: "Removed from Watchlist",
    viewall: "View All",
    msg_video_expired: "This video is expired. Please buy again to watch.",
    skip_intro: "Skip Intro",
    settings: "Settings",
    video_quality: "Video Quality",
    video_speed: "Video Speed",
    like: "Like",
    unlike: "Unlike",
    refund: "Refund",
    userProfile: "User Profile",
    signup_create_new_account: "Sign up: Create a new account",
    already_acc_login: "Already have an account? Login",
    accept_terms_and_condition: "Accept terms and conditions",
    new_password: "New password",
    api_failure_msg: "Api Failure",
    remove_profile_pic: "Remove profile picture",
    remove: "Remove",
    msg_remove_profile_pic: "Confirmation message for removing profile picture",
    profile_photo: "Profile Photo",
    purchased_video: "Purchased video",
    upgrade: "Upgrade",
    msg_send_otp: "Send OTP",
    forgot_your_password: "Forgot your password ?",
    msg_search_content: "Search content",
    current_plan: "Current Plan",
    more_like_this: "More like this",
    download_channel_id: "Download channel ID",
    download_video_service_channel: "Download video service channel",
    searchLikehotStar: "No download found",
    don_t_have_an_account: "Don't have an account?",
    delete_video: "Delete Video",
    sign_up: "Agree",
    having_forget_password: "Having trouble remembering your password?",
    complete_profile: "Complete profile",
    add_profile: "Add Profile",
    wait_to_play_video: "Wait to play video",
    buy_now_at: "Buy now at",
    upgrade_now_at: "Upgrade now at",
    new_text: "New Text",
    rate_app_title: "Rate",
    rate_app_message:
      "If you're enjoying our app, please take a moment to rate it on the PlayStore. Thanks for your support",
    rate_btn_pos: "Rate Now",
    rate_btn_neg: "Remind me later",
    rate_btn_nut: "No Thanks",
    change_name: "Change name",
    download_options: "Download Options",
    low_quality: "Low quality",
    medium_quality: "Medium quality",
    high_quality: "High quality",
    downloading: "Downloading",
    download_pause: "Pause download",
    downloaded: "Downloaded",
    download_url_is_not_found: "Download URL not found",
    download_running: "Download Running",
    no_plan_subscribed: "No plan subscribed",
    privacypolicy: "Privacy Policy",
    termsuse: "Terms of Service",
    resendotp_in: "Resend OTP (required for login)",
    login_required: "Login required",
    sorry_we_couldn_t_complete_your_request_please_try_again_in_a_moment:
      "Sorry, we couldn't complete your request. Please try again in a moment.",
    trailer: "Trailer",
    subscribe_now_to_watch: "Subscribe now to watch",
    app_version: "App version",
    select_all: "Select all",
    please_enter_valid_name: "Please enter a valid name",
    choose_avatar: "Please choose avatar",
    enter_name: "Please enter name",
    unselect_all: "Unselect all",
    enter_mobile_number: "Enter mobile number",
    title_activity_scan_qr_code: "Sign in with QR Code",
    plz_enter_name: "Please enter name",
    plz_change_name: "Please change name",
    plz_choose_avtar: "Please choose avatar",
    plz_select_profile: "Please select profile",
    who_s_watching: "Who's watching",
    my_profile: "My profile",
    profiles: "Profiles",
    ResuminWating: "Resume",
    clear: "Clear",
    recent_searches: "Recent searches",
    Recommended_searches: "Recommended searches",
    please_enter_your_number_to_discover_a_variety_nof_movies_sports_series:
      "Please enter your number to discover a variety of movies, sports, and series",
    mobile_number: "Mobile Number",
    having_issue_contact_us: "Having trouble? Contact us",
    didn_t_receive_code_resend: "Didn't receive code? Resend",
    enter_the_verification_code_we_just_sent_to_your_number:
      "Enter the verification code we just sent to your number",
    incorrect_otp_entered_please_enter_again:
      "Incorrect OTP entered. Please enter again.",
    app_update_title: "App update",
    app_update_msg: "The new version of the app is now available",
    watch_now: "Watch now",
    my_list: "My list",
    cast_and_crew: "Cast and crew",
    similar_to_this: "Similar to This",
    similar_channels: "Similar Channels",
    delete_account: "Delete Account",
    delete_account_desc: "Are you sure you want to delete ",
    delete_conform: "profile?",
    log_out: "Logout",
    log_out_desc: "Do you want to log out of this account?",
    pb_on_tv: "Use TV on Prasar Bharati",
    link_device: "Link to a device",
    linked_tv: "Linked tv",
    link_with_tv: "Are you sure you want to link to the TV?",
    no_result_found: "No results found",
    search_again: "Search again",
    no_list_found: "No list found",
    no_list_found_desc:
      "No listings found, please review and add your preferred information",
    no_notifications: "No notifications",
    no_notifications_desc:
      "You don't have any notifications yet. Please come back later",
    network_error: "Network Error",
    retry: "Retry",
    open_setting: "Open settings",
    internal_server: "Internal server error",
    availableOnRent: "Available to Rent at",
    internal_server_error:
      "The server encountered an error while processing your request.",
    go_back: "Go back",
    data_not_found: "Data not found",
    page_not_found_desc: "The page you are viewing does not exist",
    popular_search: "Popular Search",
    top_results: "Top results",
    guest_user: "Guest user",
    channels: "Channels",
    Radio: "Radio",
    favorites: "Favorites",
    content_language: "Content Language",
    app_language: "App Language",
    change_account: "Change Profile",
    move_account: "Are you sure you want to switch to another profile?",
    update_profile: "Your profile successfully updated",
    added_profile: "Your profile successfully added",
    edit_update: "Update",
    cast_crew: "Cast & Crew",
    episodes: "Episodes",
    no_record: "No Record Found",
    free_time_up: "Free Time Up!",
    free_create_account:
      "Sign in or create a free account to continue watching.",
    adventure: "Adventure",
    prasar_bharti: "PRASAR BHARTI",
    ind_broadcast: "(INDIA’S PUBLIC SERVICE BROADCASTER)",
    back_to_home: "BACK TO HOME",
    oops_page_not_found: "Oops page not found",
    page_looking: "The page you are looking for does not exist",
    go_to_home: "Go to HomePage",
    popular_genres: "Popular Genres",
    watchLanguage: "Watch In Your Language",
    help_support: "Help & Support",
    customer_support: "Customer Support",
    contact_number: "Contact Number",
    email_address: "Email Address",
    share: "Share",
    copy: "Copy",
    copied: "Copied",
    bharat_ott: "Bharat OTT",
    Home_: "Home",
    policy: "Refund & Cancellations Policy",
    terms_condition: "Terms & Conditions",
    your_account: "You have an Account?",
    continue: "Continue",
    "login_here!": "Login here!",

    mobile: "Mobile",
    password: "Password",
    forgot_password: "Forgot password?",
    sign_up_here: "Sign Up here!",
    social_media: "Continue with social media",
    search_data: "All Search Data",
    description: "Description",
    episode_name: "Episode Name",
    episode_num: "Episode No",
    page_looking_might:
      "The page you are looking for might have been removed had its name changed or is temporarily unavailable.",
    Ok: "OK",
    otp_sent: "OTP send successfully",
    success: "Success",
    could_not_sent: "Could not sent OTP",
    error: "Error",
    resent_otp: "OTP send successfully",
    enter_valid_otp: "Please enter valid OTP",
    enter_six_digit_valid: "Please enter 6 digit valid OTP",
    profile_creation: "Profile Created Successfully",
    error_name: "Please enter profile name",
    "Delete-Profile": "Delete Profile",
    add_to_watchlist: "Add to watchlist",
    added_to_watchlist: "Added to watchlist",
    like_it: "Like It",
    not_for_me: "Not for me",
    "n-number": "number",
    "e-email": "Email",
    "account-subscribe": "Subscribe Now",
    "account-subscribe-upgrade": "Upgrade Now",
    "user-details-text": "User Details",
    "acc-username": "Username",
    "acc-enterusername": "Enter User Name",
    "acc-mobile": "Mobile Number",
    "acc-entermobile": "Enter Mobile Number",
    "acc-email": "Email Address",
    "acc-enteremail": "Enter Email Address",
    "acc-Gender": "Gender",
    "acc-Gender1": "Male",
    "acc-Gender2": "Female",
    "acc-Gender3": "Others",
    "acc-dob": "Date of Birth",
    "acc-save": "Save Details",
    "my-account": "My Account",
    "trans-history": "Transaction History",
    "acc-varified": "Verified",
    "network-error": "Network error",
    "network-unable":
      "Unable to connect. Please check your internet connection",
    "network-retry": "Retry",
    "download-apps": "Download Our App",
    "PB-OTT": "PB OTT",
    "copy-right": "Copyright",
    all_right: "All Rights Reserved.",
    versions: "Version-",
    "Help-Support": "Help Support",
    "internet-connection": "Internet Connected",
    "nointernet-connection": "No Internet Connection",
    "Terms-and-Conditions": "Terms and Conditions",
    "Help-&-Support": "Help & Support",
    "unmute-tra": "Unmute Trailer",
    "mute-tra": "Mute Trailer",
    favourite_lang: "Add to favourite",
    added_lang: "Added",
    "no-notfication": "No Notification",
    "notfication-dt": "You have no notifications yet. Please come back later.",
    or: "or",
    and: "&",
    sahmat: "",
    "par-bheje": " ",
    "server-error": "Internal Server Error",
    "server-error-msg":
      "There was a serval error while processing your request.",
    "server-retry": "Go to Homepage",
    "watch-lang": "Watch In Your language",
    "popular-genre": "Popular Genres",
    subscription_heading: "Subscribe to watch all content on PB OTT",
    add: "Add",
    proceed_to_pay_btn: "Proceed to Pay",
    have_promo: "Have a promo code?",
    promo_code: "Promo Code",
    enter_promo_code: "Enter Promo Code",
    apply_code_btn: "Apply Code",
    select_live_channel_radio: "Select Live Channel & Radio",
    radio_channels: "Radio Channels",
    submit_btn: "Submit",
    add_channel_radio: "Add TV Channel & Radio",
    live_tv_channels: "Live TV Channels",
    live_radio_channels: "Live Radio Channels",
    upgrade_subscription: "Upgrade Subscription",
    you_pay: "You Pay",
    rem_amt_curr_plan: "Remaining amount in your current plan",
    payble_amt: "Amount Payable",
    live_channel: "Live Channel",
    continue_watching: "Continue Watching",
    Exit: "Exit",
    ExitMsg: "Are you sure you want to Exit from the app?",
  },
  Telugu: {
    "no_data_found":"డేటా ఏదీ కనుగొనబడలేదు",
    "Subscribe to watch":"ఇప్పుడే చూడటానికి సభ్యత్వాన్ని పొందండి",
    "Drama": "నాటకం",
  "Romance": "ప్రేమకథ",
  "Fantasy": "ఫాంటసీ",
  "Contemporary Fiction": "ఆధునిక కథాసాహిత్యం",
  "History": "చరిత్ర",
  "Mystery": "రహస్య కథ",
  "Thriller": "ఉత్కంఠభరిత కథ",
  "Horror": "భయానక కథ",
  "Educational": "విద్యా సంబంధిత",
  "Health": "ఆరోగ్యం",
  "Carnatic Music": "కర్ణాటక సంగీతం",
"Finance": "ఆర్థిక",
"Hobbies And Crafts": "అభిరుచులు & హస్తకళలు",
"Business and Finance": "వ్యాపారం & ఆర్థిక",
"Industrial design": "పారిశ్రామిక రూపకల్పన",
  "Wildlife": "వన్యప్రాణి",
  "Biography": "జీవిత చరిత్ర",
  "Musical Drama": "సంగీత నాటకం",
  "Music & Dance": "సంగీతం మరియు నృత్యం",
  "Dance Drama": "నృత్య నాటకం",
  "Music": "సంగీతం",
   "Recent Live": "ఇತ್ತೀಚಿನ ಲೈವ್",
  "Sports": "క్రీడలు",
  "Adventure": "సాహసం",
  "Animation": "యానిమేషన్",
  "Literature": "సాహిత్యం",
  "Arts & Culture": "కళలు మరియు సంస్కృతి",
  "Religious": "మత సంబంధిత",
  "Crime": "నేరం",
  "Spiritual": "ఆధ్యాత్మిక",
  "Detective": "డిటెక్టివ్ కథ",
  "Mythology": "పౌరాణిక కథలు",
  "Entertainment": "వినోదం",
  "Historical Fiction": "చారిత్రక కథ",
  "Political": "రాజకీయ",
  "Classical Music": "శాస్త్రీయ సంగీతం",
  "Comedy": "హాస్యం",
  "Satire": "వ్యంగ్యం",
  "Humor": "హాస్యరసం",
  "Autobiography": "ఆత్మకథ",
  "Lifestyle": "జీవనశైలి",
  "Kids & Family": "పిల్లలు మరియు కుటుంబం",
  "Devotional": "భక్తి సంబంధిత",
  "Nature & Wildlife": "ప్రకృతి మరియు వన్యప్రాణులు",
  "Travelogue": "ప్రయాణకథనం",
  "Folk Music": "జానపద సంగీతం",
  "Storytelling": "కథా విన్యాసం",
  "Dance": "నృత్యం",
  "Talk Shows": "టాక్ షోలు",
  "Inspirational": "ప్రేరణాత్మక",
  "Reality": "రియాలిటీ",
  "Action": "యాక్షన్",
  "Agriculture": "వ్యవసాయం",
  "International": "అంతర్జాతీయ",
  "Survival": "సర్వైవల్",
  "Anime": "యానిమే",
  "Science Fiction": "సైన్స్ ఫిక్షన్",
  "War": "యుద్ధం",
  "Rom-Com": "రామ్-కామ్",
  "Period Drama": "చారిత్రక నాటకం",
  "Sci-Fi": "వైజ్ఞానిక కథలు",
  "Patriotic": "దేశభక్తి",
  "Performing Arts": "ప్రదర్శనా కళలు",
  "Astrology": "జ్యోతిష్యం",
  "Fashion": "ఫ్యాషన్",
  "Talent Hunt": "ప్రతిభా అన్వేషణ",
  "Cookery": "వంట",
  "Talk Show": "టాక్ షో",
  "Superhero": "సూపర్ హీరో",
  "Literary Fiction": "సాహిత్య కథాసాహిత్యం",
  "Science": "విజ్ఞానం",
  "Scientific": "శాస్త్రీయ",
  "Cooking": "వంటకం",
  "Food": "ఆహారం",
  "Travel": "ప్రయాణం",
  "Paintings": "చిత్రాలు",
  "Design": "రూపకల్పన",
  "Art": "కళ",
  "Nature": "ప్రకృతి",
  "Arts And Culture": "కళలు మరియు సంస్కృతి",
  "Educational Books": "విద్యా పుస్తకాలు",
  "Young Adult Fiction": "యువ కథాసాహిత్యం",
  "News": "వార్తలు",
  "Technology": "సాంకేతికత",
  "Open World": "ఓపెన్ వరల్డ్",
  "Business": "వ్యాపారం",
  "Home Decor": "ఇంటి అలంకరణ",
  "Chat Show": "చాట్ షో",
  "Edutainment": "విద్యా వినోదం",
  "Social Awareness": "సామాజిక అవగాహన",
  "Event": "కార్యక్రమం",
  "Hindustani Classical Music": "హిందుస్తానీ శాస్త్రీయ సంగీతం",
  "Semi-Classical Music": "ఉపశాస్త్రీయ సంగీతం",
  "Kids": "పిల్లలు",
  "Celebration": "ఉత్సవం",
  "Casual": "సాధారణ",
  "Medical": "వైద్య",
  "Yojna": "యోజన",
  "Sculptures": "శిల్పాలు",
  "Carbatic Music": "కర్ణాటక సంగీతం",
  "Digital Literacy": "డిజిటల్ అక్షరాస్యత",
  "Legal And Ethical": "చట్టపరమైన మరియు నైతిక",
  "Digital art": "డిజిటల్ కళ",
  "Tracks": "ట్రాక్స్",
  "Parenting": "పేరెంటింగ్",
    Sports:"క్రీడలు",
        inviteReferr:"మీ స్నేహితుడిని ఈ అనుభవంలో చేరమని ఆహ్వానించండి",
     refer_friend:"మిత్రుడిని సూచించండి",
    Left:"మిగిలింది",
    "pbApp":"మీ ప్రొఫైల్‌ను సవరించేందుకు Waves PB మొబైల్ యాప్ వాడండి",
    dislike:"నచ్చలేదు",
    Begins_on:"ఈ కార్యక్రమం ఇంకా లైవ్ లోకి రాలేదు",
    rentalDescriptionMsg:"www.wavespb.com నుండి కంటెంట్ కొనడం కొనసాగించండి",
     "Okay, Got it":"సరి, అర్థమైంది",
    Yes: "అవును",
    No: "కాదు",
    "Referral code is empty": "రిఫరల్ కోడ్ ఖాళీగా ఉంది",
    "Enter a valid referral code": "సరైన రెఫరల్ కోడ్ నమోదు చేయండి",
    Movies: "సినిమాలు",
    Audio: "ఆడియో",
    Shows: "షోలు",
    Music: "సంగీతం",
    All: "అన్ని",
    Live: "లైవ్",
    Documentary: "డాక్యుమెంటరీ",
    "Recently Added": "ఇటీవల చేర్చబడింది",
    Nostalgia: "స్మృతులు",
    "News Features": "సమాచార విశేషాలు",
    "Waves Originals": "వేవ్స్ ఒరిజినల్స్",
    Action: "యాక్షన్",
    Kids: "పిల్లలు",
    Romance: "రొమాన్స్",
    Comedy: "హాస్యం",
    startOver: "మళ్లీ ప్రారంభించండి",
    Thriller: "థ్రిల్లర్",
    Live_Events: "లైవ్ ఈవెంట్",
    Devotional: "భక్తి",
    Shorts: "చిన్న చిత్రాలు",
    Scan_using_app_or_mobile_camera1:
      "యాప్ లేదా మొబైల్ కెమెరాను ఉపయోగించి స్కాన్ చేయండి",
    Having_Trouble_Logging_in:
      "లాగిన్ చేయడంలో సమస్య ఉందా? దయచేసి www.wavespb.com సందర్శించండి",
    have_refferel_code: "మీ దగ్గర రిఫరల్ కోడ్ ఉందా?",
    view_more: "మరిన్ని చూడండి",
    view_less: "తక్కువ చూడండి",
    streaming_from: "నుంచి ప్రసారం అవుతోంది",
    availableOnRent: "అద్దెకు అందుబాటులో ఉంది",
    "Session-Expired": "సెషన్ గడువు ముగిసింది",
    "session-desc": "మీ సెషన్ సమయం ముగిసింది.",
    RentAvailable: "₹ కు అద్దెకు అందుబాటులో ఉంది",
    RentMsg:
      "కొనుగోలు చేసిన రోజు నుంచి ఈ కంటెంట్‌ను వీక్షించేందుకు 30 రోజుల అద్దెను కలిగి ఉంటుంది.",
    "Error!": "లోపం!",
    "Success!": "విజయం!",
    streaming_start: "స్ట్రీమింగ్ నుండి",
    midnight: "అర్థరాత్రి నుండి ప్రారంభమవుతుంది",
    WatchlistError:
      "వాచ్‌లిస్టులో జోడించలేకపోయాము. దయచేసి మళ్లీ ప్రయత్నించండి.",
    WatchlistSuccess: "వాచ్‌లిస్టులో విజయవంతంగా జోడించబడింది.",
    GamePlay: "నేను ఎలా ఆడాలి?",
    PlayMsg:
      "ఈ గేమ్ ఆడేందుకు, దయచేసి Waves PB యాప్ ఉపయోగించండి లేదా www.wavespb.com కి వెళ్ళండి.",
    Prasar_Bharti_Mobile_App:
      "మరియు ప్రసార్ భారతి మొబైల్ యాప్‌లో మీ ప్రొఫైల్‌ను మార్చండి.",
    go_to_account: '"నా ఖాతా" కు వెళ్లండి',
    clear: "క్లియర్",
    del: "తొలగించు",
    RefferalCode: "రిఫరల్ కోడ్",
    space: "స్థలం",
    RefferalMsg: "ఇప్పటికే నమోదు అయిన నంబర్లకు వర్తించదు!",
    referal_code: "రిఫరల్ కోడ్",
    Live_Events: "లైవ్ ఈవెంట్",
    Apply: "అప్లై చేయండి",
    having_trouble_loggin_in_please_visit_our_website:
      "లాగిన్ చేయడంలో ఇబ్బంది ఉందా? దయచేసి మా వెబ్సైట్కి వెళ్లండి.",
    Subscribewatch: "వీక్షించడానికి సభ్యత్వం",
    SubscribeMsg:
      "ఈ కంటెంట్‌ను చూడటానికి, దయచేసి మా వెబ్‌సైట్ www.wavespb.com లో మీ కొనుగోలును పూర్తి చేయండి.",
    Subscribelisten: "వినడానికి సభ్యత్వం",
    available_to_rent: "అద్దెకు అందుబాటులో ఉంది",
    login_with: "తో లాగిన్",
    or: "లేదా",
    ResuminWating: "కొనసాగించండి",
    proceed: "ముందుకు పోవండి",
    LoginToWatch: "ఇప్పుడు వీక్షించండి",
    Watchnow: "ఇప్పుడు వీక్షించండి",
    ListenToWatch: "ఇప్పుడు వినండి",
    Listennow: "ఇప్పుడు వినండి",
    get_a_new_code: "కొత్త కోడ్ పొందండి",
    skip_start_browsing: "విడుదల & అనువర్తనం ప్రారంభించు",
    Logout: "లాగౌట్",
    "Help&Support": "సహాయం & మద్దతు",
    "Privacy-Policy": "గోప్యతా విధానం",
    "Term&Conditions": "షరతులు & నిబంధనలు",
    "About-Us": "మేము గురించి",
    done: "పూర్తి",
    Search_: "శోధన",
    "Top-Results": "టాప్ ఫలితాలు",
    enter_mobile_number: "మొబైల్ సంఖ్యను ప్రవేశపెట్టండి",
    "Popular-Searches": "ప్రజాదరణ పొందిన శోధనలు",
    "Popular-Search": "ప్రముఖ శోధనలు",
    searchplaceholder:
      "కళాకారుడు, షోస్, ప్లేలిస్ట్లు లేదా కంటెంట్ కోసం శోధించండి",
    welcome_to_dds_world_of_entertainment: "DDలు వినోద ప్రపంచానికి స్వాగతం",
    sign_in_with_mobile_or_email: "మొబైల్ లేదా ఇమెయిల్ వాడుక సైన్ ఇన్ చేయండి",
    enter_your_mobile_number_or_email_to_continue:
      "ముందుకు పోవడానికి మీ మొబైల్ నంబర్ లేదా ఇమెయిల్ ఎంటర్ చేయండి",
    Home_: "ఇల్లు",
    Live_: "టీవీ/రేడియో",
    left: "ఎడమ",
    "Delete-Account": "ఖాతా తొలగించు",
    Watchlist: "వీక్షణ జాబితా",
    subtitle: "సబ్‌టైటిల్స్",
    no_subtitle: "అందుబాటులో సబ్‌టైటిల్స్ లేవు",
    "My-Profile": "నా ప్రొఫైల్",
    Edit: "సవరించు",
    Add: "జోడించు",
    no_additional_track: "అదనపు ఆడియో ట్రాక్ అందుబాటులో లేదు",
    "Edit-Profile": "ప్రొఫైల్‌ని సవరించండి",
    "Add-Profile": "ప్రొఫైల్ జోడించు",
    "Who’sWatching?": "ఎవరు వీక్షిస్తున్నారు?",
    "placeholder-profile": "ప్రొఫైల్ పేరు ఇవ్వ్రాయండి",
    "Kid’sprofile?": "పిల్లల ప్రొఫైల్?",
    "Onlyshowkid-friendlyvideos": "కేవలం పిల్లలకు అనుకూలమైన వీడియోలు చూపించు",
    "No-Result-Found": "ఫలితాలు దొరకలేదు",
    "try-other-keyword": "ఇంకొక కీవర్డ్ ప్రయత్నించండి",
    "No-data-found": "డేటా దొరకలేదు",
    "No-list-found": "జాబితా దొరకలేదు. దయచేసి మీ ఇష్టాన్ని జోడించు",
    "Continue-Watching": "వీక్షించడాన్ని కొనసాగించు",
    Login: "లాగిన్",
    Guest: "అతిథి",
    "Login-to-your-account": "మీ ఖాతాకు లాగిన్",
    "Login-enter-no":
      "మీ మొబైల్ నంబర్ ను ఇవ్వండి వివిధ సినిమాలు, క్రీడాలు & సీరీస్ కనుగొనేందుకు",
    "Login-enter-no-email":
      "మీ ఇమెయిల్ ను ఇవ్వండి వివిధ సినిమాలు, క్రీడాలు & సీరీస్ కనుగొనేందుకు",
    "Phone-Number": "మొబైల్ నంబర్",
    "sms-verify": "మీ మొబైల్ నంబర్ కు ఒక ఓటిపి వస్తుంది.",
    "email-verify": "మీ ఇమెయిల్ కు ఒక ఓటిపి వస్తుంది.",
    "Send-OTP": "ఓటిపి పంపించు",
    "confirm-that-agree": "మీరు అంగీకరిస్తున్నారు కాబట్టి",
    "OTP-Verification": "ఓటిపి ధృవీకరణ",
    "verification-code": "ధృవీకరణ కోడ్ ను ఇవ్వండి",
    "not-receive-code": "కోడ్ రాలేదు?",
    Resend: "మళ్ళీ పంపించు",
    "Having-Issue?": "సమస్యలు ఉన్నాయా?",
    "Contact-Us": "మాకు సంప్రదించండి!",
    "Enter-Phone-Number": "మొబైల్ నంబర్ ను ఇవ్వండి",
    "Resend-OTP-in": "ఓటిపి మళ్ళీ పంపించు లో",
    verify: "ధృవీకరించు",
    "cofirm-logout": "మీరు యాప్ నుండి లాగ్ అవుట్ కావాలనుకుంటున్నారా?",
    Scan_using_app_or_mobile_camera: "మొబైల్ యాప్‌ని ఉపయోగించి స్కాన్ చేయండి",
    Confirm: "నిర్ధారించు",
    logout: "లాగౌట్",
    notifications: "సూచనలు",
    registered_devices: "నమోదిత పరికరలు",
    clear_search_history: "శోధన చరిత్ర స్పష్టం చేయండి",
    subscription_and_devices: "సభ్యత్వం & పరికరలు",
    subscription: "సభ్యత్వం",
    my_device: "నా పరికర",
    Cancel: "రద్దు",
    payment_details: "చెల్లింపు వివరాలు",
    other_devices: "ఇతర పరికరలు",
    deregister: "నమోదిత రద్దు",
    "Content-Language-Changed": "కంటెంట్ భాష మార్పు",
    "App-Language-Changed": "అప్లికేషన్ భాష మార్పు",
    "Change-Language": "భాష మార్పు",
    Previous: "మునుపటి",
    More: "మరింత",
    audio_quality: "ఆడియో నాణ్యత",
    speed: "వేగం",
    Delete: "తొలగించు",
    Notification: "నోటిఫికేషన్",
    no_noti_found: "సూచన దొరకలేదు",
    Artist: "కళాకారుడు",
    just_now: "ఇప్పుడే",
    title_activity_purchase_history: "కొనుగోళు చరిత్ర",
    first_fragment_label: "మొదటి భాగం",
    second_fragment_label: "రెండవ భాగం",
    Next: "తదుపరి",
    next_episode: "తదుపరి ఎపిసోడ్",
    Download: "డౌన్‌లోడ్ చేయండి",
    transaction_history: "లెక్కల చరిత్ర",
    no_transaction_history: "లెక్కల చరిత్ర దొరకలేదు",
    str_watch_list: "వీక్షించడానికి జాబితా",
    my_purchased_video: "నా కొనుగోళు వీడియోలు",
    subscribe_: "సభ్యత్వం",
    plan_price: "ప్లాన్ ధర",
    remaining_balance: "మిగిలిన బ్యాలెన్స్",
    total_amount: "మొత్తం మొత్తం",
    n_a: "ఏమి లేదు",
    run_on_physical_device_only: "భౌతిక పరికరపై మాత్రమే నడుస్తుంది",
    btn_ok: "సరి",
    msg_vpn_error: "విపిఎన్ లో దొరకలేదు",
    note_your_code_will_be_updated_after_5_min:
      "మీ కోడ్ 5 నిమిషాల తరువాత నవీకరించబడుతుంది",
    payable_amount: "చెల్లింపు మొత్తం",
    didnt_receive_otp: "ఓటిపి రాలేదు",
    hello_first_fragment: "హలో",
    hello_second_fragment: "కొనుగోళు వివరాలు",
    coming_soon: "త్వరలో వస్తుంది",
    packages: "ప్యాకేజీలు",
    str_support: "మద్దతు",
    delete_acct: "ఖాతా తొలగించు",
    delete_conform: "మీ ఖాతాను తొలగించాలని ఖచ్చితంగా ఉన్నారా?",
    delete_profile_success: "ప్రొఫైల్ విజయవంతంగా తొలగించబడింది",
    Dlt_Accnt_msg: "ఖాతా తొలగించు ధృవీకరణ సందేశం",
    some_error_occurred_please_try_again:
      "కొన్ని లోపాలు జరిగాయి. దయచేసి మళ్ళీ ప్రయత్నించండి.",
    auto: "ఆటో",
    player_not_ready_try_again:
      "ప్లేయర్ సిద్ధం కాలేదు. దయచేసి మళ్ళీ ప్రయత్నించండి.",
    edit_profile: "ప్రొఫైల్ సవరించు",
    learn_more: "మరింత తెలుసుకోండి",
    wishlist: "కోరికల జాబితా",
    category_name: "వర్గం",
    str_my_download: "నా డౌన్లోడ్లు",
    language: "భాష",
    added_watch_list: "వాచ్ జాబితాలో చేర్చబడింది",
    removed_watch_list: "వాచ్ జాబితా నుండి తొలగించబడింది",
    viewall: "అన్నింటినీ చూడండి",
    msg_video_expired: "ఈ వీడియో కాలం ముగిసింది. దయచేసి మళ్ళీ కొనండి.",
    skip_intro: "ప్రవేశిక తప్పించు",
    settings: "సెట్టింగ్స్",
    video_quality: "వీడియో నాణ్యత",
    video_speed: "వీడియో వేగం",
    like: "ఇష్టం",
    unlike: "ఇష్టం లేదు",
    refund: "రిఫండ్",
    userProfile: "యూజర్ ప్రొఫైల్",
    signup_create_new_account: "సైనప్: కొత్త ఖాతా సృష్టించండి",
    already_acc_login: "మీరు ఖాతా ఉంది? లోగిన్",
    accept_terms_and_condition: "సంస్కరణ దిశగుణం గృహించండి",
    new_password: "కొత్త పాస్వర్డ్",
    api_failure_msg: "API మరియు సంశోధన సంభవం",
    remove_profile_pic: "ప్రొఫైల్ ఫొటో తొలగించు",
    remove: "తొలగించు",
    msg_remove_profile_pic: "ప్రొఫైల్ ఫొటో తొలగించడం స్వయంచాలంగా నిర్ధారించండి",
    profile_photo: "ప్రొఫైల్ ఫొటో",
    purchased_video: "క్రేదిత వీడియో",
    upgrade: "అప్గ్రేడ్",
    msg_send_otp: "ఓటీపీ పంపండి",
    forgot_your_password: "మీ పాస్వర్డ్ యాదృచ్ఛికంగా ఉందండి?",
    msg_search_content: "సహాయం కోసం సహజంగా చూడండి",
    current_plan: "ప్రస్తుత యోజన",
    more_like_this: "ఇది మరియు మరియు మరియు",
    download_channel_id: "డౌన్లోడ్ చెనల్ ఐ.డి.",
    download_video_service_channel: "డౌన్లోడ్ వీడియో సేవ చెనల్",
    searchLikehotStar: "డౌన్లోడ్ కన్నింగా ఉందండి",
    don_t_have_an_account: "ఖాతా లేదు?",
    delete_video: "వీడియో తొలగించు",
    sign_up: "సైన్ అప్",
    having_forget_password: "మీ పాస్వర్డ్ యాదృచ్ఛికంగా ఉందండి?",
    complete_profile: "పూర్తి ప్రొఫైల్",
    add_profile: "ప్రొఫైల్ చేర్చు",
    wait_to_play_video: "వీడియో ఆడటానికి ఎదురుచూండి",
    buy_now_at: "ఇప్పుడు కొనండి",
    upgrade_now_at: "ఇప్పుడు అప్గ్రేడ్ చేయండి",
    new_text: "కొత్త టెక్స్ట్",
    rate_app_title: "రేట్",
    rate_app_message:
      "మీరు మా యాప్ ను ఆనందిస్తున్నారా? దయచేసి ప్లే స్టోర్ లో రేట్ చేయండి.",
    rate_btn_pos: "ఇప్పుడు రేట్ చేయండి",
    rate_btn_neg: "తరువాత మనవి చేయండి",
    rate_btn_nut: "వద్దు",
    change_name: "పేరు మార్చు",
    download_options: "డౌన్లోడ్ ఎంపికలు",
    low_quality: "తక్కువ నాణ్యత",
    medium_quality: "మధ్యస్థ నాణ్యత",
    high_quality: "ఎక్కువ నాణ్యత",
    downloading: "డౌన్లోడింగ్",
    download_pause: "డౌన్లోడ్ ఆపు",
    downloaded: "డౌన్లోడ్ చేయబడింది",
    download_url_is_not_found: "డౌన్లోడ్ యూఆర్ఎల్ కనుగొనబడలేదు",
    download_running: "డౌన్లోడ్ నడుస్తున్నది",
    no_plan_subscribed: "యోజన సభ్యత్వం లేదు",
    privacypolicy: "ప్రైవసీ పాలసీ",
    termsuse: "టెర్మ్స్ ఆఫ్ యూజ్",
    resendotp_in: "ఓటీపీ మళ్ళీ పంపండి (లోగిన్ కొరకు అవసరం)",
    login_required: "లోగినఅవసరం",
    sorry_we_couldn_t_complete_your_request_please_try_again_in_a_moment:
      "మనవి మీ అభ్యర్థన పూర్తి చేయలేకపోయింది. దయచేసి కొంచెం తరువాత ప్రయత్నించండి.",
    trailer: "ట్రైలర్",
    subscribe_now_to_watch: "ఇప్పుడు సభ్యత్వం చేయండి చూడటానికి",
    app_version: "యాప్ వెర్షన్",
    select_all: "అన్నింటినీ ఎంచుకోండి",
    please_enter_valid_name: "దయచేసి చివరి పేరు ఎంటర్ చేయండి",
    choose_avatar: "దయచేసి అవతార్ ఎంచుకోండి",
    enter_name: "దయచేసి పేరు నమోదు చేయండి",
    unselect_all: "అన్నింటినీ ఎంచుకోని వద్దు",
    enter_mobile_number: "మొబైల్ నంబర్ ఎంటర్ చేయండి",
    title_activity_scan_qr_code: "క్యూఆర్ కోడ్ స్కాన్ చేయండి",
    plz_enter_name: "దయచేసి పేరు ఎంటర్ చేయండి",
    plz_change_name: "దయచేసి పేరు మార్చు",
    plz_choose_avtar: "దయచేసి అవతార్ ఎంచుకోండి",
    plz_select_profile: "దయచేసి ప్రొఫైల్ ఎంచుకోండి",
    who_s_watching: "ఎవరు చూస్తున్నారు?",
    my_profile: "నా ప్రొఫైల్",
    profiles: "ప్రొఫైల్స్",
    clear: "స్పష్టం",
    recent_searches: "ఇటీవల సర్చెస్",
    Recommended_searches: "సిఫారసు సర్చెస్",
    please_enter_your_number_to_discover_a_variety_nof_movies_sports_series:
      "దయచేసి మీ నంబర్ ఎంటర్ చేయండి వివిధ సినిమాలు, క్రీడలు,సీరీస్ కనుగొనటానికి",
    mobile_number: "మొబైల్ నంబర్",
    having_issue_contact_us: "సమస్యలు ఉంటే మాతో సంప్రదించండి",
    didn_t_receive_code_resend: "కోడ్ పొందలేదు? మళ్ళీ పంపండి",
    enter_the_verification_code_we_just_sent_to_your_number:
      "మీ నంబర్ కు మా పంపిన ధృవీకరణ కోడ్ ఎంటర్ చేయండి",
    incorrect_otp_entered_please_enter_again:
      "తప్పుడు ఓటీపీ ఎంటర్ చేయబడింది. దయచేసి మళ్ళీ ఎంటర్ చేయండి.",
    app_update_title: "యాప్ అప్డేట్",
    app_update_msg: "యాప్ యొక్క నూతన వెర్షన్ ఇప్పుడు అందుబాటులో ఉంది",
    watch_now: "ఇప్పుడు చూడండి",
    my_list: "నా జాబితా",
    cast_and_crew: "కాస్ట్ మరియు క్రూ",
    similar_to_this: "ఇది మరియు మరియు మరియు",
    similar_channels: "ఇలాంటి మరిన్ని ఛానెల్‌లు",
    delete_account: "ఖాతా తొలగించు",
    delete_account_desc: "మీ ఖాతాను తొలగించాలని ఖచ్చితంగా ఉన్నారా",
    delete_conform: "ప్రొఫైల్?",
    log_out: "లోగౌట్",
    log_out_desc: "ఈ ఖాతా నుండి లాగౌట్ చేయాలనుకుంటున్నారా?",
    pb_on_tv: "ప్రసార్ భారతి టీవీలో ఉపయోగించండి",
    link_device: "పరికరానికి లింక్ చేయండి",
    linked_tv: "లింక్ చేయబడిన టీవీ",
    link_with_tv: "టీవీతో లింక్ చేయాలనుకుంటున్నారా?",
    no_result_found: "ఫలితాలు దొరకలేదు",
    search_again: "మళ్ళీ శోధించండి",
    no_list_found: "జాబితా దొరకలేదు",
    no_list_found_desc:
      "మీరు కోరుకున్న సమాచారం లేదు, దయచేసి మీ ఇష్టాయిష్టాలను సరిచేయండి",
    no_notifications: "సూచనలు లేవు",
    no_notifications_desc: "మీరు ఇప్పుడు సూచనలు లేవు, తరువాత వచ్చి చూడండి",
    network_error: "నెట్వర్క్ దోషం",
    retry: "మళ్ళీ ప్రయత్నించండి",
    open_setting: "సెట్టింగ్స్ తెరవండి",
    internal_server: "ఇంటర్నల్ సర్వర్ దోషం",
    internal_server_error:
      "సర్వర్ మీ అభ్యర్థనను ప్రాసెస్ చేస్తున్నప్పుడు దోషం ఎదురైంది.",
    go_back: "వెనుకకు వెళ్ళండి",
    data_not_found: "డేటా దొరకలేదు",
    page_not_found_desc: "మీరు చూస్తున్పేజీ లేదు",
    popular_search: "ప్రజాదరణ శోధన",
    top_results: "టాప్ ఫలితాలు",
    guest_user: "అతిథి వినియోగదారు",
    channels: "ఛానళ్లు",
    Radio: "రేడియో",
    TV: "టీవీ",
    favorites: "ఇష్టాయిష్టాలు",
    content_language: "కంటెంట్ భాష",
    app_language: "యాప్ భాష",
    change_account: "ఖాతాను మార్చండి",
    move_account: "మీరు ఇంకొక ఖాతాకు మార్చాలనుకుంటున్నారా?",
    update_profile: "మీ ప్రొఫైల్ విజయవంతంగా నవీకరించబడింది",
    added_profile: "మీ ప్రొఫైల్ విజయవంతంగా జోడించబడింది",
    edit_update: "నవీకరించండి",
    cast_crew: "కాస్ట్ & క్రూ",
    episodes: "ఎపిసోడ్లు",
    no_record: "రికార్డ్ లేదు",
    free_time_up: "ఉచిత సమయం పూర్తి!",
    free_create_account: "సైన్ ఇన్ లేదా ఉచిత ఖాతా సృష్టించండి కొనసాగించడానికి.",
    adventure: "సాహసం",
    prasar_bharti: "ప్రసార్ భారతి",
    ind_broadcast: "(భారతదేశపు ప్రజా సేవా ప్రసారకర్త)",
    back_to_home: "హోమ్ కు తిరిగి వెళ్ళండి",
    oops_page_not_found: "ఓప్స్ పేజీ లేదు",
    page_looking: "మీరు చూస్తున్న పేజీ లేదు",
    go_to_home: "హోమ్ కు వెళ్ళండి",
    popular_genres: "ప్రజాదరణ జానర్లు",
    watchLanguage: "మీ భాషలో వీక్షిం",
    help_support: "సహాయం మరియు మద్దతు",
    customer_support: "కస్టమర్ సపోర్ట్",
    contact_number: "సంప్రదించండి సంఖ్య",
    email_address: "ఇమెయిల్ చిరునామా",
    share: "పంచుకోండి",
    copy: "నకలు",
    copied: "నకలు చేయబడింది",
    bharat_ott: "భారత్ ఓటీటీ",
    Home_: "హోమ్",
    policy: "రిఫండ్ మరియు రద్దు విధానం",
    terms_condition: "నిబంధనలు మరియు షరతులు",
    your_account: "మీ ఖాతా ఉందా?",
    continue: "కొనసాగించండి",
    "login_here!": "ఇక్కడ లాగిన్ చేయండి!",
    mobile: "మొబైల్",
    password: "పాస్వర్డ్",
    forgot_password: "పాస్వర్డ్ మర్చిపోయారా?",
    sign_up_here: "ఇక్కడ సైన్ అప్ చేయండి!",
    social_media: "సోషల్ మీడియాతో కొనసాగించండి",
    search_data: "అన్ని శోధన డేటా",
    description: "వివరణ",
    episode_name: "ఎపిసోడ్ పేరు",
    episode_num: "ఎపిసోడ్ నంబర్",
    page_looking_might:
      "మీరు చూస్తున్న పేజీ తొలగించబడింది, దాని పేరు మార్చబడింది లేదా తాత్కాలికంగా అందుబాటులో లేదు.",
    Ok: "సరే",
    otp_sent: "OTP సఫలంగా పంపబడింది",
    success: "సఫలం",
    could_not_sent: "OTP పంపలేకపోయింది",
    error: "తప్పులోపం",
    resent_otp: "OTP సఫలంగా పంపబడింది",
    enter_valid_otp: "చెల్లుబాటు OTP ని ప్రవేశపెట్టండి",
    enter_six_digit_valid: "ఆరు అంకెల చెల్లుబాటు OTP ని ప్రవేశపెట్టండి",
    profile_creation: "ప్రొఫైల్ సృష్టించబడింది",
    error_name: "దయచేసి ప్రొఫైల్ పేరుని ప్రవేశపెట్టండి",
    "Delete-Profile": "ప్రొఫైల్ తొలగించండి",
    add_to_watchlist: "వాచ్ లిస్ట్ కి చేర్చండి",
    added_to_watchlist: "వాచ్ లిస్ట్ కి చేర్చబడింది",
    like_it: "ఇది నచ్చింది",
    not_for_me: "నాకు ఇది అవసరం లేదు",
    "n-number": "సంఖ్య",
    "e-email": "ఇమెయిల్",
    "account-subscribe": "సబ్స్క్రైబ్ చేయండి",
    "account-subscribe-upgrade": "అప్గ్రేడ్ చేయండి",
    "user-details-text": "యూజర్ వివరాలు",
    "acc-username": "యూజర్ పేరు",
    "acc-enterusername": "యూజర్ పేరుని ప్రవేశపెట్టండి",
    "acc-mobile": "మొబైల్ సంఖ్య",
    "acc-entermobile": "మొబైల్ సంఖ్యని ప్రవేశపెట్టండి",
    "acc-email": "ఇమెయిల్ చిరునామా",
    "acc-enteremail": "ఇమెయిల్ చిరునామాని ప్రవేశపెట్టండి",
    "acc-Gender": "లింగం",
    "acc-Gender1": "పురుషుడు",
    "acc-Gender2": "స్త్రీ",
    "acc-Gender3": "ఇతరులు",
    "acc-dob": "జన్మధినం",
    "acc-save": "సేవ్ చేయండి",
    "my-account": "మీ ఖాతా",
    "trans-history": "లేని హిస్టరీ",
    "acc-varified": "స్పష్టం చేయబడింది",
    "network-error": "సేవ సంశోధన తప్పు",
    "network-unable":
      "ఇన్టర్నెట్ కనేక్షన్ లేదు. మీ ఇంటర్నెట్ కనేక్షన్ పరిశీలించండి",
    "network-retry": "మొబైల్ పేజీగా జరుగుతుంది",
    "download-apps": "మేము ఆప్ డౌన్లోడ్ చేయండి",
    "PB-OTT": "PB OTT",
    "copy-right": "కొపీరైట్",
    all_right: "సర్వే హక్కులు సంప్రదించినది.",
    versions: "వెర్షన్-",
    "Help-Support": "సహాయం మరియు మద్దతు",
    "internet-connection": "ఇంటర్నెట్ కనేక్షన్",
    "nointernet-connection": "ఇంటర్నెట్ కనేక్షన్ లేదు",
    "Terms-and-Conditions": "సంస్కరణలు మరియు శరటులు",
    "Help-&-Support": "సహాయం & మద్దతు",
    "unmute-tra":
      "ట్రేయిలర్ దొబ్బు మరియు మొబైల్ సంఖ్య మరియు పాస్వర్డ్ ప్రవేశం చేయండి",
    "mute-tra":
      "ట్రేయిలర్ దొబ్బు మరియు మొబైల్ సంఖ్య మరియు పాస్వర్డ్ మొదలు పంపండి",
    favourite_lang: "ప్రియ భాష",
    added_lang: "చేర్చబడింది",
    "no-notfication": "అధికారం లేదు",
    "notfication-dt":
      "మీరు కొన్ని సంబంధిత సందేశాలు లేదు. కొన్ని సమయంలో దొరికి ప్రయత్నంచేయండి.",
    or: "లేదు",
    and: "మరియు",
    sahmat: "",
    "par-bheje": " ",
    "server-error": "సేవ సంశోధన తప్పు",
    "server-error-msg":
      "మీ అభ్యర్థనను ప్రాసెస్ చేస్తున్నప్పుడు సర్వర్ లో దోషం వచ్చింది.",
    "server-retry": "హోమ్ పేజీకి వెళ్లండి",

    "watch-lang": "మీ భాషలో వీక్షించండి",
    "popular-genre": "ప్రజాదరణ పొందిన జాన్రాలు",
    subscription_heading: "PB OTT పై అన్ని కంటెంట్ చూడటానికి సభ్యత్వం పొందండి",
    add: "జోడించు",
    proceed_to_pay_btn: "చెల్లించడానికి వెళ్లండి",
    have_promo: "ప్రోమో కోడ్ ఉందా?",
    promo_code: "ప్రోమో కోడ్",
    enter_promo_code: "ప్రోమో కోడ్ ను అందించండి",
    apply_code_btn: "కోడ్ ను అనువర్తించండి",
    select_live_channel_radio: "లైవ్ ఛానల్ & రేడియోను ఎంచుకోండి",
    radio_channels: "రేడియో ఛానల్స్",
    submit_btn: "సమర్పించండి",
    add_channel_radio: "టీవీ ఛానల్ & రేడియోను జోడించు",
    live_tv_channels: "లైవ్ టీవీ ఛానల్స్",
    live_radio_channels: "లైవ్ రేడియో ఛానల్స్",
    upgrade_subscription: "సభ్యత్వాన్ని అప్గ్రేడ్ చేయండి",
    you_pay: "మీరు చెల్లించాలి",
    rem_amt_curr_plan: "మీ ప్రస్తుత ప్లాన్ లో మిగిలిన మొత్తం",
    payble_amt: "చెల్లించమొత్తం",
    live_channel: "లైవ్ ఛానల్",
    continue_watching: "వీక్షించడాన్ని కొనసాగించండి",
    Exit: "బయటకు వెళ్ళండి",
    ExitMsg: "మీరు నిజంగానే యాప్ నుండి బయటకు వెళ్లాలనుకుంటున్నారా?",
    "Login to Continue": "కొనసాగించేందుకు లాగిన్ చేయండి",
    LoginContinue:
      "దయచేసి మా యాప్ యొక్క పూర్తి యాక్సెస్‌ను అనుభవించడానికి లాగిన్ చేయండి.",
  },
  Punjabi: {
    "no_data_found":"ਕੋਈ ਡਾਟਾ ਨਹੀਂ ਮਿਲਿਆ।",
    "Subscribe to watch":"ਹੁਣੇ ਦੇਖਣ ਲਈ ਗਾਹਕ ਬਣੋ",
 "Drama": "ਨਾਟਕ",
 "Tracks": "ਟ੍ਰੈਕਸ",
  "Romance": "ਰੋਮਾਂਸ",
  "Fantasy": "ਫੈਂਟੇਸੀ",
  "Wildlife": "ਜੰਗਲੀ ਜੀਵਨ",
  "Contemporary Fiction": "ਆਧੁਨਿਕ ਕਾਲਪਨਿਕ ਸਾਹਿਤ",
  "History": "ਇਤਿਹਾਸ",
  "Mystery": "ਰਹੱਸਮਈ ਕਹਾਣੀ",
  "Thriller": "ਥ੍ਰਿਲਰ",
  "Horror": "ਡਰਾਉਣੀ ਕਹਾਣੀ",
  "Educational": "ਸ਼ਿਖਿਆ ਸੰਬੰਧੀ",
  "Health": "ਸਿਹਤ",
   "Recent Live": "ਹਾਲ ਹੀ ਵਿੱਚ ਲਾਈਵ",
  "Biography": "ਜੀਵਨੀ",
  "Survival": "ਸਰਵਾਈਵਲ",
  "Musical Drama": "ਸੰਗੀਤਮਈ ਨਾਟਕ",
  "Music & Dance": "ਸੰਗੀਤ ਅਤੇ ਨਾਚ",
  "Dance Drama": "ਨਾਚ ਨਾਟਕ",
  "Music": "ਸੰਗੀਤ",
  "Sports": "ਖੇਡਾਂ",
  "Adventure": "ਸਾਹਸਿਕ",
  "Animation": "ਐਨੀਮੇਸ਼ਨ",
  "Literature": "ਸਾਹਿਤ",
  "Arts & Culture": "ਕਲਾ ਅਤੇ ਸਭਿਆਚਾਰ",
  "Religious": "ਧਾਰਮਿਕ",
  "Crime": "ਅਪਰਾਧ",
  "Spiritual": "ਆਧਿਆਤਮਿਕ",
  "Detective": "ਜਾਸੂਸੀ",
  "Mythology": "ਪੌਰਾਣਿਕ ਕਹਾਣੀ",
  "Entertainment": "ਮਨੋਰੰਜਨ",
  "Historical Fiction": "ਇਤਿਹਾਸਕ ਕਹਾਣੀ",
  "Political": "ਰਾਜਨੀਤਿਕ",
  "Classical Music": "ਸ਼ਾਸਤਰੀ ਸੰਗੀਤ",
  "Comedy": "ਹਾਸੇ",
  "Satire": "ਵਿਅੰਗ",
  "Carnatic Music": "ਕਰਨਾਟਕ ਸੰਗੀਤ",
"Finance": "ਵਿੱਤ",
"Hobbies And Crafts": "ਸ਼ੌਕ ਅਤੇ ਸ਼ਿਲਪਕਾਰੀ",
"Business and Finance": "ਵਪਾਰ ਅਤੇ ਵਿੱਤ",
"Industrial design": "ਉਦਯੋਗਿਕ ਡਿਜ਼ਾਈਨ",
  "Humor": "ਹਾਸ",
  "Autobiography": "ਆਤਮਕਥਾ",
  "Lifestyle": "ਜੀਵਨ ਸ਼ੈਲੀ",
  "Kids & Family": "ਬੱਚੇ ਅਤੇ ਪਰਿਵਾਰ",
  "Devotional": "ਭਗਤੀ",
  "Nature & Wildlife": "ਕੁਦਰਤ ਅਤੇ ਜੰਗਲੀ ਜੀਵਨ",
  "Travelogue": "ਯਾਤਰਾ ਵਰਣਨ",
  "Folk Music": "ਲੋਕ ਸੰਗੀਤ",
  "Storytelling": "ਕਹਾਣੀ ਸੁਣਾਉਣਾ",
  "Dance": "ਨਾਚ",
  "Talk Shows": "ਗੱਲਬਾਤ ਪ੍ਰੋਗਰਾਮ",
  "Inspirational": "ਪ੍ਰੇਰਣਾਦਾਇਕ",
  "Reality": "ਅਸਲੀਅਤ",
  "Action": "ਐਕਸ਼ਨ",
  "Agriculture": "ਖੇਤੀਬਾੜੀ",
  "International": "ਅੰਤਰਰਾਸ਼ਟਰੀ",
  "Anime": "ਐਨੀਮੇ",
  "War": "જੰਗ",
  "Rom-Com": "ਰੋਮ-ਕੌਮ",
  "Period Drama": "ਇਤਿਹਾਸਕ ਨਾਟਕ",
  "Sci-Fi": "ਵਿਗਿਆਨਕ ਕਲਪਨਾ",
  "Patriotic": "ਦੇਸ਼ਭਕਤੀ",
  "Performing Arts": "ਪ੍ਰਦਰਸ਼ਨ ਕਲਾ",
  "Astrology": "ਜੋਤਿਸ਼",
  "Fashion": "ਫੈਸ਼ਨ",
  "Talent Hunt": "ਪ੍ਰਤਿਭਾ ਖੋਜ",
  "Cookery": "ਪਕਵਾਨ",
  "Talk Show": "ਗੱਲਬਾਤ ਪ੍ਰੋਗਰਾਮ",
  "Superhero": "ਸੁਪਰਹੀਰੋ",
  "Literary Fiction": "ਸਾਹਿਤਕ ਕਲਪਨਾ",
  "Science": "ਵਿਗਿਆਨ",
  "Scientific": "ਵਿਗਿਆਨਕ",
  "Cooking": "ਖਾਣਾ ਬਣਾਉਣਾ",
  "Food": "ਖਾਣਾ",
  "Travel": "ਯਾਤਰਾ",
  "Paintings": "ਚਿੱਤਰਕਾਰੀ",
  "Design": "ਡਿਜ਼ਾਇਨ",
  "Art": "ਕਲਾ",
  "Science Fiction": "ਵਿਗਿਆਨਕ ਕਲਪਨਾ",
  "Nature": "ਕੁਦਰਤ",
  "Arts And Culture": "ਕਲਾ ਅਤੇ ਸਭਿਆਚਾਰ",
  "Educational Books": "ਸ਼ਿਕਸ਼ਾ ਪੁਸਤਕਾਂ",
  "Young Adult Fiction": "ਯੁਵਾ ਕਲਪਨਾ ਸਾਹਿਤ",
  "News": "ਖ਼ਬਰਾਂ",
  "Technology": "ਤਕਨਾਲੋਜੀ",
  "Open World": "ਖੁੱਲ੍ਹੀ ਦੁਨੀਆ",
  "Business": "ਕਾਰੋਬਾਰ",
  "Home Decor": "ਘਰ ਦੀ ਸਜਾਵਟ",
  "Chat Show": "ਚੈਟ ਪ੍ਰੋਗਰਾਮ",
  "Edutainment": "ਸ਼ਿਖਿਆ ਮਨੋਰੰਜਨ",
  "Social Awareness": "ਸਮਾਜਿਕ ਜਾਗਰੂਕਤਾ",
  "Event": "ਇਵੈਂਟ",
  "Hindustani Classical Music": "ਹਿੰਦੁਸਤਾਨੀ ਸ਼ਾਸਤਰੀ ਸੰਗੀਤ",
  "Semi-Classical Music": "ਅਰਧ-ਸ਼ਾਸਤਰੀ ਸੰਗੀਤ",
  "Kids": "ਬੱਚੇ",
  "Celebration": "ਜਸ਼ਨ",
  "Casual": "ਆਮ",
  "Medical": "ਚਿਕਿਤਸਾ",
  "Yojna": "ਯੋਜਨਾ",
  "Sculptures": "ਮੂਰਤੀਆਂ",
  "Carbatic Music": "ਕਰਨਾਟਕ ਸੰਗੀਤ",
  "Digital Literacy": "ਡਿਜ਼ਿਟਲ ਸਾਖਰਤਾ",
  "Legal And Ethical": "ਕਾਨੂੰਨੀ ਅਤੇ ਨੈਤਿਕ",
  "Digital art": "ਡਿਜ਼ਿਟਲ ਕਲਾ",
  "Parenting": "ਮਾਤਾ-ਪਿਤਾ ਬਣਨਾ",
    Sports:"ਖੇਡ",
        inviteReferr:"ਆਪਣੇ ਦੋਸਤ ਨੂੰ ਇਸ ਤਜਰਬੇ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਣ ਲਈ ਬੁਲਾਓ",
     refer_friend:"ਮਿੱਤਰ ਨੂੰ ਰੈਫਰ ਕਰੋ",
     Left:"ਖੋਜੋ",
    "pbApp":"ਆਪਣੀ ਪ੍ਰੋਫਾਈਲ ਸੰਪਾਦਿਤ ਕਰਨ ਲਈ Waves PB ਐਪ ਵਰਤੋ",
    dislike:"ਪਸੰਦ ਨਹੀਂ",
    Begins_on:"ਇਹ ਪ੍ਰੋਗਰਾਮ ਅਜੇ ਤੱਕ ਲਾਈਵ ਨਹੀਂ ਹੈ",
    rentalDescriptionMsg:"www.wavespb.com ਤੋਂ ਸਮੱਗਰੀ ਖਰੀਦਣਾ ਜਾਰੀ ਰੱਖੋ",
     "Okay, Got it":"ਠੀਕ ਹੈ, ਸਮਝ ਆ ਗਿਆ",
    Yes: "ਹਾਂ",
    No: "ਨਹੀਂ",
    "Referral code is empty": "ਰੈਫਰਲ ਕੋਡ ਖਾਲੀ ਹੈ",
    "Enter a valid referral code": "ਇੱਕ ਵੈਧ ਰੈਫਰਲ ਕੋਡ ਦਰਜ ਕਰੋ",
        Movies: "ਫਿਲਮਾਂ",
        Audio: "ਆਡੀਓ",
        Shows: "ਸ਼ੋਅਜ਼",
        Music: "ਸੰਗੀਤ",
        All: "ਸਭ",
        Live: "ਲਾਈਵ",
        Documentary: "ਡੌਕਯੂਮੈਂਟਰੀ",
        "Recently Added": "ਹਾਲ ਹੀ ਵਿੱਚ ਸ਼ਾਮਲ ਕੀਤਾ ਗਿਆ",
        Nostalgia: "ਪੁਰਾਣੀਆਂ ਯਾਦਾਂ",
        "News Features": "ਖ਼ਬਰਾਂ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ",
        "Waves Originals": "ਵੇਵਜ਼ ਓਰਿਜਿਨਲਜ਼",
        Action: "ਐਕਸ਼ਨ",
        Kids: "ਬੱਚੇ",
        Romance: "ਰੋਮਾਂਸ",
        Comedy: "ਕੌਮਡੀ",
        startOver: "ਮੁੜ ਸ਼ੁਰੂ ਕਰੋ",
        Thriller: "ਥ੍ਰਿੱਲਰ",
        Devotional: "ਭਗਤੀ",
        Shorts: "ਛੋਟੀਆਂ ਫਿਲਮਾਂ",
    Scan_using_app_or_mobile_camera1:
      "ਐਪ ਜਾਂ ਮੋਬਾਈਲ ਕੈਮਰੇ ਦੀ ਵਰਤੋਂ ਕਰਕੇ ਸਕੈਨ ਕਰੋ",
    Having_Trouble_Logging_in:
      "ਲਾਗਇਨ ਕਰਨ ਵਿੱਚ ਸਮੱਸਿਆ? ਕਿਰਪਾ ਕਰਕੇ www.wavespb.com ਤੇ ਜਾਓ",
    have_refferel_code: "ਕੀ ਤੁਹਾਡੇ ਕੋਲ ਰੇਫਰਲ ਕੋਡ ਹੈ?",
    view_more: "ਹੋਰ ਵੇਖੋ",
    view_less: "ਘੱਟ ਵੇਖੋ",
    streaming_from: "ਤੋਂ ਸਟ੍ਰੀਮਿੰਗ",
    "Session-Expired": "ਸੈਸ਼ਨ ਸਮਾਪਤ ਹੋ ਗਿਆ",
    "session-desc": "ਤੁਹਾਡੇ ਸੈਸ਼ਨ ਦੀ ਸਮਾਂ ਸੀਮਾ ਖਤਮ ਹੋ ਗਈ ਹੈ।",
    RentAvailable: "₹ ‘ਚ ਕਿਰਾਏ ਲਈ ਉਪਲਬਧ",
    RentMsg: "ਖਰੀਦ ਦੀ ਤਾਰੀਖ ਤੋਂ 30 ਦਿਨਾਂ ਲਈ ਇਹ ਸਮੱਗਰੀ ਦੇਖਣ ਦੀ ਰਿਣਟਲ ਸ਼ਾਮਲ ਹੈ।",
    "Error!": "ਗਲਤੀ!",
    "Success!": "ਸਫਲਤਾ!",
    streaming_start: "ਸਟ੍ਰੀਮਿੰਗ ਤੋਂ",
    midnight: "ਅੱਧੀ ਰਾਤ ਤੋਂ ਸ਼ੁਰੂ ਹੋਵੇਗੀ",
    WatchlistError:
      "ਵਾਚਲਿਸਟ ਵਿੱਚ ਸ਼ਾਮਲ ਨਹੀਂ ਕਰ ਸਕੇ। ਕਿਰਪਾ ਕਰਕੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    WatchlistSuccess: "ਸਫਲਤਾਪੂਰਵਕ ਵਾਚਲਿਸਟ ਵਿੱਚ ਸ਼ਾਮਲ ਕੀਤਾ ਗਿਆ।",
    GamePlay: "ਮੈਂ ਕਿਵੇਂ ਖੇਡ ਸਕਦਾ ਹਾਂ?",
    PlayMsg:
      "ਇਹ ਗੇਮ ਖੇਡਣ ਲਈ, ਕਿਰਪਾ ਕਰਕੇ Waves PB ਐਪ ਦੀ ਵਰਤੋਂ ਕਰੋ ਜਾਂ www.wavespb.com 'ਤੇ ਜਾਓ।",
    "Login to Continue": "ਜਾਰੀ ਰੱਖਣ ਲਈ ਲੌਗਇਨ ਕਰੋ",
    LoginContinue: "ਕਿਰਪਾ ਕਰਕੇ ਸਾਡੀ ਐਪ ਦੀ ਪੂਰੀ ਪਹੁੰਚ ਦਾ ਆਨੰਦ ਲੈਣ ਲਈ ਲੌਗਇਨ ਕਰੋ।",
    Prasar_Bharti_Mobile_App:
      "ਅਤੇ ਪ੍ਰਸਾਰ ਭਾਰਤੀ ਮੋਬਾਈਲ ਐਪ ਤੇ ਆਪਣਾ ਪ੍ਰੋਫਾਈਲ ਸੋਧੋ।",
    go_to_account: '"ਮੇਰਾ ਖਾਤਾ" ਤੇ ਜਾਓ',
    RefferalMsg:
      "ਜੋ ਨੰਬਰ ਪਹਿਲਾਂ ਹੀ ਰਜਿਸਟਰ ਹੋ ਚੁੱਕੇ ਹਨ, ਉਨ੍ਹਾਂ ਲਈ ਲਾਗੂ ਨਹੀਂ ਹੁੰਦਾ!",
    clear: "ਸਾਫ ਕਰੋ",
    ResuminWating: "ਜਾਰੀ ਰੱਖੋ",
    del: "ਮਿਟਾਓ",
    RefferalCode: "ਸੰਕੇਤ ਕੋਡ",
    Apply: "ਲਾਗੂ ਕਰੋ",
    availableOnRent: "ਕਿਰਾਏ 'ਤੇ ਉਪਲਬਧ ਹੈ",
    space: "ਖਾਲੀ ਜਗ੍ਹਾ",
    Live_Events: "ਲਾਈਵ ਇਵੈਂਟ",
    having_trouble_loggin_in_please_visit_our_website:
      "having_trouble_loggin_in_please_visit_our_website",
    Subscribewatch: "ਵੇਖਣ ਲਈ ਸਬਸਕਰਾਈਬ ਕਰੋ",
    SubscribeMsg:
      "ਇਸ ਸਮੱਗਰੀ ਨੂੰ ਦੇਖਣ ਲਈ, ਕਿਰਪਾ ਕਰਕੇ ਸਾਡੀ ਵੈੱਬਸਾਈਟ www.wavespb.com 'ਤੇ ਆਪਣੀ ਖਰੀਦ ਪੂਰੀ ਕਰੋ।",
    Subscribelisten: "ਸੁਣਨ ਲਈ ਸਬਸਕਰਾਈਬ ਕਰੋ",
    available_to_rent: "ਕਿਰਾਏ ਲਈ ਉਪਲਬਧ",
    login_with: "ਨਾਲ ਲਾਗਇਨ ਕਰੋ",
    LoginToWatch: "ਹੁਣ ਵੇਖੋ",
    Watchnow: "ਹੁਣ ਵੇਖੋ",
    ListenToWatch: "ਹੁਣ ਸੁਣੋ",
    Listennow: "ਹੁਣ ਸੁਣੋ",
    Logout: "ਲਾਗਆਉਟ",
    proceed: "सुरुवात करा",
    or: "ਜਾਂ",
    done: "ਹੋ ਗਿਆ",
    "Help&Support": "ਮਦਦ ਅਤੇ ਸਹਾਇਤਾ",
    "Privacy-Policy": "ਪ੍ਰਾਈਵੇਸੀ ਨੀਤੀ",
    "Term&Conditions": "ਸ਼ਰਤਾਂ ਅਤੇ ਹਾਲਤਾਂ",
    referal_code: "ਸੰਕੇਤ ਕੋਡ",
    get_a_new_code: "ਨਵਾਂ ਕੋਡ ਪ੍ਰਾਪਤ ਕਰੋ",
    "About-Us": "ਸਾਡੇ ਬਾਰੇ",
    skip_start_browsing: "ਛੱਡੋ ਅਤੇ ਸਰੀਰ ਰਖੋ",
    Search_: "ਖੋਜ",
    left: "ਖੱਬੇ",
    "Top-Results": "ਸਰਵੋਤਮ ਨਤੀਜੇ",
    subtitle: "ਸਬਟਾਈਟਲ",
    no_subtitle: "ਕੋਈ ਸਬਟਾਈਟਲ ਉਪਲੱਬਧ ਨਹੀਂ ਹੈ",
    "Popular-Searches": "ਲੋਕਪ੍ਰਿਯ ਖੋਜਾਂ",
    "Popular-Search": "ਲੋਕਪ੍ਰਿਯ ਖੋਜ",
    searchplaceholder: "ਕਲਾਕਾਰ, ਸ਼ੋਅ, ਪਲੇਲਿਸਟ ਜਾਂ ਸਮਗਰੀ ਖੋਜੋ",
    sign_in_with_mobile_or_email: "ਮੋਬਾਈਲ ਜਾਂ ਈਮੇਲ ਨਾਲ ਸਾਈਨ ਇਨ ਕਰੋ",
    enter_your_mobile_number_or_email_to_continue:
      "ਜਾਰੀ ਰੱਖਣ ਲਈ ਆਪਣਾ ਮੋਬਾਈਲ ਨੰਬਰ ਜਾਂ ਈਮੇਲ ਦਰਜ ਕਰੋ",
    Home_: "ਘਰ",
    Live_: "ਟੀਵੀ/ਰੇਡੀਓ",
    "Delete-Account": "ਖਾਤਾ ਹਟਾਓ",
    enter_mobile_number: "ਮੋਬਾਈਲ ਨੰਬਰ ਦਾਖਲ ਕਰੋ",
    Watchlist: "ਵੇਖਣ ਦੀ ਸੂਚੀ",
    "My-Profile": "ਮੇਰਾ ਪ੍ਰੋਫਾਈਲ",
    Edit: "ਸੰਪਾਦਨ",
    Add: "ਜੋੜੋ",
    "Edit-Profile": "ਪ੍ਰੋਫਾਈਲ ਦਾ ਸੰਪਾਦਨ ਕਰੋ",
    "Add-Profile": "ਪ੍ਰੋਫਾਈਲ ਜੋੜੋ",
    "Who’sWatching?": "ਕੌਣ ਵੇਖ ਰਿਹਾ ਹੈ?",
    "placeholder-profile": "ਪ੍ਰੋਫਾਈਲ ਦਾ ਨਾਮ ਦਰਜ ਕਰੋ",
    "Kid’sprofile?": "ਬੱਚੇ ਦਾ ਪ੍ਰੋਫਾਈਲ?",
    "Onlyshowkid-friendlyvideos": "ਸਿਰਫ਼ ਬੱਚਿਆਂ ਲਈ ਅਨੁਕੂਲ ਵੀਡੀਓਜ਼ ਦਿਖਾਓ",
    "No-Result-Found": "ਕੋਈ ਨਤੀਜਾ ਨਹੀਂ ਮਿਲਿਆ",
    "try-other-keyword": "ਕ੍ਰਿਪਾ ਕਰਕੇ ਵੱਖਰੇ ਕੀਵਰਡਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "No-data-found": "ਕੋਈ ਡਾਟਾ ਨਹੀਂ ਮਿਲਿਆ",
    "No-list-found": "ਕੋਈ ਸੂਚੀ ਨਹੀਂ ਮਿਲੀ. ਕ੍ਰਿਪਾ ਕਰਕੇ ਆਪਣੇ ਪਸੰਦੀਦਾ ਖੋਜੋ",
    "Continue-Watching": "ਵੇਖਣਾ ਜਾਰੀ ਰੱਖੋ",
    Login: "ਲਾਗਇਨ",
    Guest: "ਮਹਿਮਾਨ",
    "Login-to-your-account": "ਆਪਣੇ ਖਾਤੇ ਵਿੱਚ ਲਾਗਇਨ ਕਰੋ",
    "Login-enter-no":
      "ਆਪਣਾ ਨੰਬਰ ਦਰਜ ਕਰੋ ਤਾਂ ਕਿ ਤੁਸੀਂ ਫਿਲਮਾਂ, ਖੇਡਾਂ ਅਤੇ ਸੀਰੀਜ਼ ਦੀ ਇੱਕ ਵਿਭਿੰਨ ਸ਼੍ਰੇਣੀ ਖੋਜ ਸਕੋ",
    "Login-enter-no-email":
      "ਆਪਣਾ ਈਮੇਲ ਦਰਜ ਕਰੋ ਤਾਂ ਕਿ ਤੁਸੀਂ ਫਿਲਮਾਂ, ਖੇਡਾਂ ਅਤੇ ਸੀਰੀਜ਼ ਦੀ ਇੱਕ ਵਿਭਿੰਨ ਸ਼੍ਰੇਣੀ ਖੋਜ ਸਕੋ",
    "Phone-Number": "ਮੋਬਾਈਲ ਨੰਬਰ",
    "sms-verify":
      "ਤੁਸੀਂ ਆਪਣੇ ਮੋਬਾਈਲ ਨੰਬਰ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਲਈ ਇੱਕ ਓਟੀਪੀ ਪ੍ਰਾਪਤ ਕਰੋਗੇ",
    "email-verify":
      "ਤੁਸੀਂ ਆਪਣੇ ਈਮੇਲ ਪਤੇ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਲਈ ਇੱਕ ਓਟੀਪੀ ਪ੍ਰਾਪਤ ਕਰੋਗੇ",
    Scan_using_app_or_mobile_camera: "ਮੋਬਾਈਲ ਐਪ ਦੀ ਵਰਤੋਂ ਕਰਕੇ ਸਕੈਨ ਕਰੋ",
    welcome_to_dds_world_of_entertainment:
      "DDs ਮਨੋਰੰਜਨ ਦੀ ਦੁਨੀਆ ਵਿੱਚ ਤੁਹਾਡਾ ਸੁਆਗਤ ਹੈ",
    "Send-OTP": "ਓਟੀਪੀ ਭੇਜੋ",
    "confirm-that-agree":
      "ਤੁਸੀਂ ਇਸ ਗੱਲ ਨੂੰ ਸਹਿਮਤ ਹੋ ਕਿ ਤੁਸੀਂ ਸਾਡੀਆਂ ਸ਼ਰਤਾਂ ਅਤੇ ਹਾਲਤਾਂ ਨੂੰ ਸਵੀਕਾਰ ਕਰ ਰਹੇ ਹੋ",
    "OTP-Verification": "ਓਟੀਪੀ ਪੁਸ਼ਟੀ",
    "verification-code":
      "ਪੁਸ਼ਟੀਕੋਡ ਦਰਜ ਕਰੋ ਜੋ ਅਸੀਂ ਤੁਹਾਨੂੰ ਆਪਣੇ ਮੋਬਾਈਲ ਨੰਬਰ ਉੱਤੇ ਭੇਜਿਆ ਹੈ",
    "not-receive-code": "ਕੋਡ ਨਹੀਂ ਮਿਲਿਆ?",
    Resend: "ਦੁਬਾਰਾ ਭੇਜੋ",
    "Having-Issue?": "ਕੋਈ ਮੁਸੀਬਤ ਹੈ?",
    "Contact-Us": "ਸੰਪਰਕ ਕਰੋ ਸਾਡੇ ਨਾਲ!",
    "Enter-Phone-Number": "ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ",
    "Resend-OTP-in": "ਓਟੀਪੀ ਦੁਬਾਰਾ ਭੇਜੋ ਵਿੱਚ",
    verify: "ਪੁਸ਼ਟੀ ਕਰੋ",
    "cofirm-logout":"ਕੀ ਤੁਸੀਂ ਯਕੀਨੀ ਤੌਰ 'ਤੇ ਐਪ ਤੋਂ ਲੌਗਆਊਟ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",

    Confirm: "ਪੁਸ਼ਟੀ ਕਰੋ",
    logout: "ਲਾਗਆਉਟ",
    notifications: "ਸੂਚਨਾਵਾਂ",
    registered_devices: "ਰਜਿਸਟਰਡ ਡਿਵਾਈਸਾਂ",
    clear_search_history: "ਖੋਜ ਇਤਿਹਾਸ ਸਾਫ਼ ਕਰੋ",
    subscription_and_devices: "ਸਬਸਕ੍ਰਿਪਸ਼ਨ ਅਤੇ ਡਿਵਾਈਸਾਂ",
    subscription: "ਸਬਸਕ੍ਰਿਪਸ਼ਨ",
    no_additional_track: "ਕੋਈ ਵਾਧੂ ਆਡੀਓ ਟਰੈਕ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
    my_device: "ਮੇਰਾ ਡਿਵਾਈਸ",
    Cancel: "ਰੱਦ ਕਰੋ",
    payment_details: "ਭੁਗਤਾਨ ਵੇਰਵੇ",
    other_devices: "ਹੋਰ ਡਿਵਾਈਸਾਂ",
    deregister: "ਡੀਰਜਿਸਟਰ ਕਰੋ",
    "Content-Language-Changed": "ਸਮਗਰੀ ਭਾਸ਼ਾ ਬਦਲੀ ਗਈ",
    "App-Language-Changed": "ਐਪ ਭਾਸ਼ਾ ਬਦਲੀ ਗਈ",
    "Change-Language": "ਭਾਸ਼ਾ ਬਦਲੋ",
    Previous: "ਪਿਛਲਾ",
    More: "ਹੋਰ",
    audio_quality: "ਆਡੀਓ ਗੁਣਵੱਤਾ",
    speed: "ਗਤੀ",
    Delete: "ਮਿਟਾਓ",
    Notification: "ਸੂਚਨਾ",
    no_noti_found: "ਸੂਚਨਾ ਨਹੀਂ ਮਿਲੀ",
    Artist: "ਕਲਾਕਾਰ",
    just_now: "ਹੁਣੇ",
    title_activity_purchase_history: "ਖਰੀਦ ਇਤਿਹਾਸ",
    first_fragment_label: "ਪਹਿਲਾ ਟੁਕੜਾ",
    second_fragment_label: "ਦੂਜਾ ਟੁਕੜਾ",
    Next: "ਅਗਲਾ",
    Download: "ਡਾਊਨਲੋਡ",
    next_episode: "ਅਗਲਾ ਐਪੀਸੋਡ",
    transaction_history: "ਲੈਣ-ਦੇਣ ਇਤਿਹਾਸ",
    no_transaction_history: "ਲੈਣ-ਦੇਣ ਇਤਿਹਾਸ ਨਹਨਹੀਂ ਮਿਲੀ",
    str_watch_list: "ਵਾਚ ਸੂਚੀ",
    my_purchased_video: "ਮੇਰੇ ਖਰੀਦੇ ਵੀਡੀਓ",
    subscribe_: "ਸਬਸਕ੍ਰਾਈਬ ਕਰੋ",
    plan_price: "ਯੋਜਨਾ ਕੀਮਤ",
    Live_Events: "ਲਾਈਵ ਇਵੈਂਟ" ,
    remaining_balance: "ਬਾਕੀ ਰਕਮ",
    total_amount: "ਕੁੱਲ ਰਕਮ",
    n_a: "ਨਾ ਉਪਲਬਧ",
    run_on_physical_device_only: "ਸਿਰਫ਼ ਭੌਤਿਕ ਡਿਵਾਈਸ ਉੱਤੇ ਚਲਾਓ",
    btn_ok: "ਠੀਕ ਹੈ",
    msg_vpn_error: "ਵੀਪੀਐਨ ਤਰੁਟੀ",
    note_your_code_will_be_updated_after_5_min:
      "ਨੋਟ: ਤੁਹਾਡਾ ਕੋਡ 5 ਮਿੰਟ ਬਾਅਦ ਅਪਡੇਟ ਹੋ ਜਾਵੇਗਾ",
    payable_amount: "ਯੋਜਨਾ ਨਾਮ",
    didnt_receive_otp: "ਓਟੀਪੀ ਨਹੀਂ ਮਿਲੀ",
    hello_first_fragment: "ਸਤ ਸੀਅਲੋ",
    hello_second_fragment: "ਖਰੀਦ ਵੇਰਵੇ",
    coming_soon: "ਜਲਦ ਆ ਰਿਹਾ ਹੈ",
    packages: "ਪੈਕੇਜਾਂ",
    str_support: "ਸਹਿਯੋਗ",
    delete_acct: "ਖਾਤਾ ਹਟਾਓ",
    delete_conform: "ਕੀ ਤੁਸੀਂ ਖਾਤਾ ਹਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
    delete_profile_success: "ਪ੍ਰੋਫਾਈਲ ਸਫਲਤਾਪੂਰਵਕ ਹਟਾਈ ਗਈ",
    Dlt_Accnt_msg: "ਖਾਤਾ ਹਟਾਉਣ ਦੀ ਪੁਸ਼ਟੀ ਸੁਨੇਹਾ",
    some_error_occurred_please_try_again:
      "ਕੁਝ ਗਲਤੀ ਹੋਈ ਹੈ। ਕੀਰਪਾ ਕਰਕੇ ਫਿਰ ਕੋਸ਼ਿਸ਼ ਕਰੋ。",
    auto: "ਆਟੋ",
    player_not_ready_try_again:
      "ਪਲੇਅਰ ਤਿਆਰ ਨਹੀਂ ਹੈ। ਕੀਰਪਾ ਕਰਕੇ ਫਿਰ ਕੋਸ਼ਿਸ਼ ਕਰੋ。",
    edit_profile: "ਪ੍ਰੋਫਾਈਲ ਸੰਪਾਦਨ ਕਰੋ",
    learn_more: "ਜਿਆਦਾ ਜਾਣੋ",
    wishlist: "ਚਾਹਤ ਦੀ ਸੂਚੀ",
    category_name: "ਸ਼੍ਰੇਣੀ",
    str_my_download: "ਮੇਰੇ ਡਾਊਨਲੋਡ",
    language: "ਭਾਸ਼ਾ",
    added_watch_list: "ਵਾਚਲਿਸਟ ਵਿੱਚ ਸ਼ਾਮਲ ਕੀਤਾ",
    removed_watch_list: "ਵਾਚਲਿਸਟ ਤੋਂ ਹਟਾਇਆ",
    viewall: "ਸਾਰੇ ਵੇਖੋ",
    msg_video_expired: "ਇਹ ਵੀਡੀਓ ਸਮਾਪਤ ਹੋ ਗਈ ਹੈ। ਫਿਰ ਵੇਖਣ ਲਈ ਖਰੀਦੋ。",
    skip_intro: "ਇੰਟਰੋ ਸਕਿੱਪ ਕਰੋ",
    settings: "ਸੈਟਿੰਗਜ਼",
    video_quality: "ਵੀਡੀਓ ਕੁਆਲਿਟੀ",
    video_speed: "ਵੀਡੀਓ ਸਪੀਡ",
    like: "ਪਸੰਦ",
    unlike: "ਨਾਪਸੰਦ",
    refund: "ਵਾਪਸੀ",
    userProfile: "ਯੂਜ਼ਰ ਪ੍ਰੋਫਾਈਲ",
    signup_create_new_account: "ਸਾਈਨ ਅੱਪ: ਨਵਾਂ ਖਾਤਾ ਬਣਾਓ",
    already_acc_login: "ਪਹਿਲਾਂ ਤੋਂ ਖਾਤਾ ਹੈ? ਲਾਗਿਨ ਕਰੋ",
    accept_terms_and_condition: "ਸ਼ਰਤਾਂ ਅਤੇ ਹਾਸਹਿਮਤੀ ਕਬੂਲ ਕਰੋ",
    new_password: "ਨਵਾਂ ਪਾਸਵਰਡ",
    api_failure_msg: "ਏਪੀਆਈ ਅਸਫਲਤਾ ਸੁਨੇਹਾ",
    remove_profile_pic: "ਪ੍ਰੋਫਾਈਲ ਪਿਕ ਹਟਾਓ",
    remove: "ਹਟਾਓ",
    msg_remove_profile_pic: "ਪ੍ਰੋਫਾਈਲ ਪਿਕ ਹਟਾਉਣ ਦੀ ਪੁਸ਼ਟੀ ਸੁਨੇਹਾ",
    profile_photo: "ਪ੍ਰੋਫਾਈਲ ਫੋਟੋ",
    purchased_video: "ਖਰੀਦੀ ਵੀਡੀਓ",
    upgrade: "ਅੱਪਗ੍ਰੇਡ",
    msg_send_otp: "ਓਟੀਪੀ ਭੇਜੋ",
    forgot_your_password: "ਤੁਹਾਡਾ ਪਾਸਵਰਡ ਭੁੱਲ ਗਿਆ ਹੈ?",
    msg_search_content: "ਸਮਗਰੀ ਖੋਜੋ",
    current_plan: "ਮੌਜੂਦਾ ਪਲਾਨ",
    more_like_this: "ਇਸ ਵਰਗੀ ਹੋਰ",
    download_channel_id: "ਡਾਊਨਲੋਡ ਚੈਨਲ ਆਈਡੀ",
    download_video_service_channel: "ਡਾਊਨਲੋਡ ਵੀਡੀਓ ਸੇਵਾ ਚੈਨਲ",
    searchLikehotStar: "ਕੋਈ ਡਾਊਨਲੋਡ ਨਹੀਂ ਮਿਲਿਆ",
    don_t_have_an_account: "ਤੁਹਾਡੇ ਕੋਲ ਖਾਤਾ ਨਹੀਂ ਹੈ?",
    delete_video: "ਵੀਡੀਓ ਹਟਾਓ",
    sign_up: "ਸਹਿਮਤੀ ਕਬੂਲ ਕਰੋ",
    having_forget_password: "ਤੁਹਾਡਾ ਪਾਸਵਰਡ ਭੁੱਲ ਗਿਆ ਹੈ?",
    complete_profile: "ਪ੍ਰੋਫਾਈਲ ਪੂਰਾ ਕਰੋ",
    add_profile: "ਪ੍ਰੋਫਾਈਲ ਸ਼ਾਮਲ ਕਰੋ",
    wait_to_play_video: "ਵੀਡੀਓ ਚਲਾਉਣ ਲਈ ਉਡੀਕਾਓ",
    buy_now_at: "ਹੁਣੇ ਖਰੀਦੋ ਇਸ ਉੱਤੇ",
    upgrade_now_at: "ਹੁਣੇ ਅੱਪਗ੍ਰੇਡ ਕਰੋ ਇਸ ਉੱਤੇ",
    new_text: "ਨਵਾਂ ਟੈਕਸਟ",
    rate_app_title: "ਰੇਟ ਕਰੋ",
    rate_app_message:
      "ਜੇ ਤੁਸੀਂ ਸਆਪਣੇ ਐਪ ਨੂੰ ਪਸੰਦ ਕਰਦੇ ਹੋ, ਤਾਂ ਕੀਰਪਾ ਕਰਕੇ ਪਲੇਸਟੋਰ ਉੱਤੇ ਰੇਟ ਕਰੋ। ਤੁਹਾਡੇ ਸਹਿਯੋਗ ਲਈ ਧੰਨਵਾਦ。",
    rate_btn_pos: "ਹੁਣੇ ਰੇਟ ਕਰੋ",
    rate_btn_neg: "ਬਾਅਦ ਵਿੱਚ ਯਾਦ ਕਰਾਓ",
    rate_btn_nut: "ਨਹੀਂ ਧੰਨਵਾਦ",
    change_name: "ਨਾਂ ਬਦਲੋ",
    download_options: "ਡਾਊਨਲੋਡ ਵਿਕਲਪ",
    low_quality: "ਨੀਵੀਂ ਕੁਆਲਿਟੀ",
    medium_quality: "ਮੱਧ ਕੁਆਲਿਟੀ",
    high_quality: "ਉੱਚ ਕੁਆਲਿਟੀ",
    downloading: "ਡਾਊਨਲੋਡ ਹੋ ਰਿਹਾ ਹੈ",
    download_pause: "ਡਾਊਨਲੋਡ ਰੋਕੋ",
    downloaded: "ਡਾਊਨਲੋਡ ਹੋ ਚੁੱਕਾ ਹੈ",
    download_url_is_not_found: "ਡਾਊਨਲੋਡ ਯੂਆਰਐਲ ਨਹੀਂ ਮਿਲਿਆ",
    download_running: "ਡਾਊਨਲੋਡ ਚਲ ਰਿਹਾ ਹੈ",
    no_plan_subscribed: "ਕੋਈ ਪਲਾਨ ਸਬਸਕ੍ਰਾਈਬ ਨਹੀਂ ਹੈ",
    privacypolicy: "ਪ੍ਰਾਈਵੇਸੀ ਨੀਤੀ",
    termsuse: "ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ",
    resendotp_in: "ਓਟੀਪੀ ਫਿਰ ਭੇਜੋ (ਲਾਗਿਨ ਲਈ ਜ਼ਰੂਰੀ)",
    login_required: "ਲਾਗਿਨ ਜ਼ਰੂਰੀ ਹੈ",
    sorry_we_couldn_t_complete_your_request_please_try_again_in_a_moment:
      "ਸੌਰੀ, ਅਸੀਂ ਤੁਹਾਡੇ ਅਨੁਰੋਧ ਨੂੰ ਪੂਰਾ ਨਹੀਂ ਕਰ ਸਕੇ। ਕੁਝ ਸਮਾਂ ਬਾਅਦ ਫਿਰ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    trailer: "ਟਰੇਲਰ",
    subscribe_now_to_watch: "ਵੇਖਣ ਲਈ ਹੁਣੇ ਸਬਸਕ੍ਰਾਈਬ ਕਰੋ",
    app_version: "ਐਪ ਵਰਜ਼ਨ",
    select_all: "ਸਾਰੇ ਚੁਣੋ",
    please_enter_valid_name: "ਕਿਰਪਾ ਕਰਕੇ ਵੈਧ ਨਾਮ ਦਰਜ ਕਰੋ",
    choose_avatar: "ਕਿਰਪਾ ਕਰਕੇ ਅਵਤਾਰ ਚੁਣੋ",
    enter_name: "ਕਿਰਪਾ ਕਰਕੇ ਨਾਮ ਦਰਜ ਕਰੋ",
    unselect_all: "ਸਾਰੇ ਨਾ ਚੁਣੋ",
    enter_mobile_number: "ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ",
    title_activity_scan_qr_code: "ਕਿਊਆਰ ਕੋਡ ਸਕੈਨ ਕਰੋ",
    plz_enter_name: "ਕਿਰਪਾ ਕਰਕੇ ਨਾਮ ਦਰਜ ਕਰੋ",
    plz_change_name: "ਕਿਰਪਾ ਕਰਕੇ ਨਾਮ ਬਦਲੋ",
    plz_choose_avtar: "ਕਿਰਪਾ ਕਰਕੇ ਅਵਤਾਰ ਚੁਣੋ",
    plz_select_profile: "ਕਿਰਪਾ ਕਰਕੇ ਪ੍ਰੋਫਾਈਲ ਚੁਣੋ",
    who_s_watching: "ਕੌਣ ਵੇਖ ਰਿਹਾ ਹੈ",
    my_profile: "ਮੇਰਾ ਪ੍ਰੋਫਾਈਲ",
    profiles: "ਪ੍ਰੋਫਾਈਲਾਂ",
    clear: "ਸਾਫ਼ ਕਰੋ",
    recent_searches: "ਹਾਲ ਹੀ ਦੀਆਂ ਖੋਜਾਂ",
    Recommended_searches: "ਸਿਫਾਰਸ਼ ਖੋਜਾਂ",
    please_enter_your_number_to_discover_a_variety_nof_movies_sports_series:
      "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਨੰਬਰ ਦਰਜ ਕਰੋ ਤਾਂ ਕਿ ਤੁਸੀਂ ਫਿਲਮਾਂ, ਖੇਡਾਂ ਅਤੇ ਲੜੀਵਾਰਾਂ ਦੀ ਇੱਕ ਵਿਭਿੰਨ ਸ਼੍ਰੇਣੀ ਦੇਖ ਸਕੋ",
    mobile_number: "ਮੋਬਾਈਲ ਨੰਬਰ",
    having_issue_contact_us: "ਕੋਈ ਮੁਸਹੈ ਤਾਂ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
    didn_t_receive_code_resend: "ਕੋਡ ਨਹੀਂ ਮਿਲਿਆ ਤਾਂ ਫਿਰ ਭੇਜੋ",
    enter_the_verification_code_we_just_sent_to_your_number:
      "ਆਪਣੇ ਨੰਬਰ ਤੇ ਅਸੀਂ ਭੇਜੇ ਵੇਰੀਫਿਕੇਸ਼ਨ ਕੋਡ ਦਰਜ ਕਰੋ",
    incorrect_otp_entered_please_enter_again:
      "ਗਲਤ ਓਟੀਪੀ ਦਰਜ ਕੀਤਾ ਗਿਆ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਫਿਰ ਦਰਜ ਕਰੋ",
    app_update_title: "ਐਪ ਅਪਡੇਟ",
    app_update_msg: "ਐਪ ਦਾ ਨਵਾਂ ਵਰਜ਼ਨ ਹੁਣੇ ਉਪਲਬਧ ਹੈ",
    watch_now: "ਹੁਣੇ ਵੇਖੋ",
    my_list: "ਮੇਰੀ ਸੂਚੀ",
    cast_and_crew: "ਕਾਸਟ ਅਤੇ ਕਰੂ",
    similar_to_this: "ਇਸ ਵਰਗਾ",
    similar_channels: "ਮਿਲਦੇ-ਜੁਲਦੇ ਚੈਨਲ",
    delete_account: "ਖਾਤਾ ਹਟਾਓ",
    delete_account_desc: "ਕੀ ਤੁਸੀਂ ਯਕੀਨਨ ਪ੍ਰੋਫਾਈਲ ਮਿਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ ",
    delete_conform: "ਪ੍ਰੋਫਾਈਲ?",
    log_out: "ਲਾਗ ਆਉਟ",
    log_out_desc: "ਕੀ ਤੁਸੀਂ ਇਸ ਖਾਤੇ ਤੋਂ ਲਾਗ ਆਉਟ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
    pb_on_tv: "ਟੀਵੀ ਉੱਤੇ ਪੀਬੀ ਦੀ ਵਰਤੋਂ ਕਰੋ",
    link_device: "ਡਿਵਾਈਸ ਨਾਲ ਲਿੰਕ ਕਰੋ",
    linked_tv: "ਲਿੰਕ ਕੀਤਾ ਟੀਵੀ",
    link_with_tv: "ਕੀ ਤੁਸੀਂ ਟੀਵੀ ਨਾਲ ਲਿੰਕ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
    no_result_found: "ਕੋਈ ਨਤੀਜਾ ਨਹੀਂ ਮਿਲਿਆ",
    search_again: "ਫਿਰ ਖੋਜੋ",
    no_list_found: "ਕੋਈ ਸੂਚੀ ਨਹੀਂ ਮਿਲੀ",
    no_list_found_desc:
      "ਕੋਈ ਸੂਚੀ ਨਹੀਂ ਮਿਲੀ, ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੀ ਪਸੰਦ ਦੀ ਜਾਣਕਾਰਅਤੇ ਇਸ ਨੂੰ ਜੋੜੋ",
    no_notifications: "ਕੋਈ ਸੂਚਨਾ ਨਹੀਂ",
    no_notifications_desc: "ਤੁਸੀਂ ਕੋਈ ਸੂਚਨਾ ਨਹੀਂ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਵਿੱਚ ਆਉਣਾ",
    network_error: "ਨੈੱਟਵਰਕ ਤਰੁਟੀ",
    retry: "ਫਿਰ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    open_setting: "ਸੈਟਿੰਗਜ਼ ਖੋਲੋ",
    internal_server: "ਅੰਦਰੂਨੀ ਸਰਵਰ ਤਰੁਟੀ",
    internal_server_error:
      "ਸਰਵਰ ਨੇ ਆਪਣੇ ਅਨੁਰੋਧ ਨੂੰ ਪ੍ਰੋਸੈਸ ਕਰਨ ਵਿੱਚ ਇੱਕ ਤਰੁਟੀ ਪੈਦਾ ਕੀਤੀ",
    go_back: "ਵਾਪਸ ਜਾਓ",
    data_not_found: "ਡਾਟਾ ਨਹੀਂ ਮਿਲਿਆ",
    page_not_found_desc: "ਤੁਸੀਂ ਜਿਸ ਪੇਜ ਨੂੰ ਦੇਖ ਰਹੇ ਹੋ ਉਹ ਮੌਜੂਦ ਨਹੀਂ ਹੈ",
    popular_search: "ਲੋਕਪ੍ਰਿਯ ਖੋਜਾਂ",
    top_results: "ਸਰਵੋਤਮ ਨਤੀਜੇ",
    guest_user: "ਮਹਿਮਾਨ ਉਪਭੋਗਤਾ",
    channels: "ਚੈਨਲਾਂ",
    Radio: "ਰੇਡੀਓ",
    TV: "ਟੀਵੀ",
    favorites: "ਪਸੰਦੀਦਾ",
    content_language: "ਸਮਗਰੀ ਭਾਸ਼ਾ",
    app_language: "ਐਪ ਭਾਸ਼ਾ",
    change_account: "ਖਾਤਾ ਬਦਲੋ",
    move_account: "ਕੀ ਤੁਸੀਂ ਦੂਜੇ ਖਾਤੇ ਵਿੱਚ ਜਾਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
    update_profile: "ਆਪਣਾ ਪ੍ਰੋਫਾਈਲ ਅਪਡੇਟ ਕੀਤਾ ਗਿਆ",
    added_profile: "ਤੁਹਾਡੀ ਪ੍ਰੋਫਾਈਲ ਸਫਲਤਾਪੂਰਵਕ ਜੋੜੀ ਗਈ ਹੈ",
    edit_update: "ਅਪਡੇਟ ਕਰੋ",
    cast_crew: "ਕਾਸਟ ਅਤੇ ਕਰੂ",
    episodes: "ਐਪੀਸੋਡਜ਼",
    no_record: "ਕੋਈ ਰਿਕਾਰਡ ਨਹੀਂ ਮਿਲਿਆ",
    free_time_up: "ਮੁਫਤ ਸਮਾਂ ਉੱਪਰ!",
    free_create_account: "ਸਾਸਾਈਨ ਇਨ ਜਾਂ ਮੁਫਤ ਖਾਤਾ ਬਣਾਓ ਤਾਂ ਕਿ ਵੇਖਣਾ ਜਾਰੀ ਰੱਖੋ",
    adventure: "ਸਾਹਸ",
    prasar_bharti: "ਪ੍ਰਸਾਰ ਭਾਰਤੀ",
    ind_broadcast: "(ਭਾਰਤ ਦਾ ਪਬਲਿਕ ਸਰਵਿਸ ਬ੍ਰਾਡਕਾਸਟਰ)",
    back_to_home: "ਘਰ ਵਾਪਸ ਜਾਓ",
    oops_page_not_found: "ਓਹੋ! ਪੇਜ ਨਹੀਂ ਮਿਲਿਆ",
    page_looking: "ਤੁਸੀਂ ਜਿਸ ਪੇਜ ਨੂੰ ਦੇਖ ਰਹੇ ਹੋ ਉਹ ਮੌਜੂਦ ਨਹੀਂ ਹੈ",
    go_to_home: "ਘਰ ਵਾਪਸ ਜਾਓ",
    popular_genres: "ਲੋਕਪ੍ਰਿਯ ਵਿਧਾਵਾਂ",
    watchLanguage: "ਆਪਣੀ ਭਾਸ਼ਾ ਵਿੱਚ ਵੇਖੋ",
    help_support: "ਮਦਦ ਅਤੇ ਸਹਾਇਤਾ",
    customer_support: "ਗਾਹਕ ਸਹਾਇਤਾ",
    contact_number: "ਸੰਪਰਕ ਨੰਬਰ",
    email_address: "ਈ-ਮੇਲ ਪਤਾ",
    share: "ਸਾਂਝਾ ਕਰੋ",
    copy: "ਕਾਪੀ ਕਰੋ",
    copied: "ਕਾਪੀ ਕੀਤਾ ਗਿਆ",
    bharat_ott: "ਭਾਰਤ ਓਟੀਟੀ",
    Home_: "ਘਰ",
    policy: "ਵਾਪਸੀ ਅਤੇ ਰੱਦ ਕਰਨ ਦੀ ਨੀਤੀ",
    terms_condition: "ਸ਼ਰਤਾਂ ਅਤੇ ਹਾਲਤਾਂ",
    your_account: "ਤੁਹਾਡਾ ਖਾਤਾ",
    continue: "ਜਾਰੀ ਰੱਖੋ",
    "login_here!": "ਇੱਥੇ ਲਾਗ ਇਨ ਕਰੋ!",
    mobile: "ਮੋਬਾਈਲ",
    password: "ਪਾਸਵਰਡ",
    forgot_password: "ਪਾਸਵਰਡ ਭੁੱਲ ਗਿਆ",
    sign_up_here: "ਇੱਥੇ ਸਾਈਨ ਅੱਪ ਕਰੋ!",
    social_media: "ਸੋਸ਼ਲ ਮੀਡੀਆ ਨਾਲ ਜਾਰੀ ਰੱਖੋ",
    search_data: "ਸਾਰੀ ਖੋਜ ਦਾਤਾ",
    description: "ਵਰਣਨ",
    episode_name: "ਐਪੀਸਨਾਮ",
    episode_num: "ਐਪੀਸੋਡ ਨੰਬਰ",
    page_looking_might:
      "ਤੁਸੀਂ ਜਿਸ ਪੇਜ ਨੂੰ ਦੇਖ ਰਹੇ ਹੋ ਉਹ ਹੋ ਸਕਦਾ ਹੈ ਕਿ ਉਹ ਹਟਾ ਦਿੱਤਾ ਗਿਆ ਹੈ, ਉਸਦਾ ਨਾਮ ਬਦਲ ਦਿੱਤਾ ਗਿਆ ਹੈ ਜਾਂ ਉਹ ਅਸਥਾਈ ਤੌਰ ਤੇ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
    Ok: "ਠੀਕ ਹੈ",
    otp_sent: "ਓਟੀਪੀ ਭੇਜ ਦਿੱਤਾ ਗਿਆ",
    success: "ਸਫਲਤਾ",
    could_not_sent: "ਓਟੀਪੀ ਨਹੀਂ ਭੇਜ ਸਕਿਆ",
    error: "ਤਰੁਟੀ",
    resent_otp: "ਓਟੀਪੀ ਫਿਰ ਭੇਜ ਦਿੱਤਾ ਗਿਆ",
    enter_valid_otp: "ਵੈਧ ਓਟੀਪੀ ਦਰਜ ਕਰੋ",
    enter_six_digit_valid: "ਛੇ ਅੰਕ ਦਾ ਵੈਧ ਓਟੀਪੀ ਦਰਜ ਕਰੋ",
    profile_creation: "ਪ੍ਰੋਫਾਈਲ ਸਿਰਜਣਾ ਸਫਲ ਹੋ ਗਈ",
    error_name: "ਕਿਰਪਾ ਕਰਕੇ ਪ੍ਰੋਫਾਈਲ ਨਾਮ ਦਰਜ ਕਰੋ",
    "Delete-Profile": "ਪ੍ਰੋਫਾਈਲ ਹਟਾਓ",
    add_to_watchlist: "ਵੇਖਣ ਲਈ ਸੂਚੀ ਵਿੱਚ ਜੋੜੋ",
    added_to_watchlist: "ਵੇਖਣ ਲਈ ਸੂਚੀ ਵਿੱਚ ਜੋੜ ਦਿੱਤਾ ਗਿਆ",
    like_it: "ਇਹ ਪਸੰਦ ਹੈ",
    not_for_me: "ਇਹ ਮੇਰੇ ਲਈ ਨਹੀਂ ਹੈ",
    "n-number": "ਨੰਬਰ",
    "e-email": "ਈ-ਮੇਲ",
    "account-subscribe": "ਸਬਸਕ੍ਰਾਈਬ ਕਰੋ",
    "account-subscribe-upgrade": "ਅਪਗ੍ਰੇਡ ਕਰੋ",
    "user-details-text": "ਉਪਭੋਗਤਾ ਵੇਰਵੇ",
    "acc-username": "ਉਪਭੋਗਤਾ ਨਾਮ",
    "acc-enterusername": "ਉਪਭੋਗਤਾ ਨਾਮ ਦਰਜ ਕਰੋ",
    "acc-mobile": "ਮੋਬਾਈਲ ਨੰਬਰ",
    "acc-entermobile": "ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ",
    "acc-email": "ਈ-ਮੇਲ ਪਤਾ",
    "acc-enteremail": "ਈ-ਮੇਲ ਪਤਾ ਦਰਜ ਕਰੋ",
    "acc-Gender": "ਜੇਨਰ",
    "acc-Gender1": "ਪੁਰੁਸ਼",
    "acc-Gender2": "ਮਰੀਜ਼ਾਂ",
    "acc-Gender3": "ਦੀਗਰ",
    "acc-dob": "ਜਨਮ ਤਾਰੀਖ",
    "acc-save": "ਵੱਡੀਆਂ ਦੇਤਾ ਸੁਰੱਖਿਆ ਕਰੋ",
    "my-account": "ਮੇਰਾ ਖਾਤਾ",
    "trans-history": "ਤੱਕ ਪ੍ਰਤੀਤ ਹਿਸਟਰੀ",
    "acc-varified": "ਤਿੱਕ ਪ੍ਰਮਾਣਿਤ",
    "network-error": "ਨੈੱਟਵਰਕ ਤਰੁਟੀ",
    "network-unable":
      "ਇੱਕ ਸੀਮਤ ਨਾਲ ਤੁਹਾਡਾ ਇੰਟਰੈਨੈਟ ਵੰਡ ਨਹੀਂ ਹੋ ਸਕਦਾ ਹੈ, ਕਿਰਪਾ ਕਰਕੇ ਤੁਹਾਡਾ ਇੰਟਰੈਨੈਟ ਚੇਕ ਕਰੋ",
    "network-retry": "ਫਿਰ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "download-apps": "ਆਪਸ ਡਾਉਨਲੋਡ ਕਰੋ",
    "PB-OTT": "ਪੀਬੀ ਓਟੀਟੀ",
    "copy-right": "ਕਾਪੀਰਾਈਟ",
    all_right: "ਸਾਰੇ ਅਧਿਕਾਰ ਸੁਰੱਖਿਅਤ",
    versions: "ਵਰਜ਼ਨ-",
    "Help-Support": "ਮਦਦ ਸਹਾਇਤਾ",
    "internet-connection": "ਇੰਟਰਨੈੱਟ ਕਨੈਕਟਡ",
    "nointernet-connection": "ਕੋਈ ਇੰਟਰਨੈੱਟ ਕਨੈਕਸ਼ਨ ਨਹੀਂ",
    "Terms-and-Conditions": "ਸ਼ਰਤਾਂ ਅਤੇ ਹਾਲਤਾਂ",
    "Help-&-Support": "ਮਦਦ ਅਤੇ ਸਹਾਇਤਾ",
    "unmute-tra": "ਟਰੇਲਰ ਅਨਮਿਊਟ",
    "mute-tra": "ਟਰੇਲਰ ਮਿਊਟ",
    favourite_lang: "ਪਸੰਦੀਦਾ ਭਾਸ਼ਾ ਵਿੱਚ ਸ਼ਾਮਲ ਕਰੋ",
    added_lang: "ਸ਼ਾਮਲ ਕੀਤਾ",
    "no-notfication": "ਕੋਈ ਸੂਚਨਾ ਨਹੀਂ",
    "notfication-dt": "ਤੁਸੀਂ ਅਜੇ ਤੱਕ ਕੋਈ ਸੂਚਨਾ ਨਹੀਂ ਹੈ। ਬਾਅਦ ਵਿੱਚ ਆਉਣਾ。",
    or: "ਜਾਂ",
    and: "ਅਤੇ",
    sahmat: "",
    "par-bheje": " ",
    "server-error": "ਅੰਦਰੂਨੀ ਸਰਵਰ ਗਲਤੀ",
    "server-error-msg":
      "ਤੁਹਾਡੇ ਅਨੁਰੋਧ ਨੂੰ ਪ੍ਰੋਸੈਸ ਕਰਨ ਦੌਰਾਨ ਇੱਕ ਸਰਵਰ ਗਲਤੀ ਆਈ ਹੈ。",
    "server-retry": "ਹੋਮਪੇਜ ਤੇ ਜਾਓ",
    "watch-lang": "ਤੁਹਾਡੀ ਭਾਸ਼ਾ ਵਿੱਚ ਵੇਖੋ",
    "popular-genre": "ਲੋਕਪ੍ਰਿਯ ਵਿਧਾ",
    subscription_heading: "ਸਾਰੇ ਸਮਗਰੀ ਨੂੰ ਪੀਬੀ ਓਟੀਟੀ ਤੇ ਵੇਖਣ ਲਈ ਸਬਸਕ੍ਰਾਈਬ ਕਰੋ",
    add: "ਸ਼ਾਮਲ ਕਰੋ",
    proceed_to_pay_btn: "ਭੁਗਤਾਨ ਕਰਨ ਲਈ ਅੱਗੇ ਵਧੋ",
    have_promo: "ਕੀ ਤੁਹਾਡੇ ਕੋਲ ਪ੍ਰੋਮੋ ਕਹੈ?",
    promo_code: "ਪ੍ਰੋਮੋ ਕੋਡ",
    enter_promo_code: "ਪ੍ਰੋਮੋ ਕੋਡ ਦਰਜ ਕਰੋ",
    apply_code_btn: "ਕੋਡ ਲਾਗੂ ਕਰੋ",
    select_live_channel_radio: "ਲਾਇਵ ਚੈਨਲ ਅਤੇ ਰੇਡੀਓ ਚੁੱਣ ਕਰੋ",
    radio_channels: "ਰੇਡੀਓ ਚੈਨਲ",
    submit_btn: "ਸੁੱਭ ਕਰੋ",
    add_channel_radio: "ਟੀਵੀ ਚੈਨਲ ਅਤੇ ਰੇਡੀਓ ਸ਼ਾਮਲ ਕਰੋ",
    live_tv_channels: "ਲਾਇਵ ਟੀਵੀ ਚੈਨਲ",
    live_radio_channels: "ਲਾਇਵ ਰੇਡੀਓ ਚੈਨਲ",
    upgrade_subscription: "ਸਬਸਕ੍ਰਾਈਬ ਅੱਗੇ ਵੱਧ ਕਰੋ",
    you_pay: "ਤੁਸੀਂ ਦੇਤੇ ਹੋ",
    rem_amt_curr_plan: "ਤੁਹਾਡੀ ਵਰਤੋਂਮੇਂ ਕੀ ਵੱਧੀ ਮੌਕਾ",
    payble_amt: "ਦੇਇਆ ਗਿਆ ਮੌਕਾ",
    live_channel: "ਲਾਇਵ ਚੈਨਲ",
    continue_watching: "ਵੇਖੋ ਵੱਧੇ",
    Exit: "ਬਾਹਰ ਨਿਕਲੋ",
    ExitMsg: "ਕੀ ਤੁਸੀਂ ਪੱਕੇ ਹੋ ਕਿ ਤੁਸੀਂ ਐਪ ਤੋਂ ਬਾਹਰ ਨਿਕਲਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
  },
  Tamil: {
    "no_data_found":"தரவு எதுவும் கிடைக்கவில்லை",
    "Subscribe to watch":"இப்போது பார்க்க குழுசேரவும்",
   "Drama": "நாடகம்",
   "Tracks": "டிராக்ஸ்",
  "Romance": "காதல்",
  "Fantasy": "பேண்டஸி",
  "Contemporary Fiction": "நவீன புனைகதை",
  "History": "வரலாறு",
  "Mystery": "மர்மம்",
  "Wildlife": "வனவிலங்கு",
  "Thriller": "திகில் கதை",
  "Horror": "பயங்கர கதை",
  "Educational": "கல்வி சார்ந்தது",
  "Health": "ஆரோக்கியம்",
  "Recent Live": "சமீபத்திய நேரலை",
  "Biography": "சுயசரிதை",
  "Musical Drama": "இசை நாடகம்",
  "Music & Dance": "இசை மற்றும் நடனம்",
  "Dance Drama": "நடன நாடகம்",
  "Music": "இசை",
  "Sports": "விளையாட்டு",
  "Adventure": "சாகசம்",
  "Animation": "அனிமேஷன்",
  "Literature": "இலக்கியம்",
  "Arts & Culture": "கலை மற்றும் கலாச்சாரம்",
  "Religious": "மதம்",
  "Crime": "குற்றம்",
  "Spiritual": "ஆன்மீகம்",
  "Detective": "துப்பறியும்",
  "Mythology": "புராணம்",
  "Entertainment": "பொழுதுபோக்கு",
  "Historical Fiction": "வரலாற்று புனைகதை",
  "Political": "அரசியல்",
  "Classical Music": "சாஸ்திரிய இசை",
  "Comedy": "நகைச்சுவை",
  "Satire": "விமர்சனம்",
  "Humor": "காமெடி",
  "Carnatic Music": "கர்நாடக இசை",
"Finance": "நிதி",
"Hobbies And Crafts": "பொழுதுபோக்கு & கைவினை",
"Business and Finance": "வணிகம் மற்றும் நிதி",
"Industrial design": "தொழில்துறை வடிவமைப்பு",
  "Autobiography": "சுயசரிதை",
  "Lifestyle": "வாழ்க்கை முறை",
  "Kids & Family": "குழந்தைகள் மற்றும் குடும்பம்",
  "Devotional": "பக்தி",
  "Nature & Wildlife": "இயற்கை மற்றும் விலங்குகள்",
  "Travelogue": "பயணக் குறிப்பு",
  "Folk Music": "நாட்டு இசை",
  "Storytelling": "கதை சொல்லல்",
  "Dance": "நடனம்",
  "Talk Shows": "பேச்சு நிகழ்ச்சிகள்",
  "Inspirational": "ஈர்க்கும்",
  "Reality": "உண்மை நிகழ்ச்சி",
  "Action": "சண்டை",
  "Agriculture": "விவசாயம்",
  "International": "சர்வதேசம்",
  "Anime": "அனிமே",
  "War": "போர்",
  "Rom-Com": "ரோம்-காம்",
  "Period Drama": "வரலாற்று நாடகம்",
  "Sci-Fi": "அறிவியல் புனைகதை",
  "Patriotic": "தேசபக்தி",
  "Performing Arts": "நிகழ்த்தும் கலை",
  "Astrology": "ஜோதிடம்",
  "Fashion": "நாகரிகம்",
  "Talent Hunt": "திறன் தேடல்",
  "Cookery": "சமையல்",
  "Talk Show": "பேச்சு நிகழ்ச்சி",
  "Superhero": "சூப்பர் ஹீரோ",
  "Literary Fiction": "இலக்கிய புனைகதை",
  "Science": "அறிவியல்",
  "Scientific": "அறிவியல் சார்ந்தது",
  "Cooking": "சமையல்",
  "Food": "உணவு",
  "Science Fiction": "அறிவியல் புனைகதை",
  "Travel": "பயணம்",
  "Paintings": "ஓவியங்கள்",
  "Design": "வடிவமைப்பு",
  "Art": "கலை",
  "Nature": "இயற்கை",
  "Arts And Culture": "கலை மற்றும் கலாச்சாரம்",
  "Educational Books": "கல்வி புத்தகங்கள்",
  "Young Adult Fiction": "இளைஞர் புனைகதை",
  "News": "செய்திகள்",
  "Technology": "தொழில்நுட்பம்",
  "Open World": "திறந்த உலகம்",
  "Business": "வணிகம்",
  "Home Decor": "வீட்டு அலங்காரம்",
  "Survival": "சர்வைவல்",
  "Chat Show": "அரட்டை நிகழ்ச்சி",
  "Edutainment": "கல்வி-பொழுதுபோக்கு",
  "Social Awareness": "சமூக விழிப்புணர்வு",
  "Event": "நிகழ்வு",
  "Hindustani Classical Music": "இந்துஸ்தானி சாஸ்திரிய இசை",
  "Semi-Classical Music": "அரையசாஸ்திரிய இசை",
  "Kids": "குழந்தைகள்",
  "Celebration": "விழா",
  "Casual": "சாதாரணம்",
  "Medical": "மருத்துவம்",
  "Yojna": "திட்டம்",
  "Sculptures": "சிற்பங்கள்",
  "Carbatic Music": "கர்நாடக இசை",
  "Digital Literacy": "டிஜிட்டல் கல்வி",
  "Legal And Ethical": "சட்ட மற்றும் நெறிமுறை",
  "Digital art": "டிஜிட்டல் கலை",
  "Parenting": "பெற்றோராக இருப்பது",
    Sports:"விளையாட்டு",
        inviteReferr:"உங்கள் நண்பரை இந்த அனுபவத்தில் சேர அழைக்கவும்",
     refer_friend:"ஒரு நண்பரை பரிந்துரைக்கவும்",
    Left:"தேடவும்",
    "pbApp":"உங்கள் சுயவிவரத்தை திருத்த Waves PB மொபைல் செயலியை பயன்படுத்தவும்",
    dislike:"பிடிக்கவில்லை",
    rentalDescriptionMsg:"www.wavespb.com இலிருந்து உள்ளடக்கத்தை வாங்குவதைக் தொடரவும்",
     "Okay, Got it":"சரி, புரிந்துவிட்டது",
    Yes: "ஆம்",
    Begins_on:"இந்த நிகழ்ச்சி இப்போது நேரலையாக இல்லை",
    No: "இல்லை",
    "Referral code is empty": "பரிந்துரை குறியீடு காலியாக உள்ளது",
    "Enter a valid referral code": "சரியான பரிந்துரை குறியீட்டை உள்ளிடவும்",
    Movies: "படங்கள்",
    Audio: "ஆடியோ",
    Shows: "நிகழ்ச்சிகள்",
    Music: "இசை",
    All: "அனைத்தும்",
    Live: "நேரலை",
    Documentary: "ஆவணப்படம்",
    "Recently Added": "சமீபத்தில் சேர்க்கப்பட்டது",
    Nostalgia: "நினைவுகள்",
    "News Features": "செய்தி அம்சங்கள்",
    "Waves Originals": "வேவ்ஸ் ஒரிஜினல்ஸ்",
    Action: "நடிப்பு",
    Kids: "குழந்தைகள்",
    Romance: "காதல்",
    Comedy: "நகைச்சுவை",
    startOver: "மீண்டும் தொடங்கு",
    Thriller: "திகில்",
    Live_Events: "லைவ் நிகழ்வு",
    Devotional: "பக்தி",
    Shorts: "குறும்படங்கள்",
    Scan_using_app_or_mobile_camera1:
      "செயலி அல்லது மொபைல் கேமராவை பயன்படுத்தி ஸ்கேன் செய்க",
    Having_Trouble_Logging_in:
      "உள்நுழைவதில் சிக்கலா? www.wavespb.com பார்வையிடவும்",
    have_refferel_code: "உங்களிடம் பரிந்துரை குறியீடு உள்ளதா?",
    view_more: "மேலும் காண்க",
    view_less: "குறைந்தது காண்க",
    streaming_from: "இருந்து ஸ்ட்ரீமிங்",
    "Session-Expired": "அமர்வு காலாவதியானது",
    "session-desc": "உங்கள் அமர்வு நேர எல்லை முடிவடைந்தது.",
    RentAvailable: "₹ விலையில் வாடகைக்கு கிடைக்கும்",
    RentMsg:
      "கொள்முதல் செய்த நாளிலிருந்து இந்த உள்ளடக்கத்தை பார்ப்பதற்கான 30 நாட்கள் வாடகை உள்ளடக்கியுள்ளது.",
    "Error!": "பிழை!",
    "Success!": "வெற்றி!",
    streaming_start: "ஸ்ட்ரீமிங் இருந்து",
    midnight: "நள்ளிரவு முதல் ஆரம்பமாகும்",
    WatchlistError:
      "வாட்ச் லிஸ்டில் சேர்க்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    WatchlistSuccess: "வாட்ச் லிஸ்டில் வெற்றிகரமாக சேர்க்கப்பட்டது.",
    GamePlay: "நான் எப்படி விளையாடுவது?",
    PlayMsg:
      "இந்த விளையாட்டை விளையாட, தயவுசெய்து Waves PB பயன்பாட்டைப் பயன்படுத்தவும் அல்லது www.wavespb.com பார்வையிடவும்.",
    "Login to Continue": "தொடர लॉगिन செய்யவும்",
    LoginContinue:
      "நமது பயன்பாட்டின் முழு அணுகலையும் அனுபவிக்க தயவுசெய்து உள்நுழையவும்.",
    Prasar_Bharti_Mobile_App:
      "மற்றும் பிரசார் பாரதி மொபைல் செயலியில் உங்கள் சுயவிவரத்தை திருத்தவும்.",
    go_to_account: '"என் கணக்கு" செல்',
    clear: "அழுத்தம்",
    ResuminWating: "தொடரவும்",
    RefferalMsg: "ஏற்கனவே பதிவு செய்யப்பட்ட எண்களுக்கு இது பொருந்தாது!",
    del: "அழி",
    RefferalCode: "குறியீடு",
    referal_code: "ரிபரல் கோடு",
    space: "இடைவெளி",
    Live_Events: "நேரடி நிகழ்வு",
    having_trouble_loggin_in_please_visit_our_website:
      "உள்நுழைவதில் சிக்கல் உள்ளதா? தயவுசெய்து எங்கள் இணையதளத்தைப் பாருங்கள்.",
    Subscribewatch: "பார்க்க சந்தானம்",
    SubscribeMsg:
      "இந்த உள்ளடக்கத்தை பார்ப்பதற்காக, தயவுசெய்து எங்கள் இணையதளம் www.wavespb.com-ல் உங்கள் வாங்கும் செயல்முறையை முடிக்கவும்.",
    Subscribelisten: "கேட்க சந்தானம்",
    available_to_rent: "குத்தகைக்கு கிடைக்கிறது",
    login_with: "உடன் உள்நுழை",
    LoginToWatch: "இப்போது பார்க்க",
    subtitle: "உபதலைப்புகள்",
    no_subtitle: "எந்த உபதலைப்புகளும் கிடைக்கவில்லை",
    Watchnow: "இப்போது பார்க்க",
    ListenToWatch: "இப்போது கேட்க",
    Listennow: "இப்போது கேளுங்கள்",
    Logout: "வெளியேறு",
    proceed: "தொடர்க",
    availableOnRent: "வாடகைக்கு கிடைக்கும்",
    Apply: "சேர்க்கவும்",
    skip_start_browsing: "விடு & உலவி ஆரம்பிக்க",
    or: "அல்லது",
    done: "செய்துவிட்டேன்",
    "Help&Support": "உதவி & ஆதரவு",
    enter_mobile_number: "கடமை எண்ணை உள்ளிடவும்",
    "Privacy-Policy": "தனியுரிமை கொள்கை",
    "Term&Conditions": "நிபந்தனைகள் & கட்டுப்பாடுகள்",
    sign_in_with_mobile_or_email:
      "மொபைல் அல்லது மின்னஞ்சல் பயன்படுத்தி உள்நுழையுங்கள்",
    "About-Us": "எங்களைப் பற்றி",
    get_a_new_code: "புதிய குறியீட்டை பெறவும்",
    enter_your_mobile_number_or_email_to_continue:
      "தொடர உங்கள் மொபைல் எண் அல்லது மின்னஞ்சலை உள்ளிடவும்",
    Search_: "தேடல்",
    left: "இடது",
    "Top-Results": "சிறந்த முடிவுகள்",
    "Popular-Searches": "பிரபலமான தேடல்கள்",
    "Popular-Search": "பிரபலமான தேடல்",
    searchplaceholder:
      "கலைஞர், நிகழ்ச்சிகள், பட்டியல்கள் அல்லது உள்ளடக்கத்தை தேடு",
    Home_: "முகப்பு பக்கம்",
    Live_: "டிவி/வானொலி",
    "Delete-Account": "கணக்கை அழிக்க",
    Watchlist: "பார்க்க வேண்டியவை பட்டியல்",
    "My-Profile": "என் சுயவிவரம்",
    Edit: "திருத்து",
    Add: "சேர்க்க",
    "Edit-Profile": "சுயவிவரத்தைத் திருத்து",
    "Add-Profile": "சுயவிவரத்தை சேர்க்க",
    "Who’sWatching?": "யார் பார்க்கிறார்கள்?",
    "placeholder-profile": "சுயவிவர பெயரை உள்ளிடு",
    "Kid’sprofile?": "குழந்தையின் சுயவிவரம்?",
    "Onlyshowkid-friendlyvideos":
      "குழந்தைகளுக்கு உகந்த காணொளிகளை மட்டும் காட்டு",
    "No-Result-Found": "எந்த முடிவும் கிடைக்கவில்லை",
    "try-other-keyword": "வேறு சொகீவொர்டை மீண்டும் பார்க்கவும்",
    "No-data-found": "எந்த தரவும் கிடைக்கவில்லை",
    "No-list-found":
      "எந்த பட்டியலும் கிடைக்கவில்லை. தேடுவதையும் உங்கள் பிரியங்களை சேர்க்கவும்",
    "Continue-Watching": "பார்க்கும் தொடர்வு",
    welcome_to_dds_world_of_entertainment: "விளையாட்டின் அலை",
    Login: "உள்நுழை",
    Guest: "விருந்தினர்",
    "Login-to-your-account": "உங்கள் கணக்கிற்கு உள்நுழை",
    "Login-enter-no":
      "உங்கள் எண்ணை உள்ளிடுவீர். பல திரைப்படங்கள், விளையாட்டுகள் & தொடர்களை கண்டுகொள்ளவும்",
    "Login-enter-no-email":
      "உங்கள் மின்னஞ்சலை உள்ளிடுவீர். பல திரைப்படங்கள், விளையாட்டுகள் & தொடர்களை கண்டுகொள்ளவும்",
    "Phone-Number": "கைபேச்சு எண்",
    "sms-verify": "உங்கள் கைபேச்சு எண்ணிற்கு ஒரு OTP அனுப்பப்படும்.",
    "email-verify": "உங்கள் மின்னஞ்சலைக்கு ஒரு OTP அனுப்பப்படும்.",
    Scan_using_app_or_mobile_camera:
      "மொபைல் பயன்பாட்டைப் பயன்படுத்தி ஸ்கேன் செய்யவும்",
    "Send-OTP": "OTP அனுப்பு",
    "confirm-that-agree":
      "உங்கள் இந்த நிபந்தனைகளை ஏற்றுக்கொள்வதை உறுதிப்படுத்துகிறீர்.",
    "OTP-Verification": "OTP உறுதிப்பாடு",
    "verification-code": "உறுதிப்பாடு கோடை உள்ளிடு",
    "not-receive-code": "கோடை பெறவில்லை?",
    Resend: "மீண்டும் அனுப்பு",
    "Having-Issue?": "எதுவும் பிரச்சனைகள்?",
    "Contact-Us": "எங்களை தொடர்பு கொள்ளவும்!",
    "EnterPhone-Number": "கைபேச்சு எண்ணை உள்ளிடு",
    "Resend-OTP-in": "மீண்டும் OTP அனுப்புவதில்",
    verify: "உறுதிப்பாடு",
    "cofirm-logout": "நீங்கள் நிச்சயமாக பயன்பாட்டில் இருந்து வெளியேற விரும்புகிறீர்களா?",
    Confirm: "உறுதிப்பாடு",
    logout: "வெளியேறு",
    notifications: "அறிவிப்புகள்",
    registered_devices: "பதிவு செய்யப்பட்ட சாதனங்கள்",
    clear_search_history: "தேடல் வரலாற்றை அழிக்க",
    subscription_and_devices: "சந்தானம் & சாதனங்கள்",
    subscription: "சந்தானம்",
    my_device: "என் சாதனம்",
    Cancel: "ரத்து செய்",
    payment_details: "கட்டணை விவரங்கள்",
    other_devices: "ஏனைய சாதனங்கள்",
    deregister: "பதிவு நீக்க",
    "Content-Language-Changed": "உள்ளடக்கத்தின் மொழி மாற்றப்பட்டது",
    "App-Language-Changed": "செயலி மொழி மாற்றப்பட்டது",
    "Change-Language": "மொழியை மாற்று",
    Previous: "இதற்கு முன்",
    More: "மேலும்",
    audio_quality: "ஆடியோ தரம்",
    speed: "வேகம்",
    Delete: "நீக்கவும்",
    Notification: "அறிவிப்பு",
    no_noti_found: "அறிவிப்பு கிடைக்கவில்லை",
    Artist: "கலைஞர்",
    just_now: "சற்று முன்",
    title_activity_purchase_history: "வாங்கும் வரலாறு",
    first_fragment_label: "முதல் துண்டம்",
    second_fragment_label: "இரண்டாம் துண்டம்",
    Next: "அடுத்து",
    next_episode: "அடுத்த அத்தியாயம்",
    Download: "பதிவிறக்கம் செய்",
    transaction_history: "பரிவர்த்தனை வரலாறு",
    no_transaction_history: "பரிவர்த்தனை வரலாறு கிடைக்கவில்லை",
    str_watch_list: "பார்க்க பட்டியல்",
    my_purchased_video: "என் வாஙகாணொளிகள்",
    subscribe_: "சந்தானம்",
    plan_price: "திட்டம் விலை",
    remaining_balance: "எஞ்சியிருக்கும் இருப்பு",
    total_amount: "மொத்த தொகை",
    n_a: "கிடையாது",
    run_on_physical_device_only: "உடல் சாதனத்தில் மட்டும் இயக்கு",
    btn_ok: "சரி",
    msg_vpn_error: "VPN பிழையானது",
    note_your_code_will_be_updated_after_5_min:
      "குறிப்பு: உங்கள் கோடை 5 நிமிடங்களில் புதுப்பிக்கப்படும்",
    payable_amount: "கட்டணை தொகை",
    didnt_receive_otp: "OTP பெறவில்லை",
    hello_first_fragment: "வணக்கம்",
    hello_second_fragment: "வாங்கும் விவரங்கள்",
    coming_soon: "விரைவில் வருகிறது",
    packages: "பேக்கேஜ்கள்",
    str_support: "ஆதரவு",
    delete_acct: "கணக்கை அழிக்க",
    delete_conform: "உங்கள் கணக்கை அழிக்க உறுதிப்படுத்துகிறீர்களா?",
    delete_profile_success: "சுயவிவரம் வெற்றிகரமாக அகற்றப்பட்டது",
    Dlt_Accnt_msg: "கணக்கை அழிக்கும் உறுதிப்பாடு செய்தி",
    some_error_occurred_please_try_again:
      "சில பிழைகள் ஏற்பட்டன. மீண்டும் முயற்சிக்கவும்.",
    auto: "தானாக",
    player_not_ready_try_again:
      "ப்ளேயர் தயாராக இல்லை. மீண்டும் முயற்சிக்கவும்.",
    edit_profile: "சுயவிவரத்தை திருத்து",
    learn_more: "மேலும் அறிக",
    wishlist: "விருப்பப்பட்டியல்",
    category_name: "வகைப்பாடு",
    str_my_download: "என் பதிவிறக்கங்கள்",
    language: "மொழி",
    added_watch_list: "பார்க்க பட்டியலில் சேர்க்கப்பட்டது",
    removed_watch_list: "பார்க்க பட்டியலிலிருந்து நீக்கப்பட்டது",
    viewall: "அனைத்தையும் பார்க்க",
    msg_video_expired:
      "இந்த வீடியோ காலஅடைந்தது. மீண்டும் வாங்கவும் பார்க்க அது கொடுப்பதற்கு ஒப்புதலை வாங்கவும்.",
    skip_intro: "உரையைத் தள்ளு",
    settings: " அமைப்புகள்",
    video_quality: "வீடியோ 品质",
    video_speed: "வீடியோ வேகம்",
    like: "ஒப்புதலை",
    unlike: "அல்லது ஒப்புதலை",
    refund: "பதில்",
    userProfile: "பயனாளர் புத்தகம்",
    signup_create_new_account: "புதிய கணக்கை உருவாக்குங்கள்",
    already_acc_login: "ஏற்கனவே கணக்கு உள்ளதா? உள்நுழையுங்கள்",
    accept_terms_and_condition:
      "விதிகளையும் நிபந்தனைகளையும் ஏற்றுக்கொள்ளுங்கள்",
    new_password: "புதிய கடவுச்சொல்",
    api_failure_msg: "API தோல்வி",
    remove_profile_pic: "சுயவிவர படிமத்தை நீக்குங்கள்",
    remove: "நீக்குங்கள்",
    msg_remove_profile_pic: "சுயவிவர படிமத்தை நீக்கும் உறுதிசெய்தியை",
    profile_photo: "சுயவிவர படிமம்",
    purchased_video: "வாங்கிய வீடியோ",
    upgrade: "மேம்படுத்துங்கள்",
    msg_send_otp: "OTP ஐ அனுப்புங்கள்",
    forgot_your_password: "உங்கள் கடவுச்சொல்லை மறந்துவிட்டீர்களா?",
    msg_search_content: "உள்ளடக்கத்தை தேடுங்கள்",
    current_plan: "தற்போதைய திட்டம்",
    more_like_this: "இதைபோன்ற மேலும்",
    download_channel_id: "டவுன்லோட் சேனல் ID",
    download_video_service_channel: "டவுன்லோட் வீடியோ சேவை சேனல்",
    searchLikehotStar: "எதுவும் டவுன்லோட் கிடைக்கவில்லை",
    don_t_have_an_account: "கணக்கு இல்லையா?",
    delete_video: "வீடியோவை நீக்குங்கள்",
    sign_up: "ஒப்புக்கொள்ளுங்கள்",
    having_forget_password: "உங்கள் கடவுச்சொல்லை மறந்துவிட்டீர்களா?",
    complete_profile: "சுயவிவரத்தை நிறைவுசெய்யுங்கள்",
    add_profile: "சுயவிவரத்தை சேர100 words",
    wait_to_play_video: "வீடியோ விளிக்கும் காலத்தில் காத்துக்கொள்ளுங்கள்",
    buy_now_at: "இப்போது வாங்குங்கள்",
    upgrade_now_at: "இப்போது மேம்படுத்துங்கள்",
    new_text: "புதிய வாக்கு",
    rate_app_title: "மதிப்பெயர்க்கு",
    rate_app_message:
      "எங்களது அப்பியை நன்றிப்படுத்துகிறீர்களா? உங்கள் முன்னேற்றத்தை ஒரு கட்டுப்படam நிறுத்துங்கள். எங்களுக்கு உதவிப்படுத்தின் மகிழ்ச்சி!",
    rate_btn_pos: "தற்போதைய விவரத்தை மதிப்பெயர்க்கு",
    rate_btn_neg: "அடுத்த நேரத்தில் நினைவு செய்",
    rate_btn_nut: "நன்றி",
    no_additional_track: "கூடுதல் ஆடியோ டிராக் கிடைக்கவில்லை",
    change_name: "பெயரை மாற்றுங்கள்",
    download_options: "டவுன்லோட் விக்கலாம்",
    low_quality: "குறைவான வகை",
    medium_quality: "மூன்று வகை",
    high_quality: "உயர் வகை",
    downloading: "டவுன்லோட் செய்கிறது",
    download_pause: "டவுன்லோட் நிறுத்துங்கள்",
    downloaded: "டவுன்லோட் செய்யப்பட்டது",
    download_url_is_not_found: "டவுன்லோட் URL கிடைக்கவில்லை",
    download_running: "டவுன்லோட் செயல்படுகிறது",
    no_plan_subscribed: "திட்டம் உறுதிப்படுத்தப்படவில்லை",
    privacypolicy: "குறிப்புகள்",
    termsuse: "பயன்வழி",
    resendotp_in: "OTP ஐ மீண்டும் அனுப்புங்கள் (உள்நுழைப்பதற்கு தேவை)",
    login_required: "உள்நுழைப்பதற்கு உள்நுழைவீர்கள்",
    sorry_we_couldn_t_complete_your_request_please_try_again_in_a_moment:
      "உங்கள் கேட்கையை முடியவில்Please try again in a moment.",
    trailer: "டிரைலர்",
    subscribe_now_to_watch: "இப்போது உறுதிப்படுத்துங்கள்",
    app_version: "அப்பின் பதிப்பு",
    select_all: "அனைத்தையும் தேர்ந்தெடுங்கள்",
    please_enter_valid_name: "செல்லுபடியான பெயரை உள்ளிடுங்கள்",
    choose_avatar: "அவதாரத்தைத் தேர்ந்தெடுக்கவும்",
    enter_name: "தயவுசெய்து பெயரை உள்ளிடவும்",
    unselect_all: "அனைத்தையும் தேர்ந்தெடுவதை நிறுத்துங்கள்",
    enter_mobile_number: "கைபேசி எண்ணை உள்ளிடுங்கள்",
    title_activity_scan_qr_code: "QR குறியீட்டை ஸ்கேன் செய்யுங்கள்",
    plz_enter_name: "பெயரை உள்ளிடுங்கள்",
    plz_change_name: "பெயரை மாற்றுங்கள்",
    plz_choose_avtar: "அவதாரத்தை தேர்ந்தெடுங்கள்",
    plz_select_profile: "சுயவிவரத்தை தேர்ந்தெடுங்கள்",
    who_s_watching: "யார் பார்க்கிறார்கள்",
    my_profile: "எனது சுயவிவரம்",
    profiles: "சுயவிவரங்கள்",
    clear: "தெளிவு",
    recent_searches: "சமீபத்திய தேடல்கள்",
    Recommended_searches: "பரிந்துரைக்கப்பட்ட தேடல்கள்",
    please_enter_your_number_to_discover_a_variety_nof_movies_sports_series:
      "பல்வேறு திரைப்படங்கள், விளையாட்டுகள், தொடர்களை கண்டுபிடிக்க உங்கள் கைபேசி எண்ணை உள்ளிடுங்கள்",
    mobile_number: "கைபேசி எண்",
    having_issue_contact_us: "பிரச்சனைகள் உள்ளனவா? எங்களை தொடர்புகொள்ளுங்கள்",
    didn_t_receive_code_resend:
      "குறியீட்டை பெறவில்லை? OTP ஐ மீண்டும் அனுப்புங்கள்",
    enter_the_verification_code_we_just_sent_to_your_number:
      "உங்கள் எண்ணிற்கு நாம் அனுப்பிய உறுதிசெய்தியை உள்ளிடுங்கள்",
    incorrect_otp_entered_please_enter_again:
      "தவறான OTP உள்ளிடப்பட்டது. மீண்டும் உள்ளிடுங்கள்",
    app_update_title: "அப்பின் புதுப்பிப்பு",
    app_update_msg: "அப்பின் புதிய பதிப்பு இப்போது கிடைக்கிறது",
    watch_now: "இப்போது பார்க்கவும்",
    my_list: "எனது பட்டியல்",
    cast_and_crew: "நடிகர்கள் மற்றும் குழு",
    similar_to_this: "இதைபோன்ற",
    similar_channels: "இதே போன்ற சேனல்கள்",
    delete_account: "கணக்கை நீக்குங்கள்",
    delete_account_desc: "உங்கள் கணக்கை நீக்க விரும்புகிறீர்களா",
    delete_conform: "சுயவிவரம்?",
    log_out: "உள்நுழைவை நீக்குங்கள்",
    log_out_desc:
      "இந்த கணக்கிலிருந்து உள்நுழைவை நீக்க உறுதியாக இருக்கிறீர்களா?",
    pb_on_tv: "பிரசார் பாரதி டிவியில் பயன்படுத்துங்கள்",
    link_device: "சாதனத்தை இணைக்கவும்",
    linked_tv: "இணைக்கப்பட்ட டிவி",
    link_with_tv: "டிவியுடன் இணைக்க உறுதியாக இருக்கிறீர்களா?",
    no_result_found: "எதுவும் கிடைக்கவில்லை",
    search_again: "மீண்டும் தேடுங்கள்",
    no_list_found: "எதுவும் பட்டியல் கிடைக்கவில்லை",
    no_list_found_desc: "உங்கள் விருப்பத்த",
    no_notifications: "எதுவும் அறிவிப்புகள் கிடைக்கவில்லை",
    no_notifications_desc:
      "உங்களுக்கு எதுவும் அறிவிப்புகள் இல்லை. பின்னாளில் வருகையில்",
    network_error: "நெட்வொர்க் பிழை",
    retry: "மீண்டும் செய்யுங்கள்",
    open_setting: "அமைப்புகளை திறக்கவும்",
    internal_server: "உள்ளார்ந்த சேவையகப் பிழை",
    internal_server_error:
      "சேவையகம் உங்கள் கேட்கையை செயல்படுத்தும்போது பிழை ஏற்பட்டது.",
    go_back: "பின்னாளில் செல்லுங்கள்",
    data_not_found: "தரவு கிடைக்கவில்லை",
    page_not_found_desc: "உங்கள் பார்க்கும் பக்கம் இல்லை",
    popular_search: "பிரபலமான தேடல்கள்",
    top_results: "மேல் முடிவுகள்",
    guest_user: "விருந்தினர் பயனர்",
    channels: "சேனல்கள்",
    Radio: "ரேடியோ",
    TV: "டிவி",
    favorites: "விருப்பங்கள்",
    content_language: "உள்ளடக்க மொழி",
    app_language: "அப்பின் மொழி",
    change_account: "கணக்கை மாற்றுங்கள்",
    move_account: "மற்றொரு கணக்கிற்கு செல்ல உறுதியாக இருக்கிறீர்களா?",
    update_profile: "உங்கள் சுயவிவரம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    added_profile: "உங்கள் சுயவிவரம் வெற்றிகரமாக சேர்க்கப்பட்டது",
    edit_update: "திருத்துங்கள்",
    cast_crew: "நடிகர்கள் மற்றும் குழு",
    episodes: "அத்தியாயங்கள்",
    no_record: "எதுவும் பதிவு கிடைக்கவில்லை",
    free_time_up: "இலவச நேரம் முடிந்துவிட்டது!",
    free_create_account:
      "பார்க்க ஒரு இலவச கணக்கை உருவாக்கவும் அல்லது உள்நுழையவும்",
    adventure: "சாகசம்",
    prasar_bharti: "பிரசார் பாரதி",
    ind_broadcast: "(இந்தியாவின் பொது சேவை ஒலிபரப்புநர்)",
    back_to_home: "முகப்புப் பக்கத்திற்கு திரும்பு",
    oops_page_not_found: "மன்னிக்கவும் பக்கம் கிடைக்கவில்லை",
    page_looking: "நீங்கள் தேடும் பக்கம் இல்லை",
    go_to_home: "முகப்புப் பக்கத்திற்கு செல்லுங்கள்",
    popular_genres: "பிரபல வகைகள்",
    watchLanguage: "உங்கள் மொழியில் பார்க்கவும்",
    help_support: "உதவி மற்றும் ஆதரவு",
    customer_support: "வாடிக்கையாளர் ஆதரவு",
    contact_number: "தொடர்பு எண்",
    email_address: "மின்னஞ்சல் முகவரி",
    share: "பகிர்",
    copy: "நகல்",
    copied: "நகல் செய்யப்பட்டது",
    bharat_ott: "பாரத் ஒட்டி",
    Home_: "முகப்பு பக்கம்",
    policy: "திரும்பும் மற்றும் ரத்து செய்யும் கொள்கை",
    terms_condition: "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
    your_account: "உங்களுகulagam",
    continue: "தொடர்க",
    "login_here!": "இங்கு உள்நுழைக",
    mobile: "கைபேசி",
    password: "கடவுச்சொல்",
    forgot_password: "கடவுச்சொல்லை மறந்துவிட்டீர்களா?",
    sign_up_here: "இங்கு பதிவுசெய்க",
    social_media: "சோசியல் மீடியாவில் தொடர்ந்து",
    search_data: "அனைத்து தேடல் தரவு",
    description: "விவரணம்",
    episode_name: "எபிசோட் பெயர்",
    episode_num: "எபிசோட் எண்",
    page_looking_might:
      "நீங்கள் தேடும் பக்கம் நீக்கப்பட்டிருக்கலாம் அல்லது தற்காலிகமாக கிடைக்காது.",
    Ok: "சரி",
    otp_sent: "OTP வெற்றிகரமாக அனுப்பப்பட்டது",
    success: "வெற்றி",
    could_not_sent: "OTP அனுப்ப இயலவில்லை",
    error: "பிழை",
    resent_otp: "OTP வெற்றிகரமாக அனுப்பப்பட்டது",
    enter_valid_otp: "சரியான OTP ஐ உள்ளிடவும்",
    enter_six_digit_valid: "6 இலக்க சரியான OTP ஐ உள்ளிடவும்",
    profile_creation: "ப்ரோஃபைல் வெற்றிகரமாக உருவாக்கப்பட்டது",
    error_name: "ப்ரோஃபைல் பெயரை உள்ளிடவும்",
    "Delete-Profile": "ப்ரோஃபைலை நீக்கு",
    add_to_watchlist: "கண்காணிப்புப் பட்டியலில் சேர்க்க",
    added_to_watchlist: "கண்காணிப்புப் பட்டியலில் சேர்க்கப்பட்டது",
    like_it: "இதை விரும்பு",
    not_for_me: "எனக்கு இது பொருந்தாது",
    "n-number": "எண்",
    "e-email": "மின்னஞ்சல்",
    "account-subscribe": "இப்போது சந்தாவில் சேர்க்க",
    "account-subscribe-upgrade": "இப்போது மேம்படுத்து",
    "user-details-text": "பயனர் விவரங்கள்",
    "acc-username": "பயனர் பெயர்",
    "acc-enterusername": "பயனர் பெயரை உள்ளிடவும்",
    "acc-mobile": "கைபேசி எண்",
    "acc-entermobile": "கைபேசி எண்ணை உள்ளிடவும்",
    "acc-email": "மின்னஞ்சல் முகவரி",
    "acc-enteremail": "மின்னஞ்சல் முகவரியை உள்ளிடவும்",
    "acc-Gender": "பாலினம்",
    "acc-Gender1": "ஆண்",
    "acc-Gender2": "பெண்",
    "acc-Gender3": "மற்றவை",
    "acc-dob": "பிறந்த தேதி",
    "acc-save": "விவரங்களை சேமிக்க",
    "my-account": "என் கணக்கு",
    "trans-history": "பரிவர்த்தனை வரலாறு",
    "acc-varified": "உறுதிப்படுத்தப்பட்டது",
    "network-error": "நெட்வொர்க் பிழை",
    "network-unable":
      "இணையத்தில் இணைக்க இயலவில்லை. தங்கள் இணைய இணைப்பை சரிபார்க்கவும்",
    "network-retry": "மீண்டும் முயற்சி",
    "download-apps": "எங்கள் பயன்பாடுகளை பதிவிறக்கு",
    "PB-OTT": "PB OTT",
    "copy-right": "படைப்புரிமை",
    all_right: "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டுள்ளன.",
    versions: "பதிப்பு-",
    "Help-Support": "உதவி ஆதரவு",
    "internet-connection": "இணைய இணைப்பு",
    "nointernet-connection": "இணைய இணைப்பு இல்லை",
    "Terms-and-Conditions": "நிபந்தனைகள் மற்றும் கட்டுப்பாடுகள்",
    "Help-&-Support": "உதவி & ஆதரவு",
    "unmute-tra": "டிரெய்லரை அன்மூட் செய்யவும்",
    "mute-tra": "டிரெய்லரை மூட் செய்யவும்",
    favourite_lang: "பிரியமான மொழியைச் சேர்க்கவும்",
    added_lang: "சேர்க்கப்பட்டது",
    "no-notfication": "எந்த அறிவிப்பும் இல்லை",
    "notfication-dt":
      "உங்களுக்கு எந்த அறிவிப்பும் இல்லை. பின்னர் வருகையில் திரும்பவும்.",
    or: "அல்லது",
    and: "&",
    sahmat: "",
    "par-bheje": " ",
    "server-error": "உள்ளே சேவை பிழையாகும்",
    "server-error-msg":
      "உங்கள் கோரிக்கையை செயல்படுத்தும் போது சேவை பிழையாகும்.",
    "server-retry": "ஹோம்பேஜுக்கு செல்லவும்",
    "watch-lang": "உங்கள் மொழியில் பார்க்கவும்",
    "popular-genre": "பிரபலமான வகைகள்",
    subscription_heading:
      "PB OTT இல் அனைத்து உள்ளடக்கங்களையும் பார்க்க சந்தாவை செய்யவும்",
    add: "சேர்க்கவும்",
    proceed_to_pay_btn: "கட்டணத்திற்கு செல்லவும்",
    have_promo: "உங்களுக்கு பிரோமோ கோடு உளஉள்ளதா?",
    promo_code: "பிரோமோ கோடு",
    enter_promo_code: "பிரோமோ கோடை உள்ளிடுக",
    apply_code_btn: "கோடை பயன்படுத்துக",
    select_live_channel_radio:
      "நேரடி டிவி அலைவானையும் ரேடியோவையும் தேர்ந்தெடுக",
    radio_channels: "ரேடியோ அலைவானைகள்",
    submit_btn: "சமர்ப்புக",
    add_channel_radio: "டிவி அலைவானையும் ரேடியோவையும் சேர்க்கவும்",
    live_tv_channels: "நேரடி டிவி அலைவானைகள்",
    live_radio_channels: "நேரடி ரேடியோ அலைவானைகள்",
    upgrade_subscription: "சந்தாவை மேம்படுத்துக",
    you_pay: "உங்கள் கட்டணம்",
    rem_amt_curr_plan: "உங்கள் தற்போதைய திட்டத்தில் எஞ்சியுள்ள தொகை",
    payble_amt: "கட்டணத்திற்கு தொகை",
    live_channel: "நேரடி டிவி அலைவானை",
    continue_watching: "பார்க்கவும் தொடர்ந்து செய்யவும்",
    Exit: "வெளியேறு",
    ExitMsg: "நீங்கள் நிச்சயமாக பயன்பாட்டிலிருந்து வெளியேற விரும்புகிறீர்களா?",
  },
  Malayalam: {
    "no_data_found":"ഡാറ്റ ലഭ്യമല്ല",
    "Subscribe to watch":"ഇപ്പോൾ കാണാൻ സബ്സ്ക്രൈബ് ചെയ്യുക",
     "Drama": "നാടകം",
  "Tracks": "ട്രാക്സ്",
  "Romance": "പ്രണയം",
  "Fantasy": "ഫാന്‍റസി",
  "Wildlife": "വന്യജീവി",
  "Contemporary Fiction": "സമകാലിക കൽപ്പിതം",
  "History": "ചരിത്രം",
  "Mystery": "രഹസ്യം",
  "Thriller": "ത്രീലർ",
  "Horror": "ഭീകരം",
  "Educational": "വിദ്യാഭ്യാസം",
  "Survival": "അതിജീവനം",
  "Health": "ആരോഗ്യം",
  "Biography": "ജീവചരിത്രം",
   "Recent Live": "സമീപകാല ലൈവ്",
  "Musical Drama": "സംഗീത നാടകം",
  "Music & Dance": "സംഗീതവും നൃത്തവും",
  "Dance Drama": "നൃത്ത നാടകം",
  "Music": "സംഗീതം",
  "Sports": "കായികം",
  "Adventure": "സാഹസികം",
  "Animation": "ആനിമേഷൻ",
  "Literature": "സാഹിത്യം",
  "Arts & Culture": "കലയും സംസ്കാരവും",
  "Religious": "മതപരമായത്",
  "Crime": "അപരാധം",
  "Spiritual": "ആത്മീയത",
  "Detective": "ഡിറ്റക്റ്റീവ്",
  "Mythology": "പുരാണം",
  "Entertainment": "വിനോദം",
  "Historical Fiction": "ചരിത്ര നോവൽ",
  "Political": "രാഷ്ട്രീയം",
  "Classical Music": "ശാസ്ത്രീയ സംഗീതം",
  "Comedy": "ഹാസ്യം",
  "Satire": "പരിഹാസം",
  "Carnatic Music": "കർണാട്ടിക് സംഗീതം",
"Finance": "ധനകാര്യം",
"Hobbies And Crafts": "വിനോദങ്ങളും കരകൗശലവും",
"Business and Finance": "ബിസിനസ്സും ധനകാര്യവും",
"Industrial design": "ഇൻഡസ്ട്രിയൽ ഡിസൈൻ",
  "Humor": "തമാശ",
  "Autobiography": "ആത്മകഥ",
  "Lifestyle": "ജീവിതശൈലി",
  "Kids & Family": "കുട്ടികളും കുടുംബവും",
  "Devotional": "ഭക്തിപ്രധാനമായത്",
  "Nature & Wildlife": "പ്രകൃതിയും വന്യജീവികളും",
  "Travelogue": "യാത്രാവിവരണം",
  "Folk Music": "ജനപാട്ട്",
  "Storytelling": "കഥ പറയൽ",
  "Dance": "നൃത്തം",
  "Talk Shows": "ടോക്ക് ഷോകൾ",
  "Inspirational": "പ്രചോദനാത്മകമായത്",
  "Reality": "യാഥാർത്ഥ്യ പരിപാടി",
  "Action": "ആക്ഷൻ",
  "Agriculture": "കൃഷി",
  "International": "അന്തർദേശീയ",
  "Anime": "ആനിമെ",
  "Period Drama": "കാലഘട്ട നാടകം",
  "Sci-Fi": "ശാസ്ത്രീയ സാങ്കൽപ്പികം",
  "Patriotic": "ദേശഭക്തി",
  "Performing Arts": "നാടകകലകൾ",
  "Astrology": "ജ്യോതിശ്ശാസ്ത്രം",
  "War": "യുദ്ധം",
  "Rom-Com": "റோம்-കോം",
  "Fashion": "ഫാഷൻ",
  "Talent Hunt": "പ്രതിഭാ തേടൽ",
  "Cookery": "പാചകം",
  "Talk Show": "ടോക്ക് ഷോ",
  "Superhero": "സൂപ്പർഹീറോ",
  "Literary Fiction": "സാഹിത്യ നോവൽ",
  "Science": "ശാസ്ത്രം",
  "Scientific": "ശാസ്ത്രീയമായത്",
  "Cooking": "പാചകം",
  "Food": "ഭക്ഷണം",
  "Travel": "യാത്ര",
  "Paintings": "ചിത്രങ്ങൾ",
  "Design": "ഡിസൈൻ",
  "Art": "കല",
  "Science Fiction": "സയൻസ് ഫിക്ഷൻ",
  "Nature": "പ്രകൃതി",
  "Arts And Culture": "കലയും സംസ്കാരവും",
  "Educational Books": "വിദ്യാഭ്യാസ പുസ്തകങ്ങൾ",
  "Young Adult Fiction": "യുവജന നോവൽ",
  "News": "വാർത്ത",
  "Technology": "സാങ്കേതികവിദ്യ",
  "Open World": "തുറന്ന ലോകം",
  "Business": "ബിസിനസ്",
  "Home Decor": "വീട്ടലങ്കാരം",
  "Chat Show": "ചാറ്റ് ഷോ",
  "Edutainment": "വിദ്യാഭ്യാസ വിനോദം",
  "Social Awareness": "സാമൂഹ്യ ബോധവത്കരണം",
  "Event": "പരിപാടി",
  "Hindustani Classical Music": "ഹിന്ദുസ്ഥാനി ശാസ്ത്രീയ സംഗീതം",
  "Semi-Classical Music": "അർദ്ധശാസ്ത്രീയ സംഗീതം",
  "Kids": "കുട്ടികൾ",
  "Celebration": "ആഘോഷം",
  "Casual": "സാധാരണ",
  "Medical": "വൈദ്യശാസ്ത്രം",
  "Yojna": "പദ്ധതി",
  "Sculptures": "ശില്പങ്ങൾ",
  "Carbatic Music": "കാർണാറ്റിക് സംഗീതം",
  "Digital Literacy": "ഡിജിറ്റൽ സാക്ഷരത",
  "Legal And Ethical": "നിയമപരവും നൈതികവുമായത്",
  "Digital art": "ഡിജിറ്റൽ കല",
  "Parenting": "മാതൃത്വം",
    Sports:"കായികം",
            inviteReferr:"നിങ്ങളുടെ സുഹൃത്തിനെ ഈ അനുഭവത്തിൽ ചേരാൻ ക്ഷണിക്കുക",
     refer_friend:"ഒരു സുഹൃത്തെ പരാമർശിക്കുക",
     Left:"ഇടത്",
    "pbApp":"നിങ്ങളുടെ പ്രൊഫൈൽ എഡിറ്റ് ചെയ്യാൻ Waves PB മൊബൈൽ ആപ്പ് ഉപയോഗിക്കുക",
    dislike:"ഇഷ്ടമല്ല",
    rentalDescriptionMsg:"www.wavespb.comൽ നിന്നുള്ള ഉള്ളടക്കം വാങ്ങുന്നത് തുടരുക",
     "Okay, Got it":"ശരി, മനസ്സിലായി",
    Yes: "അതെ",
    Begins_on:"ഈ പരിപാടി ഇപ്പോഴും തത്സമയത്തിൽ ആകാത്തതാണ്",
    No: "ഇല്ല",
    "Referral code is empty": "റഫറൽ കോഡ് ശൂന്യമാണ്",
    "Enter a valid referral code":"ഒരു സാധുവായ റഫറൽ കോഡ് നൽകുക",
    Movies: "സിനിമകൾ",
   Audio: "ഓഡിയോ",
   Shows: "പ്രദർശനങ്ങൾ",
   Music: "സംഗീതം",
   All: "എല്ലാം",
   Live: "ലൈവ്",
   Documentary: "ഡോക്യുമെന്ററി",
   "Recently Added": "സമീപകാലത്ത് ചേർത്തത്",
   Nostalgia: "പഴയ ഓർമ്മകൾ",
   "News Features": "വാർത്താ സവിശേഷതകൾ",
   "Waves Originals": "വേവ്സ് ഓറിജിനൽസ്",
    Action: "ആക്ഷൻ",
    Kids: "കുട്ടികൾ",
    Romance: "പ്രണയം",
    Comedy: "ഹാസ്യം",
    startOver: "വീണ്ടും തുടങ്ങുക",
    Thriller: "ത്രില്ലർ", 
    Devotional: "ഭക്തി",
    Shorts: "ചെറിയ ചിത്രങ്ങൾ",
    Scan_using_app_or_mobile_camera1:
      "ആപ്പ് അല്ലെങ്കിൽ മൊബൈൽ കാമറ ഉപയോഗിച്ച് സ്കാൻ ചെയ്യുക",
    Having_Trouble_Logging_in:
      "ലോഗിൻ ചെയ്യുന്നതിൽ പ്രശ്നമാണോ? ദയവായി www.wavespb.com സന്ദർശിക്കുക",
    have_refferel_code: "നിങ്ങളുടെ কাছে റഫറൽ കോഡ് ഉണ്ടോ?",
    view_more: "കൂടുതൽ കാണുക",
    view_less: "കുറഞ്ഞത് കാണുക",
    streaming_from: "മുതൽ സ്ട്രീമിംഗ്",
    "Session-Expired": "സെഷൻ കാലഹരണപ്പെട്ടു",
    "session-desc": "നിങ്ങളുടെ സെഷൻ സമയപരിധി കഴിഞ്ഞു.",
    RentAvailable: "₹ ൽ വാടകയ്ക്ക് ലഭ്യമാണ്",
    RentMsg:
      "വാങ്ങിയ ദിവസത്തിൻ്റെ തുടക്കം മുതൽ ഈ ഉള്ളടക്കം കാണാൻ 30 ദിവസത്തെ വാടക ഉൾപ്പെടുന്നു.",
    "Error!": "പിശക്!",
    streaming_start: "സ്ട്രീമിംഗ് നിന്ന്",
    midnight: "അർധരാത്രി മുതൽ ആരംഭിക്കും",
    "Success!": "വിജയം!",
    WatchlistError:
      "വാച്ച്‌ലിസ്റ്റിലേക്ക് ചേർക്കാനായില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
    WatchlistSuccess: "വിജയകരമായി വാച്ച്‌ലിസ്റ്റിലേക്ക് ചേർത്തു.",
    GamePlay: "ഞാന്‍ എങ്ങനെ കളിക്കും?",
    PlayMsg:
      "ഈ ഗെയിം കളിക്കാനായി, ദയവായി Waves PB ആപ്പ് ഉപയോഗിക്കുക അല്ലെങ്കിൽ www.wavespb.com സന്ദർശിക്കുക.",
    "Login to Continue": "തുടരാൻ ലോഗിൻ ചെയ്യുക",
    LoginContinue:
      "ദയവായി ഞങ്ങളുടെ ആപ്പിന്റെ മുഴുവൻ ആക്സസ് ആസ്വദിക്കാൻ ലോഗിൻ ചെയ്യുക.",
    Prasar_Bharti_Mobile_App:
      "మరియు പ്രസാർ ഭാരതി മൊബൈൽ ആപ്പിൽ നിങ്ങളുടെ പ്രൊഫൈൽ തിരുത്തുക.",
    go_to_account: '"എൻറെ അക്കൗണ്ട്" പോകുക',
    clear: "ക്ലിയർ",
    del: "മായ്ക്കുക",
    RefferalCode: "റഫറൽ കോഡ്",
    referal_code: "റഫറൽ കോഡ്",
    space: "ഇടവിട",
    RefferalMsg: "ഇതിനകം രജിസ്റ്റർ ചെയ്ത നമ്പറുകൾക്ക് ഇത് ബാധകമല്ല!",
    ResuminWating: "തുടരുക",
    Live_Events: "ലൈവ് ഇവന്റ്",
    Apply: "അപ്ലൈ ചെയ്യുക",
    Live_Events: "ലൈവ് ഇവന്റ്",
    subtitle: "ഉപശീർഷകം",
    no_subtitle: "യാതൊരു ഉപശീർഷകവും ലഭ്യമല്ല",
    availableOnRent: "വാടകയ്ക്ക് ലഭ്യമാണ്",
    having_trouble_loggin_in_please_visit_our_website:
      "ലോഗിന് പ്രശ്നമുണ്ടോ? ദയവായി ഞങ്ങളുടെ വെബ്സൈറ്റില്‍ പോകുക.",
    Subscribewatch: "വാച്ച് ചെയ്യാൻ സബ്സ്ക്രൈബ്",
    SubscribeMsg:
      "ഈ ഉള്ളടക്കം കാണുന്നതിനായി, ദയവായി ഞങ്ങളുടെ വെബ്സൈറ്റ് www.wavespb.com-ല്‍ നിങ്ങളുടെ വാങ്ങല്‍ പൂര്‍ത്തിയാക്കുക.",
    Subscribelisten: "ലിസ്റ്റൻ ചെയ്യാൻ സബ്സ്ക്രൈബ്",
    available_to_rent: "റെന്റിന് ലഭ്യമാണ്",
    login_with: "ഇതുമായി ലോഗിൻ ചെയ്യുക",
    LoginToWatch: "ഇപ്പോൾ വാച്ച് ചെയ്യുക",
    get_a_new_code: "പുതിയ കോഡ് ലഭിക്കുക",
    Watchnow: "ഇപ്പോൾ വാച്ച് ചെയ്യുക",
    or: "അല്ലെങ്കിൽ",
    done: "പൂർത്തിയായി",
    proceed: "പുരോഗമിക്കുക",
    ListenToWatch: "ഇപ്പോൾ ലിസ്റ്റൻ ചെയ്യുക",
    Listennow: "ഇപ്പോൾ കേൾക്കൂ",
    Logout: "ലോഗൗട്ട്",
    left: "മുൻ്പ്",
    skip_start_browsing: "അതെ & ബ്രൌസിംഗ് ആരംഭിക്കുക",
    "Help&Support": "സഹായവും പിന്തുണയും",
    enter_mobile_number: "മൊബൈൽ നമ്പർ നേരെയാക്കുക",
    "Privacy-Policy": "പ്രൈവസി പോളിസി",
    "Term&Conditions": "ടെർംസ് ആൻഡ് കണ്ടീഷൻസ്",
    sign_in_with_mobile_or_email:
      "മൊബൈൽ അല്ലെങ്കിൽ ഇമെയിൽ ഉപയോഗിച്ച് സൈൻ ഇൻ ചെയ്യുക",
    "About-Us": "ഞങ്ങളെക്കുറിച്ച്",
    enter_your_mobile_number_or_email_to_continue:
      "തുടരുകയായി നിങ്ങളുടെ മൊബൈൽ നമ്പർ അല്ലെങ്കിൽ ഇമെയിൽ നൽകുക",
    Search_: "തിരയുക",
    "Top-Results": "ടോപ്പ് റിസൾട്ട്സ്",
    "Popular-Searches": "പോപ്പുലർ സെർച്ചെസ്",
    "Popular-Search": "ജനപ്രിയമായ തിരയലുകൾ",
    searchplaceholder:
      "ആർട്ടിസ്റ്റ്, ഷോസ്, പ്ലേലിസ്റ്റുകൾ അല്ലെങ്കിൽ കോണ്ടന്റ് തിരയുക",
    welcome_to_dds_world_of_entertainment: "ഡിഡിയുടെ വിനോദ ലോകത്തേക്ക് സ്വാഗതം",
    Home_: "ഹോം",
    Live_: "ടിവി/റേഡിയോ",
    "Delete-Account": "അക്കൗണ്ട് ഇല്ലാതാക്കുക",
    Scan_using_app_or_mobile_camera: "മൊബൈൽ ആപ്പ് ഉപയോഗിച്ച് സ്കാൻ ചെയ്യുക",
    Watchlist: "വാച്ച്‌ലിസ്റ്റ്",
    "My-Profile": "എന്റെ പ്രൊഫൈൽ",
    Edit: "എഡിറ്റ്",
    Add: "അഡ്",
    no_additional_track: "യാതൊരു അധിക ഓഡിയോ ട്രാക്കും ലഭ്യമല്ല",
    "Edit-Profile": "പ്രൊഫൈൽ എഡിറ്റുചെയ്യുക",
    "Add-Profile": "പ്രൊഫൈൽ അഡ് ചെയ്യുക",
    "Who’sWatching?": "ആർ വാച്ച് ചെയ്യുന്നു?",
    "placeholder-profile": "പ്രൊഫൈൽ പേര് എഴുതുക",
    "Kid’sprofile?": "കിഡ്സ് പ്രൊഫൈൽ?",
    "Onlyshowkid-friendlyvideos": "കിഡ്സ് ഫ്രണ്ട് ലി വീഡിയോസ് മാത്രം കാണിക്കുക",
    "No-Result-Found": "ഫലം കണ്ടെടുകി   ്ല",
    "try-other-keyword": "വേറെ കീവേർഡ് ഉപയോഗിക്കുക",
    "No-data-found": "ഡാറ്റ കണ്ടെടുകില്ല",
    "No-list-found":
      "ലിസ്റ്റ് കണ്ടെടുകില്ല. ദയവായി നിങ്ങളുടെ ഫേവറിറ്റുകൾ    ഡ് ചെയ്യുക",
    "Continue-Watching": "വാച്ച് ചെയ്യുന്നു",
    Login: "ലോഗിൻ",
    Guest: "ഗെസ്റ്റ്",
    "Login-to-your-account": "നിങ്ങളുടെ അക്കൗണ്ടിലേക്ക് ലോഗിൻ ചെയ്യുക",
    "Login-enter-no":
      "നിങ്ങളുടെ നമ്പർ എഴുതുക സിനിമകൾ, സ്പോർട്സ്, സീരീസ് എന്നിവയെക്കുറിച്ച് കണ്ടെടുക",
    "Login-enter-no-email":
      "നിങ്ങളുടെ ഇമെയിൽ എഴുതുക സിനിമകൾ, സ്പോർട്സ്, സീരീസ് എന്നിവയെക്കുറിച്ച് കണ്ടെടുക",
    "Phone-Number": "മൊബൈൽ നമ്പർ",
    "sms-verify": "നിങ്ങളുടെ മൊബൈൽ നമ്പർ വെരിഫിക്കേഷൻ ആവശ്യമാണ്",
    "email-verify": "നിങ്ങളുടെ ഇമെയിൽ വെരിഫിക്കേഷൻ ആവശ്യമാണ്",
    "Send-OTP": "ഒടിപി അയക്കുക",
    "confirm-that-agree": "നിങ്ങളുടെ സമ്മതംഉണ്ടെന്ന് സ്ഥിരീകരിക്കുക",
    "OTP-Verification": "ഒടിപി വെരിഫിക്കേഷൻ",
    "verification-code": "വെരിഫിക്കേഷൻ കോഡ് എഴുതുക",
    "not-receive-code": "കോഡ് ലഭിച്ചില്ല",
    Resend: "വീണ്ടും അയക്കുക",
    "Having-Issue?": "പ്രശ്നയുണ്ടോ?",
    "Contact-Us": "ഞങ്ങളെ സമ്പർക്കുക",
    "Enter-Phone-Number": "മൊബൈൽ നമ്പർ എഴുതുക",
    "Resend-OTP-in": "ഒടിപി വീണ്ടും അയക്കുക",
    verify: "വെരിഫിക്കേഷൻ",
    "cofirm-logout":  "നിങ്ങൾക്ക് ആപ്പിൽ നിന്ന് ലോഗ് ഔട്ട് ചെയ്യണമെന്ന് ഉറപ്പാണോ?",
    Confirm: "സ്ഥിരീകരിക്കുക",
    logout: "ലോഗൗട്ട്",
    notifications: "അറിയിപ്പുകൾ",
    registered_devices: "രജിസ്റ്റർ ചെയ്ത ഉപകരണങ്ങൾ",
    clear_search_history: "തിരയൽ ചരിത്രം ഒഴിവാക്കുക",
    subscription_and_devices: "സബ്സ്ക്രൈബർ ആൻഡ് ഉപകരണങ്ങൾ",
    subscription: "സബ്സ്ക്രൈബർ",
    my_device: "എന്റെ ഉപകരണം",
    Cancel: "റദ്ദ്",
    payment_details: "പേയ്മെന്റ് വിവരങ്ങൾ",
    other_devices: "മറ്റ് ഉപകരണങ്ങൾ",
    deregister: "ഡിറെജിസ്റ്റർ",
    "Content-Language-Changed": "കോണ്ടന്റ് ഭാഷ മാറ്റി",
    "App-Language-Changed": "ആപ്പ് ഭാഷ മാറ്റി",
    "Change-Language": "ഭാഷ മാറ്റുക",
    Previous: "മുമ്പത്തെത്",
    More: "കൂടുതൽ",
    audio_quality: "ഓഡിയോ ഗുണനിലവാരം",
    speed: "വേഗം",
    Delete: "നീക്കം ചെയ്യുക",
    Notification: "അറിയിപ്പ്",
    no_noti_found: "അറിയിപ്പ് കണ്ടെടുകില്ല",
    Artist: "കലാകാരൻ",
    just_now: "ഇപ്പോൾ",
    title_activity_purchase_history: "വാങ്ങൽ ചരിത്രം",
    first_fragment_label: "ആദ്യത്തെ ഫ്രാഗ്മെന്റ്",
    second_fragment_label: "രണ്ടാമത്തെ ഫ്രാഗ്മെന്റ്",
    Next: "അടുത്തത്",
    next_episode: "അടുത്ത എപ്പിസോഡ്",
    Download: "ഡൗൺലോഡ്",
    transaction_history: "ഇടപാട് ചരിത്രം",
    no_transaction_history: "ഇടപാട് ചരിത്രം കണ്ടെടുകില്ല",
    str_watch_list: "വാച്ച് ലിസ്റ്റ്",
    my_purchased_video: "എന്റെ വാങ്ങിയ വീഡിയോസ്",
    subscribe_: "സബ്സ്ക്രൈബ്",
    plan_price: "പ്ലാനിന്റെ വില",
    remaining_balance: "ബാലൻസ് ബാക്കി",
    total_amount: "മൊത്തം തുക",
    n_a: "എൻ.എ.",
    run_on_physical_device_only: "ഭൌതിക ഉപകരണത്തിൽ മാത്രം പ്രവർത്തിക്കുക",
    btn_ok: "ഓകെ",
    msg_vpn_error: "വിപിഎൻ പിഴവ്",
    note_your_code_will_be_updated_after_5_min:
      "നോട്ട്: നിങ്ങളുടെ കോഡ് 5 മിനിറ്റിൽ പുതിയ ആക്കും",
    payable_amount: "പേയ്മെന്റ് തുക",
    didnt_receive_otp: "ഒടിപി ലഭിച്ചില്ല",
    hello_first_fragment: "ഹലോ",
    hello_second_fragment: "പേയ്മെന്റ് വിവരങ്ങൾ",
    coming_soon: "വരുന്നു",
    packages: "പാക്കേജുകൾ",
    str_support: "പിന്തുണ",
    delete_acct: "അക്കൗണ്ട് ഇല്ലാതാക്കുക",
    delete_conform: "അക്കൗണ്ട് ഇല്ലാതാക്കാൻ ഉറപ്പാണോ?",
    delete_profile_success: "പ്രൊഫൈൽ വിജയകരമായി നീക്കം ചെയ്തു",
    Dlt_Accnt_msg: "അക്കൗണ്ട് ഇല്ലാതാക്കൽ സന്ദേശം",
    some_error_occurred_please_try_again:
      "ചില പിഴവുകൾ സംഭവിച്ചു. ദയവായി വീണ്ടും പ്രയത്നിക്കുക",
    auto: "ഓട്ടോ",
    player_not_ready_try_again:
      "പ്ലേയർ തയ്യാറായില്ല. ദയവായി വീണ്ടും പ്രയത്നിക്കുക",
    edit_profile: "പ്രൊഫൈൽ എഡിറ്റ് ചെയ്യുക",
    learn_more: "കൂടുതൽ അറിയുക",
    wishlist: "ആഗ്രഹസൂചിക",
    category_name: "വിഭാഗം",
    str_my_download: "എന്റെ ഡൗൺലോഡുകൾ",
    language: "ഭാഷ",
    added_watch_list: "വാച്ച് ലിസ്റ്റിൽ ചേർക്കപ്പെട്ടു",
    removed_watch_list: "വാച്ച് ലിസ്റ്റിൽ നിന്ന് നീക്കപ്പെട്ടു",
    viewall: "എല്ലാം കാണുക",
    msg_video_expired: "ഈ വീഡിയോ കാലഹരണപ്പെട്ടു. വീണ്ടും വാങ്ങി കാണുക",
    skip_intro: "ഇന്റ്രോ ഒഴിവാക്കുക",
    settings: "സെറ്റിംഗുകൾ",
    video_quality: "വീഡിയോ ഗുണനിലവാരം",
    video_speed: "വീഡിയോ വേഗത",
    like: "ഇഷ്ടപ്പെടുന്നു",
    unlike: "ഇഷ്ടപ്പെടാത്തത്",
    refund: "തിരുത്തുക",
    userProfile: "ഉപയോക്താവ് പ്രൊഫൈൽ",
    signup_create_new_account: "സിന്യാസ്: നേരെയാണ് ഒരു അക്കൗണ്ട് സൃഷ്ടിക്കുക",
    already_acc_login: "ഈശ്വരമായി ഒരു അക്കൗണ്ട് ഉള്ളേ? ലോഗിൻ",
    accept_terms_and_condition: "തുല്യനിയമങ്ങൾ സ്വീകരിക്കുക",
    new_password: "പുതിയ പാസ്വേർഡ്",
    api_failure_msg: "API തന്ത്രം",
    remove_profile_pic: "പ്രൊഫൈൽ ഫോട്ടോ നീക്കം",
    remove: "നീക്കം",
    msg_remove_profile_pic: "പ്രൊഫൈൽ ഫോട്ടോ നീക്കം സ്ഥിരീകരിക്കുക",
    profile_photo: "പ്രൊഫൈൽ ഫോട്ടോ",
    purchased_video: "വാങ്ങിയ വീഡിയോ",
    upgrade: "അഗ്രദാനം",
    msg_send_otp: "ഒടിപി അയയ്ക്കുക",
    forgot_your_password: "പാസ്വേർഡ് നമ്മുടിയാണോ?",
    msg_search_content: "തിരയുക",
    current_plan: "പരസ്യത പ്ലാൻ",
    more_like_this: "ഇതിന്റെ പരിശോധനങ്ങൾ",
    download_channel_id: "ഡൗൺലോഡ് ചാൻനൽ ഐ.ഡി.",
    download_video_service_channel: "വീഡിയോ ഡൗൺലോഡ് സേവ       ചാൻനൽ",
    searchLikehotStar: "ഡൗൺലോഡ് അയയ്ക്കുന്നതിന്റെ അയയ്ക്കുന്ന ചാൻനൽ",
    don_t_have_an_account: "അക്കൗണ്ട് ഉള്ളത് ഇല്ല?",
    delete_video: "വീഡിയോ നീക്കം",
    sign_up: "സമര്പ്യമാണോ",
    having_forget_password: "പാസ്വേർഡ് നമ്മുടിയാണോ?",
    complete_profile: "പൂർണ്ണ പ്രൊഫൈൽ ചേർക്കുക",
    add_profile: "പ്രൊഫൈൽ ചേർക്കുക",
    wait_to_play_video: "വീഡിയോ പ്രയോഗിക്കുക പൂർണ്ണമാക്കുക",
    buy_now_at: "ഇപ്പോൾ വാങ്ങുക ഇവിടെ",
    upgrade_now_at: "ഇപ്പോൾ അഗ്രദാനം ഇവിടെ",
    new_text: "പുതിയ ടെക്സ്റ്റ്",
    rate_app_title: "തിരയുക",
    rate_app_message:
      "മനസ്സിലാക്കുന്നതിന് നമ്മുടെ അപ്പിൽ തിരയുകയാണെങ്കിൽ പ്ലേയ് സ്റ്റോർഡിൽ തിരയുകയാണെങ്കിൽ നമ്മുടെ സുപർശകത്തിനു നമ്മുടെ സഹായത്തിനു ധന്യവാദം",
    rate_btn_pos: "തിരയുക",
    rate_btn_neg: "മാത്രമേ പുനഃപ്രശ്നമാക്കുക",
    rate_btn_nut: "അവശ്യമാണ്",
    change_name: "പേര് മാറിക്കുക",
    download_options: "ഡൗൺലോഡ് വിവരങ്ങൾ",
    low_quality: "നിലവാരം",
    medium_quality: "മധ്യമവാരം",
    high_quality: "ഉത്തമവാരം",
    downloading: "ഡൗൺലോഡിന്റെ പ്രവർത്തനം",
    download_pause: "ഡൗൺലോഡ് നിലവർക്കുക",
    downloaded: "ഡൗൺലോഡ് ചെയ്തു",
    download_url_is_not_found: "ഡൗൺലോഡ് URL നേരും പേയ്യുന്നില്ല",
    download_running: "ഡൗൺലോഡ് പ്രവർത്തിക്കുന്നു",
    no_plan_subscribed: "പ്ലാൻ സബ്സ്ക്രൈബ് ചെയ്തില്ല",
    privacypolicy: "പ്രവത്തിനിയമങ്ങൾ",
    termsuse: "സേവനത്തിന്റെ തുല്യനിയമങ്ങൾ",
    resendotp_in: "ഒടിപി വീണ്ടും അയയ്ക്കുക (ലോഗിൻ നേരും അവശ്യമാണ്)",
    login_required: "ലോഗിൻ അവശ്യമാണ്",
    sorry_we_couldn_t_complete_your_request_please_try_again_in_a_moment:
      "നമുക്ക് താങ്കളുടെ അനുരൂപ       പൂർത്തിക്കുന്നതിന് സാധിക്കാൻ പുതിയതായി പ്രയത്നിക്കുക",
    trailer: "ട്രേയിൾ",
    subscribe_now_to_watch: "വാച്ച് ചെയ്യാൻ ഇപ്പോൾ സബ്സ്ക്രൈബ് ചെയ്യുക",
    app_version: "അപ്പ് വെര്ഷൻ",
    select_all: "എല്ലാവർക്ക് തിരഞ്ഞെടുക്കുക",
    please_enter_valid_name:
      "വേണ്ടി ഒരു മറ്റുണ്ടായിരിക്കുന്ന പേര് നേരും പോകുക",
    choose_avatar: "ദയവായി അവതാർ തിരഞ്ഞെടുക്കുക",
    enter_name: "ദയവായി പേര് നൽകുക",
    unselect_all: "എല്ലാവർക്ക് തിരഞ്ഞെടുക്കുക",
    enter_mobile_number: "മൊബൈൽ നമ്പർ നേരും പോകുക",
    title_activity_scan_qr_code: "QR കോഡ് സ്കാൻ ചെയ്യുക",
    plz_enter_name: "പേര് നേരും പോകുക",
    plz_change_name: "പേര് മാറിക്കുക",
    plz_choose_avtar: "അവതാർ തിരഞ്ഞെടുക്കുക",
    plz_select_profile: "പ്രൊഫൈൽ തിരഞ്ഞെടുക്കുക",
    who_s_watching: "വാച്ച് ചെയ്യുന്നു",
    my_profile: "എന്റെ പ്രൊഫൈൽ",
    profiles: "പ്രൊഫൈൽസ്",
    clear: "നിഷ്ടത്തുക",
    recent_searches: "ക്രൈ   ്റ്റ് തിരയുകളുടെ പേര്",
    Recommended_searches: "തുല്യനിയമങ്ങൾ",
    please_enter_your_number_to_discover_a_variety_nof_movies_sports_series:
      "മൊബൈൽ നമ്പർ നേരും പോകുക സിനിമകൾ, ക്രീഡയും, സീരിയും പ്രതിഭാവിക്കുന്ന വസ്തുക്കളുടെ പൊതുവിധം കണ്ടെത്തുക",
    mobile_number: "മൊബൈൽ നമ്പർ",
    having_issue_contact_us: "പ്രശ്നയുണ്ടോ? നമുക്ക് താങ്കളുടെ സഹായം നേരെ പോകുക",
    didn_t_receive_code_resend: "കോഡ് ലഭിച്ചില്ല? പുനഃപറയുക",
    enter_the_verification_code_we_just_sent_to_your_number:
      "നിങ്ങളുടെ നമ്പർും നേരും പോകുന്ന വെരിഫിക്കേഷൻ കോഡ് നേരും പോകുക",
    incorrect_otp_entered_please_enter_again:
      "തെറ്റായ ഒടിപി നൽകി. വീണ്ടും നൽകുക",
    app_update_title: "അപ്പ് അപ്ഡേറ്റ്",
    app_update_msg: "അപ്പിന്റെ പുതിയ പതിപ്പ് ഇപ്പോൾ ലഭ്യമാണ്",
    watch_now: "ഇപ്പോൾ വാച്ച് ചെയ്യുക",
    my_list: "എന്റെ ലിസ്റ്റ്",
    cast_and_crew: "കാസ്റ്റ്&ക്രൂ",
    similar_to_this: "ഇതിനോട് സമാനമായ",
    similar_channels: "സമാനമായ ചാനലുകൾ",
    delete_account: "അക്കൗണ്ട് ഇല്ലാതാക്കുക",
    delete_account_desc: "നിങ്ങളുടെ അക്കൗണ്ട് നീക്കം ചെയ്യണമെന്ന് ഉറപ്പാണോ",
    delete_conform: "പ്രൊഫൈൽ?",
    log_out: "ലോഗ് ഔട്ട്",
    log_out_desc: "നിങ്ങളു‍് ഈ അക്കൗണ്ടിൽ നിന്ന് ലോഗ് ഔട്ട് ചെയ്യണോ?",
    pb_on_tv: "ടിവിയിൽ പ്രസാർ ഭാരതി ഉപയോഗിക്കുക",
    link_device: "ഒരു ഉപകരണത്തിലേക്ക് കൂട്ടിക്കൊണ്ടുകൂടുക",
    linked_tv: "ലിങ്ക് ചെയ്ത ടിവി",
    link_with_tv: "നിങ്ങളുടെ ടിവിയിലേക്ക് കൂട്ടിക്കൊണ്ടുകൂടുകയാണോ?",
    no_result_found: "ഫലം കണ്ടെത്തിയില്ല",
    search_again: "വീണ്ടും തിരയുക",
    no_list_found: "ലിസ്റ്റ് കണ്ടെത്തിയില്ല",
    no_list_found_desc:
      "ലിസ്റ്റ് കണ്ടെത്തിയില്ല, ദയവായി നിങ്ങളുടെ ഇഷ്ട് വിവരങ്ങൾ പുറത്തുവിടുക",
    no_notifications: "അറിയിപ്പ് ഉണ്ടായില്ല",
    no_notifications_desc: "അറിയിപ്പ് ഉണ്ടായില്ല. ദയവായി വീണ്ടും തുറന്നു",
    network_error: "റിറ്റ് പിഡിറ്റർ തന്ത്രം",
    retry: "പുനഃപ്രയത്നിക്കുക",
    open_setting: "സെറ്റിംഗ് ഓപ്പൺ ചെയ്യുക",
    internal_server: "അന്തരിച്ചു സേവാസംഭവം",
    internal_server_error:
      "താങ്കളുടെ അനുരൂപണം പ്രവർത്തിക്കുന്നതിന് സാധിക്കാൻ പുതിയതായി പ്രയത്നിക്കുക",
    go_back: "പുറത്തു മുൻഭവിക്കുക",
    data_not_found: "ഡാറ്റ കണ്ടെത്തിയില്ല",
    page_not_found_desc: "താങ്കളുടെ നേടുന്ന പേജ് ഉള്ളതാണ്",
    popular_search: "പൊപ്പുൾര് തിരയുക",
    top_results: "ടോപ് ഫലങ്ങൾ",
    guest_user: "ഗെസ്റ്റ് ഉപയോക്താവ്",
    channels: "ചാൻനൽ",
    Radio: "റേഡിയോ",
    TV: "ടിവി",
    favorites: "പ്രിയപ്പെട്ടുകൾ",
    content_language: "സംവിധാന ഭാഷ",
    app_language: "അപ്പ് ഭാഷ",
    change_account: "പ്രൊഫൈൽ മാറ്റുക",
    move_account: "നിങ്ങളുടെ മറ്റൊരു പ്രൊഫൈലിലേക്ക് മാറ്റണമോ?",
    update_profile: "നിങ്ങളുടെ പ്രൊഫൈൽ വിജയകരമായി അപ്‌ഡേറ്റ് ചെയ്തു",
    added_profile: "നിങ്ങളുടെ പ്രൊഫൈൽ വിജയകരമായി ചേർത്തു",
    edit_update: "അപ്‌ഡേറ്റ് ചെയ്യുക",
    cast_crew: "കാസ്റ്റ്&ക്രൂ",
    episodes: "എപ്പിസോഡ്",
    no_record: "റെക്കോർഡ് കണ്ടെത്തിയില്ല",
    free_time_up: "സ്വതന്ത്ര സമയം മുക്തമായി!",
    free_create_account:
      "ദയവായി ഒരു സ്വതന്ത്ര അക്കൗണ്ട് സൃഷ്ടിക്കുക അല്ലെങ്കിൽ പ്രവേശിക്കുക വാച്ച് തുടരാൻ.",
    adventure: "അന്വേഷണം",
    prasar_bharti: "പ്രസാർ ഭാരതി",
    ind_broadcast: "(ഇന്ത്യയുടെ പബ്ലിക് സർവീസ് ബ്രോഡ്കാസ്റ്റർ)",
    back_to_home: "ഹോം പേജിലേക്ക് തിരിക്കുക",
    oops_page_not_found: "അപ്പോൾ പേജ് കണ്ടെത്തിയില്ല",
    page_looking: "താങ്കളുടെ തിരയുന്ന പേജ് ഉണ്ടായിട്ടില്ല",
    go_to_home: "ഹോം പേജിലേക്ക് പോകുക",
    popular_genres: "പൊപ്പുലർ ജാന്റുകൾ",
    watchLanguage: "നിങ്ങളുടെ ഭാഷയിൽ വാച്ച് ചെയ്യുക",
    help_support: "സഹായം നൽകുക",
    customer_support: "കസ്റ്റമർ സപ്പോർട്ട്",
    contact_number: "കോൺടാക്ട് നമ്പർ",
    email_address: "ഇമെയിൽ ചിഹ്നം",
    share: "സഹായിക്കുക",
    copy: "നുകരുത്തുക",
    copied: "നുകരുത്തിയിരിക്കുന്നു",
    bharat_ott: "ഭാരത് ഓട്ടി",
    Home_: "ഹോം",
    policy: "റിഫുൻഡ് മുതലായിരിക്കുന്ന തന്ത്രം നിയമങ്ങൾ",
    terms_condition: "തുല്യനിയമങ്ങൾ മുതലായിരിക്കുന്നു",
    your_account: "നിങ്ങളുടെ അക്കൗണ്ട് ഉണ്ടായില്ല?",
    continue: "തുടങ്ങിയും",
    "login_here!": "ലോഗിൻ ഇവിടെ!",
    mobile: "മൊബൈൽ",
    password: "പാസ്വേർഡ്",
    forgot_password: "പാസ്വേർഡ് നമ്മുടിയാണോ?",
    sign_up_here: "സൈൻ അപ്പ് ഇവിടെ!",
    social_media: "സോഷ്യൽ മീഡിയ വൃത്തിയിൽ പുതുക്കുക",
    search_data: "തിരയുക ഡാറ്റ",
    description: "വിവരണം",
    episode_name: "എപ്പിസോഡ് പേര്",
    episode_num: "എപ്പിസോഡ് നുമ്പർ",
    page_looking_might:
      "നിങ്ങൾ തേടുന്ന പേജ് നീക്കിയേക്കാം, പേര് മാറ്റിയേക്കാം, അല്ലെങ്കിൽ താൽക്കാലികമായി ലഭ്യമല്ലാത്തതാകാം.",
    Ok: "ഓകെ",
    otp_sent: "OTP വിജയകരമായി അയച്ചു",
    success: "വിജയം",
    could_not_sent: "OTP അയക്കാൻ കഴിഞ്ഞില്ല",
    error: "പിഴവ്",
    resent_otp: "OTP വിജയകരമായി അയച്ചു",
    enter_valid_otp: "സാധുവായ OTP ഇടുക",
    enter_six_digit_valid: "6 അക്കങ്ങളുള്ള സാധുവായ OTP ഇടുക",
    profile_creation: "പ്രൊഫൈൽ വിജയകരമായി സൃഷ്ടിച്ചു",
    error_name: "പ്രൊഫൈൽ പേര് ഇടുക",
    "Delete-Profile": "പ്രൊഫൈൽ ഇല്ലാതാക്കുക",
    add_to_watchlist: "വാച്ച് ലിസ്റ്റിൽ ചേർക്കുക",
    added_to_watchlist: "വാച്ച് ലിസ്റ്റിൽ ചേർത്തു",
    like_it: "ഇത് ഇഷ്ടമാണ്",
    not_for_me: "എനിക്ക് ഇത് ഇഷ്ടമല്ല",
    "n-number": "നമ്പർ",
    "e-email": "ഇമെയിൽ",
    "account-subscribe": "ഇപ്പോൾ സബ്സ്ക്രൈബ് ചെയ്യുക",
    "account-subscribe-upgrade": "ഇപ്പോൾ അപ്ഗ്രേഡ് ചെയ്യുക",
    "user-details-text": "ഉപയോക്തൃ വിവരങ്ങൾ",
    "acc-username": "ഉപയോക്തൃ പേര്",
    "acc-enterusername": "ഉപയോക്തൃ പേര് ഇടുക",
    "acc-mobile": "മൊബൈൽ നമ്പർ",
    "acc-entermobile": "മൊബൈൽ നമ്പർ ഇടുക",
    "acc-email": "ഇമെയിൽ ചോദ്യമായുള്ള വിലാസം",
    "acc-enteremail": "ഇമെയിൽ വിലാസം ഇടുക",
    "acc-Gender": "ജന്മസമയം",
    "acc-Gender1": "പുരുഷന്",
    "acc-Gender2": "മഹിലാ",
    "acc-Gender3": "അन്യന്",
    "acc-dob": "ജനന തീയതി",
    "acc-save": "തുറക്കുക",
    "my-account": "മയ ഖാത",
    "trans-history": "തുറക്കമണ്ഡലം",
    "acc-varified": "തുറക്കുന്നു",
    "network-error": "രീതിയിൽ കുറച്ചുകൊള്ളുന്ന തുടങ്ങിനുള്ള പിഴവ്",
    "network-unable":
      "ഇന്തർനെറ്റ് കേസം ചെയ്യാൻ അനുമതിക്കുന്നതിനു നിമിത്തം ഇന്തർനെറ്റ് കേസം നല്കുന്നതില്ല",
    "network-retry": "പുനഃപ്രയോഗിച്ചുകൊള്ളുക",
    "download-apps": "അമ്പുകളും ഡൗൺലോഡ് ചെയ്യുക",
    "PB-OTT": "PB OTT",
    "copy-right": "കോപ്യർറ്റ്",
    all_right: "എല്ലാ റൈറ്റ്സ് പേരും പേരുന്നു.",
    versions: "വർഷനം-",
    "Help-Support": "സഹായം സൂപർറ്റ്",
    "internet-connection": "ഇന്തർനെറ്റ് കേസം",
    "nointernet-connection": "ഇന്തർനെറ്റ് കേസം ഇല്ല",
    "Terms-and-Conditions": "നിബന്ധനകളും അവസ്ഥകളും",
    "Help-&-Support": "സഹായം & സൂപർട്ട്",
    "unmute-tra": "ട്രെയിലർ അൺമ്യൂട്ട്",
    "mute-tra": "ട്രെയിലർ മ്യൂട്ട്",
    favourite_lang: "ഇഷ്ടഭാഷ ചേർക്കുക",
    added_lang: "ചേർത്തു",
    "no-notfication": "അറിയിപ്പുകളില്ല",
    "notfication-dt": "അറിയിപ്പുകളില്ല. പിന്നീട് വരുക.",
    or: "അല്ലെങ്കിൽ",
    and: "ഉം",
    sahmat: "",
    "par-bheje": " ",
    "server-error": "സെർവർ പിഴവ്",
    "server-error-msg":
      "നിങ്ങളുടെ അപേക്ഷ പ്രൊസസ്സിങ്ങിൽ ഒരു സെർവർ പിഴവ് ഉണ്ടായി.",
    "server-retry": "ഹോംപേജിലേക്ക് പോകുക",
    "watch-lang": "നിങ്ങളുടെ ഭാഷയിൽ കാണുക",
    "popular-genre": "ജനപ്രിയ വിഭാഗങ്ങൾ",
    subscription_heading:
      "PB OTT ൽ എല്ലാ ഉള്ളടക്കങ്ങളും കാണുന്നതിന് സബ്സ്ക്രൈബ് ചെയ്യുക",
    add: "ചേർക്കുക",
    proceed_to_pay_btn: "പേയ്മെന്റിന് പോകുക",
    have_promo: "പ്രൊമോ കോഡ് ഉണ്ടോ?",
    promo_code: "പ്രൊമോ കോഡ്",
    enter_promo_code: "പ്രൊമോ കോഡ് ഇടുക",
    apply_code_btn: "കോഡ് പ്രയോഗിക്കുക",
    select_live_channel_radio: "ലൈവ് ചാനൽ & റേഡിയോ തെരഞ്ഞെടുക്കുക",
    radio_channels: "റേഡിയോ ചാനലുകൾ",
    submit_btn: "സമർപ്പിക്കുക",
    add_channel_radio: "ടിവി ചാനൽ & റേഡിയോ ചേർക്കുക",
    live_tv_channels: "ലൈവ് ടിവി ചാനലുകൾ",
    live_radio_channels: "ലൈവ് റേഡിയോ ചാനലുകൾ",
    upgrade_subscription: "സബ്സ്ക്രൈബ് അപ്ഗ്രേഡ് ചെയ്യുക",
    you_pay: "നിങ്ങൾ പേയ്മെന്റ് ചെയ്യുന്നു",
    rem_amt_curr_plan: "നിലവിലുള്ള പ്ലാനിൽ ബാക്കി ഉള്ള തുക",
    payble_amt: "പേയ്മെന്റ് ചെയ്യേണ്ട തുക",
    live_channel: "ലൈവ് ചാനൽ",
    continue_watching: "കാണുന്നത് തുടരുക",
    Exit: "പുറത്തുകടക്കുക",
    ExitMsg: "നിങ്ങൾക്ക് ഉറപ്പായും ആപ്പ് മുതൽ പുറത്തെക്ക് പോകണമെന്നുണ്ടോ?",
  },
  Kannada: {
    "no_data_found":"ಯಾವುದೇ ಡೇಟಾ ಕಂಡುಬಂದಿಲ್ಲ",
    "Subscribe to watch":"ಈಗಲೇ ವೀಕ್ಷಿಸಲು ಚಂದಾದಾರರಾಗಿ",
     "Drama": "ನಾಟಕ",
  "Tracks": "ಟ್ರ್ಯಾಕ್ಸ್",
  "Romance": "ಪ್ರೇಮ",
  "Fantasy": "ಫ್ಯಾಂಟಸಿ",
  "Contemporary Fiction": "ಆಧುನಿಕ ಕಾದಂಬರಿ",
  "History": "ಇತಿಹಾಸ",
  "Mystery": "ರಹಸ್ಯ",
  "Wildlife": "ವನ್ಯಜೀವಿ",
  "Thriller": "ರೋಮಾಂಚಕ",
  "Horror": "ಭಯಾನಕ",
  "Educational": "ಶೈಕ್ಷಣಿಕ",
   "Recent Live": "ಇತ್ತೀಚಿನ ಲೈವ್",
  "Health": "ಆರೋಗ್ಯ",
  "Biography": "ಜೀವನಚರಿತ್ರೆ",
  "Musical Drama": "ಸಂಗೀತ ನಾಟಕ",
  "Music & Dance": "ಸಂಗೀತ ಮತ್ತು ನೃತ್ಯ",
  "Dance Drama": "ನೃತ್ಯ ನಾಟಕ",
  "Music": "ಸಂಗೀತ",
  "Sports": "ಕ್ರೀಡೆ",
  "Adventure": "ಸಾಹಸ",
  "Animation": "ಆನಿಮೇಷನ್",
  "Literature": "ಸಾಹಿತ್ಯ",
  "Arts & Culture": "ಕಲೆ ಮತ್ತು ಸಂಸ್ಕೃತಿ",
  "Religious": "ಧಾರ್ಮಿಕ",
  "Crime": "ಅಪರಾಧ",
  "War": "ಯುದ್ಧ",
  "Rom-Com": "ರಾಮ್-ಕಾಮ್",
  "Spiritual": "ಆಧ್ಯಾತ್ಮಿಕ",
  "Detective": "ಡಿಟೆಕ್ಟಿವ್",
  "Mythology": "ಪುರಾಣ",
  "Entertainment": "ಮನರಂಜನೆ",
  "Historical Fiction": "ಇತಿಹಾಸಕ ಕಾದಂಬರಿ",
  "Political": "ರಾಜಕೀಯ",
  "Classical Music": "ಶಾಸ್ತ್ರೀಯ ಸಂಗೀತ",
  "Comedy": "ಹಾಸ್ಯ",
  "Carnatic Music": "ಕರ್ನಾಟಿಕ್ ಸಂಗೀತ",
"Finance": "ಹಣಕಾಸು",
"Hobbies And Crafts": "ಹವ್ಯಾಸಗಳು ಮತ್ತು ಕರಕುಶಲ",
"Business and Finance": "ವ್ಯಾಪಾರ ಮತ್ತು ಹಣಕಾಸು",
"Industrial design": "ಕೈಗಾರಿಕಾ ವಿನ್ಯಾಸ",
  "Survival": "ಸರ್ವೈವಲ್",
  "Satire": "ವ್ಯಂಗ್ಯ",
  "Humor": "ಮನರಂಜನಾತ್ಮಕ ಹಾಸ್ಯ",
  "Autobiography": "ಆತ್ಮಚರಿತ್ರೆ",
  "Lifestyle": "ಜೀವನ ಶೈಲಿ",
  "Kids & Family": "ಮಕ್ಕಳು ಮತ್ತು ಕುಟುಂಬ",
  "Devotional": "ಭಕ್ತಿಪರ",
  "Nature & Wildlife": "ಪ್ರಕೃತಿ ಮತ್ತು ವನ್ಯಜೀವಿ",
  "Travelogue": "ಪ್ರಯಾಣಕಥನ",
  "Folk Music": "ಜನಪದ ಸಂಗೀತ",
  "Storytelling": "ಕಥೆ ಹೇಳಿಕೆ",
  "Dance": "ನೃತ್ಯ",
  "Talk Shows": "ಟಾಕ್ ಶೋಗಳು",
  "Inspirational": "ಪ್ರೇರಣಾದಾಯಕ",
  "Reality": "ರಿಯಾಲಿಟಿ",
  "Action": "ಆಕ್ಷನ್",
  "Agriculture": "ಕೃಷಿ",
  "International": "ಅಂತರರಾಷ್ಟ್ರೀಯ",
  "Anime": "ಅನಿಮೆ",
  "Period Drama": "ಐತಿಹಾಸಿಕ ನಾಟಕ",
  "Sci-Fi": "ವೈಜ್ಞಾನಿಕ ಕಲ್ಪನೆ",
  "Patriotic": "ದೇಶಭಕ್ತಿ",
  "Performing Arts": "ಪ್ರದರ್ಶನ ಕಲೆಗಳು",
  "Astrology": "ಜ್ಯೋತಿಷ್ಯ",
  "Fashion": "ಫ್ಯಾಷನ್",
  "Talent Hunt": "ಪ್ರತಿಭೆ ಹುಡುಕಾಟ",
  "Cookery": "ಅಡುಗೆ",
  "Talk Show": "ಟಾಕ್ ಶೋ",
  "Superhero": "ಸೂಪರ್ ಹೀರೋ",
  "Literary Fiction": "ಸಾಹಿತ್ಯ ಕಾದಂಬರಿ",
  "Science": "ವಿಜ್ಞಾನ",
  "Scientific": "ವೈಜ್ಞಾನಿಕ",
  "Cooking": "ಅಡುಗೆ",
  "Food": "ಆಹಾರ",
  "Travel": "ಪ್ರಯಾಣ",
  "Science Fiction": "ವೈಜ್ಞಾನಿಕ ಕಲ್ಪನೆ",
  "Paintings": "ಚಿತ್ರಗಳು",
  "Design": "ವಿನ್ಯಾಸ",
  "Art": "ಕಲೆ",
  "Nature": "ಪ್ರಕೃತಿ",
  "Arts And Culture": "ಕಲೆ ಮತ್ತು ಸಂಸ್ಕೃತಿ",
  "Educational Books": "ಶೈಕ್ಷಣಿಕ ಪುಸ್ತಕಗಳು",
  "Young Adult Fiction": "ಯುವ ಕಾದಂಬರಿ",
  "News": "ಸುದ್ದಿ",
  "Technology": "ತಂತ್ರಜ್ಞಾನ",
  "Open World": "ಮುಕ್ತ ಜಗತ್ತು",
  "Business": "ವ್ಯಾಪಾರ",
  "Home Decor": "ಮನೆ ಅಲಂಕಾರ",
  "Chat Show": "ಚಾಟ್ ಶೋ",
  "Edutainment": "ಶಿಕ್ಷಣ ಮನರಂಜನೆ",
  "Social Awareness": "ಸಾಮಾಜಿಕ ಜಾಗೃತಿ",
  "Event": "ಕಾರ್ಯಕ್ರಮ",
  "Hindustani Classical Music": "ಹಿಂದೂಸ್ತಾನಿ ಶಾಸ್ತ್ರೀಯ ಸಂಗೀತ",
  "Semi-Classical Music": "ಅರ್ಧ ಶಾಸ್ತ್ರೀಯ ಸಂಗೀತ",
  "Kids": "ಮಕ್ಕಳು",
  "Celebration": "ಆಚರಣೆ",
  "Casual": "ಸಾಮಾನ್ಯ",
  "Medical": "ವೈದ್ಯಕೀಯ",
  "Yojna": "ಯೋಜನೆ",
  "Sculptures": "ಶಿಲ್ಪಗಳು",
  "Carbatic Music": "ಕರ್ಣಾಟಿಕ್ ಸಂಗೀತ",
  "Digital Literacy": "ಡಿಜಿಟಲ್ ಸಾಕ್ಷರತೆ",
  "Legal And Ethical": "ಕಾನೂನು ಮತ್ತು ನೈತಿಕ",
  "Digital art": "ಡಿಜಿಟಲ್ ಕಲೆ",
  "Parenting": "ಪೋಷಣೆ",
    Sports:"ಕ್ರೀಡೆ",
            inviteReferr:"ನಿಮ್ಮ ಸ್ನೇಹಿತನನ್ನು ಈ ಅನುಭವಕ್ಕೆ ಸೇರಿಸಲು ಆಹ್ವಾನಿಸಿ",
     refer_friend:"ಸ್ನೇಹಿತರನ್ನು ಆಹ್ವಾನಿಸಿ",
    Left:"ಬಾಕಿ ಇದೆ",
    Begins_on:"ಈ ಕಾರ್ಯಕ್ರಮ ಇನ್ನೂ ಲೈವ್ ಆಗಿಲ್ಲ",
    "pbApp":"ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಲು Waves PB ಮೊಬೈಲ್ ಆ್ಯಪ್ ಬಳಸಿ",
    dislike:"ನಾಪಸಂದ",
    rentalDescriptionMsg:"www.wavespb.com ನಿಂದ ವಿಷಯವನ್ನು ಖರೀದಿಸುವುದನ್ನು ಮುಂದುವರಿಸಿ",
     "Okay, Got it":"ಸರಿ, ಅರ್ಥವಾಯಿತು",
    Yes: "ಹೌದು",
    No: "ಇಲ್ಲ",
    "Referral code is empty": "ರೆಫರಲ್ ಕೋಡ್ ಖಾಲಿಯಾಗಿದೆ",
    "Enter a valid referral code": "ಮಾನ್ಯವಾದ ರೆಫರಲ್ ಕೋಡ್ ನಮೂದಿಸಿ",
    Movies: "ಚಿತ್ರಗಳು",
    Audio: "ಆಡಿಯೋ",
   Shows: "ಕಾರ್ಯಕ್ರಮಗಳು",
   Music: "ಸಂಗೀತ",
   All: "ಎಲ್ಲಾ",
   Live: "ಲೈವ್",
   Documentary: "ಡಾಕ್ಯುಮೆಂಟರಿ",
   "Recently Added": "ಇತ್ತೀಚೆಗೆ ಸೇರಿಸಲಾಗಿದೆ",
   Nostalgia: "ಹಳೆಯ ನೆನಪುಗಳು",
    "News Features": "ಸುದ್ದಿ ವೈಶಿಷ್ಟ್ಯಗಳು",
    "Waves Originals": "ವೇವ್ಸ್ ಒರಿಜಿನಲ್ಸ್",
    Action: "ಕ್ರಿಯೆ",
    Kids: "ಮಕ್ಕಳು",
    Romance: "ರೊಮ್ಯಾಂಸ್",
    Comedy: "ಹಾಸ್ಯ",
    startOver: "ಮತ್ತೆ ಪ್ರಾರಂಭಿಸಿ",
    Thriller: "ಥ್ರಿಲ್ಲರ್",
    Live_Events: "லைವ್ ಇವೆಂಟ್" ,
    Devotional: "ಭಕ್ತಿ",
    Shorts: "ಸಣ್ಣ ಚಿತ್ರಗಳು",
    Scan_using_app_or_mobile_camera1:
      "ಅಪ್ಲಿಕೇಶನ್ ಅಥವಾ ಮೊಬೈಲ್ ಕ್ಯಾಮೆರಾ ಬಳಸಿ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ",
    Having_Trouble_Logging_in:
      "ಲಾಗಿನ್ ಮಾಡಲು ತೊಂದರೆ ಇದೆಯೇ? ದಯವಿಟ್ಟು www.wavespb.com ಗೆ ಭೇಟಿ ನೀಡಿ",
    have_refferel_code: "ನಿಮಗೆ ಪರಿಚಯ ಕೋಡ್ ಇದೆಯೆ?",
    view_more: "ಇನ್ನಷ್ಟು ವೀಕ್ಷಿಸಿ",
    view_less: "ಕಡಿಮೆ ವೀಕ್ಷಿಸಿ",
    streaming_from: "ಇಂದ ಸ್ಟ್ರೀಮಿಂಗ್",
    "Session-Expired": "ಅಧಿವೇಶನ ಮುಕ್ತಾಯವಾಗಿದೆ",
    "session-desc": "ನಿಮ್ಮ ಸೆಷನ್ ಅವಧಿ ಕೊನೆಗೊಂಡಿದೆ.",
    RentAvailable: "₹ ಗೆ ಬಾಡಿಗೆಗೆ ಲಭ್ಯವಿದೆ",
    RentMsg:
      "ಖರೀದಿದಿನದಿಂದ ಈ ವಿಷಯವನ್ನು ವೀಕ್ಷಿಸಲು 30 ದಿನಗಳ ಬಾಡಿಗೆ ಒಳಗೊಂಡಿರುತ್ತದೆ.",
    "Error!": "ದೋಷ!",
    "Success!": "ಯಶಸ್ಸು!",
    streaming_start: "ಸ್ಟ್ರೀಮಿಂಗ್ ರಿಂದ",
    midnight: "ಮಧ್ಯರಾತ್ರಿಯಿಂದ ಪ್ರಾರಂಭವಾಗುತ್ತದೆ",
    WatchlistError: "ವಾಚ್‌ಲಿಸ್ಟ್‌ಗೆ ಸೇರಿಸಲಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
    WatchlistSuccess: "ವಾಚ್‌ಲಿಸ್ಟ್‌ಗೆ ಯಶಸ್ವಿಯಾಗಿ ಸೇರಿಸಲಾಗಿದೆ.",
    GamePlay: "ನಾನು ಹೇಗೆ ಆಡಬಹುದು?",
    PlayMsg:
      "ಈ ಆಟವನ್ನು ಆಡುವುದಕ್ಕೆ, ದಯವಿಟ್ಟು Waves PB ಅಪ್ಲಿಕೇಶನ್ ಬಳಸಿ ಅಥವಾ www.wavespb.com ಗೆ ಹೋಗಿ.",
    "Login to Continue": "ಮುಂದುವರಿಯಲು ಲಾಗಿನ್ ಮಾಡಿ",
    LoginContinue:
      "ದಯವಿಟ್ಟು ನಮ್ಮ ಅಪ್ಲಿಕೇಶನ್‌ನ ಸಂಪೂರ್ಣ ಪ್ರವೇಶವನ್ನು ಅನುಭವಿಸಲು ಲಾಗಿನ್ ಮಾಡಿ.",
    Prasar_Bharti_Mobile_App:
      "ಮತ್ತು ಪ್ರಸಾರ್ ಭಾರತಿ ಮೊಬೈಲ್ ಆಪ್‌ನಲ್ಲಿ ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಿ.",
    go_to_account: '"ನನ್ನ ಖಾತೆ" ಗೆ ಹೋಗಿ',
    clear: "ಸ್ವಚ್ಛಗೊಳಿಸಿ",
    del: "ಅಳಿಸಿ",
    space: "ಸ್ಥಳ",
    RefferalCode: "ರಿಫರ್ ಕೋಡ್",
    referal_code: "ರೆಫರಲ್ ಕೋಡ್",
    ResuminWating: "ಮುಂದುವರಿಸಿ",
    RefferalMsg: "ಈಗಾಗಲೇ ನೋಂದಾಯಿಸಿರುವ ಸಂಖ್ಯೆಗಳು ಅನ್ವಯಿಸದು!",
    Apply: "ಅನ್ವಯಿಸಿ",
    Live_Events: "ಲೈವ್ ಈವೆಂಟ್",
    having_trouble_loggin_in_please_visit_our_website:
      "ಲಾಗಿನ್ ಮಾಡಲು ತೊಂದರೆ ಉಂಟಾಗಿದೆಯೇ? ದಯವಿಟ್ಟು ನಮ್ಮ ವೆಬ್ಸೈಟ್ಗೆ ಭೇಟಿ ನೀಡಿ.",
    Subscribewatch: "ಚಂದಾದಾರರಾಗಿರಿ",
    SubscribeMsg:
      "ಈ ವಿಷಯವನ್ನು ವೀಕ್ಷಿಸಲು, ದಯವಿಟ್ಟು ನಮ್ಮ ವೆಬ್‌ಸೈಟ್ www.wavespb.com ನಲ್ಲಿ ನಿಮ್ಮ ಖರೀದಿಯನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ.",
    Subscribelisten: "ಕೇಳಲು ಚಂದಾದಾರಾಗಿರಿ",
    available_to_rent: "ಭಾಡೆಗೆ ಲಭ್ಯವಿದೆ",
    login_with: "ಇದರೊಂದಿಗೆ ಲಾಗಿನ್ ಮಾಡಿ",
    LoginToWatch: "ಈಗ ವೀಕ್ಷಿಸಿ",
    Watchnow: "ಈಗಲೇ ನೋಡಿ",
    ListenToWatch: "Écouter maintenant",
    Listennow: "ಈಗ ಕೇಳಿ",
    Logout: "ಲಾಗ್ ಔಟ್",
    done: "ಮುಗಿದೆ",
    or: "ಅಥವಾ",
    proceed: "ಮುಂದುವರಿಸಿ",
    subtitle: "ಉಪಶೀರ್ಷಿಕೆ",
    no_subtitle: "ಯಾವುದೇ ಉಪಶೀರ್ಷಿಕೆ ಲಭ್ಯವಿಲ್ಲ",
    availableOnRent: "ಬಾಡಿಗೆಗೆ ಲಭ್ಯವಿದೆ",
    skip_start_browsing: "ಹಾರಿಹೋಗು & ಬ್ರೌಸ್ ಮಾಡು",
    get_a_new_code: "ಹೊಸ ಕೋಡ್ ಪಡೆಯಿರಿ",
    "Privacy-Policy": "ಗೌಪ್ಯತಾ ನೀತಿ",
    "Send-OTP": "OTP ಕಳುಹಿಸಿ",
    "Term&Conditions": "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
    enter_mobile_number: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "About-Us": "ನಮ್ಮ ಬಗ್ಗೆ",
    Search_: "ಹುಡುಕು",
    "confirm-that-agree": "ಮುಂದುವರಿಯುವ ಮೂಲಕ, ನೀವು ಒಪ್ಪಿಗೆಯನ್ನು ದೃಢೀಕರಿಸುತ್ತೀರಿ",
    "Help&Support": "ಸಹಾಯ ಮತ್ತು ಬೆಂಬಲ",
    ListenToWatch: "ಈಗ ಕೇಳಿ",
    "Top-Results": "ಉತ್ತಮ ಫಲಿತಾಂಶಗಳು",
    "Popular-Searches": "ಜನಪ್ರಿಯ ಹುಡುಕುಗಳು",
    "Popular-Search": "ಜನಪ್ರಿಯ ಹುಡುಕುಗಳು",
    searchplaceholder: "ಕಲಾವಿದ, ಕಾರ್ಯಕ್ರಮಗಳು, ಪ್ಲೇಲಿಸ್ಟ್ ಅಥವಾ ವಿಷಯವನ್ನು ಹುಡುಕಿ",
    Scan_using_app_or_mobile_camera: "ಮೊಬೈಲ್ ಅಪ್ಲಿಕೇಶನ್ ಬಳಸಿ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ",
    welcome_to_dds_world_of_entertainment: "ഡിഡിയുടെ വിനോദ ലോകത്തേക്ക് സ്വാഗതം",
    sign_in_with_mobile_or_email: "ಮೊಬೈಲ್ ಅಥವಾ ಇಮೇಲ್ ಬಳಸಿ ಸೈನ್ ಇನ್ ಮಾಡಿ",
    enter_your_mobile_number_or_email_to_continue:
      "ಮುಂದುವರೆಯಲು ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಅಥವಾ ಇಮೇಲ್ ನಮೂದಿಸಿ",
    Home_: "ಮುಖಪುಟ",
    Live_: "ಟಿವಿ/ರೇಡಿಯೋ",
    left: "ಎಡಭಾಗ",
    "Delete-Account": "ಖಾತೆಯನ್ನು ಅಳಿಸಿ",
    Watchlist: "ವೀಕ್ಷಣೆ ಪಟ್ಟಿ",
    "My-Profile": "ನನ್ನ ಪ್ರೊಫೈಲ್",
    Edit: "ಸಂಪಾದಿಸಿ",
    no_additional_track: "ಯಾವುದೇ ಹೆಚ್ಚುವರಿ ಆಡಿಯೋ ಟ್ರ್ಯಾಕ್ ಲಭ್ಯವಿಲ್ಲ",
    Add: "ಸೇರಿಸಿ",
    "Edit-Profile": "ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಿ",
    "Add-Profile": "ಪ್ರೊಫೈಲ್ ಸೇರಿಸಿ",
    "Who’sWatching?": "ಯಾರು ನೋಡುತ್ತಿದ್ದಾರೆ?",
    "placeholder-profile": "ಪ್ರೊಫೈಲ್ ಹೆಸರು ನಮೂದಿಸಿ",
    "Kid’sprofile?": "ಮಕ್ಕಳ ಪ್ರೊಫೈಲ್",
    "Onlyshowkid-friendlyvideos": "ಮಕ್ಕಳಿಗೆ ಸೂಕ್ತವಾದ ವೀಡಿಯೊಗಳನ್ನು ಮಾತ್ರ ತೋರಿಸಿ",
    "No-Result-Found": "ಯಾವುದೇ ಫಲಿತಾಂಶ ಕಂಡುಬಂದಿಲ್ಲ",
    "try-other-keyword": "ದಯವಿಟ್ಟು ಬೇರೆ ಕೀವರ್ಡ್ ಪ್ರಯತ್ನಿಸಿ",
    "No-data-found": "ಯಾವುದೇ ಡೇಟಾ ಕಂಡುಬಂದಿಲ್ಲ",
    "No-list-found":
      "ಯಾವುದೇ ಪಟ್ಟಿಯು ಕಂಡುಬಂದಿಲ್ಲ. ದಯವಿಟ್ಟು ಎಕ್ಸ್‌ಪ್ಲೋರ್ ಮಾಡಿ ಮತ್ತು ನಿಮ್ಮ ಮೆಚ್ಚಿನವುಗಳನ್ನು ಸೇರಿಸಿ",
    "Continue-Watching": "ಮುಂದುವರೆಸಿ ವೀಕ್ಷಿಸಿ",
    Login: "ಲಾಗಿನ್",
    Guest: "ಅತಿಥಿ",
    "Login-to-your-account": "ನಿಮ್ಮ ಖಾತೆಗೆ ಲಾಗಿನ್ ಆಗಿ",
    "Login-enter-no":
      "ಸಿನೆಮಾ, ಕ್ರೀಡೆ ಮತ್ತು ಸರಣಿಗಳ ವೈವಿಧ್ಯತೆಯನ್ನು ಅನ್ವೇಷಿಸಲು ದಯವಿಟ್ಟು ನಿಮ್ಮ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ.",
    "Login-enter-no-email":
      "ಸಿನೆಮಾ, ಕ್ರೀಡೆ ಮತ್ತು ಸರಣಿಗಳ ವೈವಿಧ್ಯತೆಯನ್ನು ಅನ್ವೇಷಿಸಲು ದಯವಿಟ್ಟು ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ.",
    "Phone-Number": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
    "sms-verify": "ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ಪರಿಶೀಲಿಸಲು ನಿಮಗೆ OTP ಸಿಗಲಿದೆ.",
    "email-verify": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ಪರಿಶೀಲಿಸಲು ನಿಮಗೆ OTP ಸಿಗಲಿದೆ.",
    "OTP-Verification": "OTP ಪರಿಶೀಲನೆ",
    "verification-code": "ನಾವು ನಿಮಗೆ ಕಳುಹಿಸಿದ ಪರಿಶೀಲನಾ ಕೋಡ್ ನಮೂದಿಸಿ",
    Resend: "ಮತ್ತೆ ಕಳುಹಿಸಿ",
    "Having-Issue?": "ಸಮಸ್ಯೆ ಇದ್ದರೆ?",
    "Contact-Us": "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ!",
    "Enter-Phone-Number": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "not-receive-code": "ನೀವು ಕೋಡ್ ಪಡೆಯಲಿಲ್ಲವೇ?",
    "Resend-OTP-in": "OTP ಮತ್ತೆ ಕಳುಹಿಸು ನಲ್ಲಿ",
    verify: "ಪರಿಶೀಲಿಸಿ",
    "cofirm-logout": "ನೀವು ಖಚಿತವಾಗಿ ಅಪ್‌ನಿಂದ ಲಾಗ್ ಔಟ್ ಆಗಲು ಬಯಸುವಿರಾ?",
    Confirm: "ದೃಢಪಡಿಸಿ",
    logout: "	ಲಾಗ್ ಔಟ್",
    notifications: "ಅಧಿಸೂಚನೆಗಳು",
    registered_devices: "ನೊಂದಾಯಿತ ಸಾಧನಗಳು",
    clear_search_history: "ಹುಡುಕಾಟ ಇತಿಹಾಸವನ್ನು ಅಳಿಸಿ",
    subscription_and_devices: "ಚಂದಾದಾರಿಕೆ ಮತ್ತು ಸಾಧನಗಳು",
    subscription: "ಚಂದಾದಾರಿಕೆ",
    my_device: "ನನ್ನ ಸಾಧನ",
    Cancel: "ರದ್ದುಮಾಡಿ",
    payment_details: "ಪಾವತಿ ವಿವರಗಳು",
    other_devices: "ಇತರ ಸಾಧನಗಳು",
    deregister: "ನೋಂದಣಿ ರದ್ದುಮಾಡಿ",
    "Content-Language-Changed": "ವಿಷಯ ಭಾಷೆ ಬದಲಾಗಿದೆ",
    "App-Language-Changed": "ಅನ್ವಯ ಭಾಷೆ ಬದಲಾಗಿದೆ",
    "Change-Language": "ಭಾಷೆ ಬದಲಿಸಿ",
    Previous: "ಹಿಂದಿನ",
    More: "ಇನ್ನಷ್ಟು",
    audio_quality: "ಆಡಿಯೋ ಗುಣಮಟ್ಟ",
    speed: "ವೇಗ",
    Delete: "ಅಳಿಸಿ",
    Notification: "ಅಧಿಸೂಚನೆ",
    no_noti_found: "ಯಾವುದೇ ಅಧಿಸೂಚನೆ ಸಿಗಲಿಲ್ಲ",
    Artist: "ಕಲಾವಿದ",
    just_now: "ಈಗಷ್ಟೇ",
    title_activity_purchase_history: "ಖರೀದಿ ಇತಿಹಾಸ",
    first_fragment_label: "ಮೊದಲ ಫ್ರಾಗ್ಮೆಂಟ್",
    second_fragment_label: "ಎರಡನೇ ಫ್ರಾಗ್ಮೆಂಟ್",
    Next: "ಮುಂದೆ",
    next_episode: "ಮುಂದಿನ ಎಪಿಸೋಡ್",
    Download: "ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    transaction_history: "ವಹಿವಾಟು ಇತಿಹಾಸ",
    no_transaction_history: "ವಹಿವಾಟು ಇತಿಹಾಸ ಇಲ್ಲ",
    str_watch_list: "ವೀಕ್ಷಣಾ ಪಟ್ಟಿ",
    my_purchased_video: "ನನ್ನ ಖರೀದಿಸಿದ ವಿಡಿಯೋಗಳು",
    subscribe_: "ಚಂದಾದಾರರಾಗಿ",
    plan_price: "ಯೋಜನೆಯ ದರ",
    remaining_balance: "ಉಳಿದ ಸಮತೋಲನ",
    total_amount: "ಒಟ್ಟು ಮೊತ್ತ",
    n_a: "ಲಭ್ಯವಿಲ್ಲ",
    run_on_physical_device_only: "ಶಾರೀರಿಕ ಸಾಧನದಲ್ಲಿ ಮಾತ್ರ ಚಲಾಯಿಸಿ",
    btn_ok: "ಸರಿ",
    msg_vpn_error: "VPN ದೋಷ",
    note_your_code_will_be_updated_after_5_min:
      "ಗಮನಿಸಿ: ನಿಮ್ಮ ಕೋಡ್ 5 ನಿಮಿಷಗಳ ನಂತರ ನವೀಕರಿಸಲಾಗುವುದು",
    payable_amount: "ಪಾವತಿಸಬೇಕಾದ ಮೊತ್ತ",
    didnt_receive_otp: "ನಿಮಗೆ OTP ಸಿಗಲಿಲ್ವೆ?",
    hello_first_fragment: "ಹಲೋ",
    hello_second_fragment: "ಖರೀದಿ ವಿವರಗಳು",
    coming_soon: "ಶೀಘ್ರದಲ್ಲೇ ಬರುತ್ತಿದೆ",
    packages: "ಪ್ಯಾಕೇಜುಗಳು",
    str_support: "ಬೆಂಬಲ",
    delete_acct: "ಖಾತೆ ಅಳಿಸಿ",
    delete_conform: "ನೀವು ಖಾತೆಯನ್ನು ಅಳಿಸಲು ಖಚಿತವಾಗಿದ್ದೀರಾ?",
    delete_profile_success: "ಪ್ರೊಫೈಲ್ ಯಶಸ್ವಿಯಾಗಿ ಅಳಿಸಲಾಗಿದೆ",
    Dlt_Accnt_msg: "ಖಾತೆ ಅಳಿಸುವ ದೃಢೀಕರಣ ಸಂದೇಶ",
    some_error_occurred_please_try_again:
      "ಯಾವುದೋ ದೋಷ ಉಂಟಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    auto: "ಸ್ವಯಂ",
    player_not_ready_try_again:
      "ಪ್ಲೇಯರ್ ಸಿದ್ಧವಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    edit_profile: "ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಿ",
    learn_more: "ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ",
    wishlist: "ಬಯಕೆಯ ಪಟ್ಟಿ",
    category_name: "ವರ್ಗ",
    str_my_download: "ನನ್ನ ಡೌನ್‌ಲೋಡ್‌ಗಳು",
    language: "ಭಾಷೆ",
    added_watch_list: "ವೀಕ್ಷಣಾ ಪಟ್ಟಿಗೆ ಸೇರಿಸಲಾಗಿದೆ",
    removed_watch_list: "ವೀಕ್ಷಣಾ ಪಟ್ಟಿಯಿಂದ ತೆಗೆದುಹಾಕಲಾಗಿದೆ",
    viewall: "ಎಲ್ಲವನ್ನೂ ನೋಡಿ",
    msg_video_expired:
      "ಈ ವಿಡಿಯೋ ಅವಧಿ ಮೀರಿದೆ. ಅದನ್ನು ವೀಕ್ಷಿಸಲು ದಯವಿಟ್ಟು ಮತ್ತೆ ಖರೀದಿಸಿ.",
    skip_intro: "ಪರಿಚಯವನ್ನು ಬಿಟ್ಟುಬಿಡಿ",
    settings: "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
    video_quality: "ವಿಡಿಯೋ ಗುಣಮಟ್ಟ",
    video_speed: "ವಿಡಿಯೋ ವೇಗ",
    like: "ಇಷ್ಟವಾಯಿತು",
    unlike: "ಇಷ್ಟವಾಗಲಿಲ್ಲ",
    refund: "ಮರುಪಾವತಿ",
    userProfile: "ಬಳಕೆದಾರ ಪ್ರೊಫೈಲ್",
    signup_create_new_account: "ಸೈನ್ ಅಪ್: ಹೊಸ ಖಾತೆ ರಚಿಸಿ",
    already_acc_login: "ಈಗಾಗಲೇ ಖಾತೆ ಇದೆಯಾ? ಲಾಗಿನ್ ಮಾಡಿ",
    accept_terms_and_condition: "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಒಪ್ಪಿಕೊಳ್ಳಿ",
    new_password: "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್",
    api_failure_msg: "API ವಿಫಲವಾಗಿದೆ",
    remove_profile_pic: "ಪ್ರೊಫೈಲ್ ಫೋಟೋ ತೆಗೆದುಹಾಕಿ",
    remove: "ತೆಗೆದುಹಾಕಿ",
    msg_remove_profile_pic: "ಪ್ರೊಫೈಲ್ ಫೋಟೋ ತೆಗೆದುಹಾಕುವ ದೃಢೀಕರಣ ಸಂದೇಶ",
    profile_photo: "ಪ್ರೊಫೈಲ್ ಫೋಟೋ",
    purchased_video: "ಖರೀದಿಸಿದ ವಿಡಿಯೋ",
    upgrade: "ನವೀಕರಿಸಿ",
    msg_send_otp: "OTP ಕಳುಹಿಸಿ",
    forgot_your_password: "ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ಮರೆತಿರಾ?",
    msg_search_content: "ವಿಷಯವನ್ನು ಹುಡುಕಿ",
    current_plan: "ಪ್ರಸ್ತುತ ಯೋಜನೆ",
    more_like_this: "ಇದರಂತಹ ಇನ್ನಷ್ಟು",
    download_channel_id: "ಡೌನ್‌ಲೋಡ್ ಚಾನೆಲ್ ID",
    download_video_service_channel: "ವಿಡಿಯೋ ಸೇವೆ ಡೌನ್‌ಲೋಡ್ ಚಾನೆಲ್",
    searchLikehotStar: "ಯಾವುದೇ ಡೌನ್‌ಲೋಡ್‌ ಸಿಗಲಿಲ್ಲ",
    don_t_have_an_account: "ಖಾತೆ ಇಲ್ಲವೇ?",
    delete_video: "ವಿಡಿಯೋ ಅಳಿಸಿ",
    sign_up: "ಸೈನ್ ಅಪ್ ಮಾಡಿ",
    having_forget_password: "ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ನೆನಪಿಲ್ಲದಿದ್ದರೆ?",
    complete_profile: "ಪ್ರೊಫೈಲ್ ಪೂರ್ಣಗೊಳಿಸಿ",
    add_profile: "ಪ್ರೊಫೈಲ್ ಸೇರಿಸಿ",
    wait_to_play_video: "ವಿಡಿಯೋ ವೀಕ್ಷಿಸಲು ನಿರೀಕ್ಷಿಸಿ",
    buy_now_at: "ಈಗ ಖರೀದಿಸಿ",
    upgrade_now_at: "ಈಗ ನವೀಕರಿಸಿ",
    new_text: "ಹೊಸ ಪಠ್ಯ",
    rate_app_title: "ಅನ್ವಯಕ್ಕೆ ಮೌಲ್ಯ ನೀಡಿ",
    rate_app_message:
      "ನಮ್ಮ ಅಪ್ಲಿಕೇಶನ್ ನಿಮಗೆ ಇಷ್ಟವಾದರೆ, ದಯವಿಟ್ಟು PlayStore ನಲ್ಲಿ ಮೌಲ್ಯಮಾಪನ ಮಾಡಲು ಕ್ಷಣವೇ ತೆಗೆದುಕೊಳ್ಳಿ. ನಿಮ್ಮ ಬೆಂಬಲಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು",
    rate_btn_pos: "ಈಗ ಮೌಲ್ಯಮಾಪನ ಮಾಡಿ",
    rate_btn_neg: "ನಂತರ ನೆನಪಿಸು",
    rate_btn_nut: "ಇಲ್ಲ, ಧನ್ಯವಾದಗಳು",
    change_name: "ಹೆಸರು ಬದಲಿಸಿ",
    download_options: "ಡೌನ್‌ಲೋಡ್ ಆಯ್ಕೆಗಳು",
    low_quality: "ಕಡಿಮೆ ಗುಣಮಟ್ಟ",
    medium_quality: "ಮಧ್ಯಮ ಗುಣಮಟ್ಟ",
    high_quality: "ಉನ್ನತ ಗುಣಮಟ್ಟ",
    downloading: "ಡೌನ್‌ಲೋಡ್ ಆಗುತ್ತಿದೆ",
    download_pause: "ಡೌನ್‌ಲೋಡ್ ನಿಲ್ಲಿಸಿ",
    downloaded: "ಡೌನ್‌ಲೋಡ್ ಆಗಿದೆ",
    download_url_is_not_found: "ಡೌನ್‌ಲೋಡ್ URL ಸಿಗಲಿಲ್ಲ",
    download_running: "ಡೌನ್‌ಲೋಡ್ ನಡೆಯುತ್ತಿದೆ",
    no_plan_subscribed: "ಯಾವುದೇ ಯೋಜನೆ ಚಂದಾದಾರರಾಗಿಲ್ಲ",
    privacypolicy: "ಗೌಪ್ಯತಾ ನೀತಿ",
    termsuse: "ಬಳಕೆಯ ಷರತ್ತುಗಳು",
    resendotp_in: "OTP ಮರುಕಳುಹಿಸಿ (ಲಾಗಿನ್‌ಗೆ ಅಗತ್ಯವಿದೆ)",
    login_required: "ಲಾಗಿನ್ ಅಗತ್ಯವಿದೆ",
    sorry_we_couldn_t_complete_your_request_please_try_again_in_a_moment:
      "ಕ್ಷಮಿಸಿ, ನಿಮ್ಮ ವಿನಂತಿಯನ್ನು ಪೂರ್ಣಗೊಳಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಸ್ವಲ್ಪ ಸಮಯದ ನಂತರ ಪ್ರಯತ್ನಿಸಿ.",
    trailer: "ಟ್ರೇಲರ್",
    subscribe_now_to_watch: "ವೀಕ್ಷಿಸಲು ಈಗ ಚಂದಾದಾರರಾಗಿ",
    app_version: "ಅನ್ವಯ ಆವೃತ್ತಿ",
    select_all: "ಎಲ್ಲವನ್ನೂ ಆಯ್ಕೆಮಾಡಿ",
    please_enter_valid_name: "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಹೆಸರು ನಮೂದಿಸಿ",
    choose_avatar: "ದಯವಿಟ್ಟು ಅವತಾರ್ ಆಯ್ಕೆಮಾಡಿ",
    enter_name: "ದಯವಿಟ್ಟು ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    unselect_all: "ಎಲ್ಲವನ್ನೂ ಆಯ್ಕೆ ತೆಗೆದುಹಾಕಿ",
    enter_mobile_number: "ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
    title_activity_scan_qr_code: "QR ಕೋಡ್ ಸ್ಕಾನ್ ಮಾಡಿ",
    plz_enter_name: "ದಯವಿಟ್ಟು ಹೆಸರು ನಮೂದಿಸಿ",
    plz_change_name: "ದಯವಿಟ್ಟು ಹೆಸರು ಬದಲಿಸಿ",
    plz_choose_avtar: "ದಯವಿಟ್ಟು ಅವತಾರ ಆಯ್ಕೆಮಾಡಿ",
    plz_select_profile: "ದಯವಿಟ್ಟು ಪ್ರೊಫೈಲ್ ಆಯ್ಕೆಮಾಡಿ",
    who_s_watching: "ಯಾರು ನೋಡುತ್ತಿದ್ದಾರೆ?",
    my_profile: "ನನ್ನ ಪ್ರೊಫೈಲ್",
    profiles: "ಪ್ರೊಫೈಲ್‌ಗಳು",
    clear: "ಸ್ಪಷ್ಟಗೊಳಿಸಿ",
    recent_searches: "ಇತ್ತೀಚಿನ ಹುಡುಕಾಟಗಳು",
    Recommended_searches: "ಶಿಫಾರಸು ಮಾಡಲಾದ ಹುಡುಕಾಟಗಳು",
    please_enter_your_number_to_discover_a_variety_nof_movies_sports_series:
      "ಚಿತ್ರಗಳು, ಕ್ರೀಡೆ ಮತ್ತು ಸರಣಿಗಳ ವೈವಿಧ್ಯತೆಯನ್ನು ಅನಾವರಣ ಮಾಡಲು ನಿಮ್ಮ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    mobile_number: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
    having_issue_contact_us: "ಸಮಸ್ಯೆಯಿದೆಯಾ? ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
    didn_t_receive_code_resend: "ಕೋಡ್ ಸಿಗಲಿಲ್ವೆ? ಮರುಕಳುಹಿಸಿ",
    enter_the_verification_code_we_just_sent_to_your_number:
      "ನಾವು ನಿಮಗೆ ಕಳುಹಿಸಿದ ಪರಿಶೀಲನೆ ಕೋಡ್ ಅನ್ನು ನಮೂದಿಸಿ",
    incorrect_otp_entered_please_enter_again:
      "ತಪ್ಪಾದ OTP ನಮೂದಿಸಲಾಗಿದೆ. ದಯವಿಟ್ಟು ಪುನಃ ನಮೂದಿಸಿ.",
    app_update_title: "ಅನ್ವಯ ನವೀಕರಣ",
    app_update_msg: "ಆಪ್‌ನ ಹೊಸ ಆವೃತ್ತಿ ಈಗ ಲಭ್ಯವಿದೆ",
    watch_now: "ಈಗ ವೀಕ್ಷಿಸಿ",
    my_list: "ನನ್ನ ಪಟ್ಟಿ",
    cast_and_crew: "ಭಾಗವಹಿಸುವವರು ಮತ್ತು ಸಿಬ್ಬಂದಿ",
    similar_to_this: "ಇದಕ್ಕೆ ಸಮಾನವಾದವು",
    similar_channels: "ಇದೇ ಚಾನೆಲ್‌ಗಳು",
    delete_account: "ಖಾತೆ ಅಳಿಸಿ",
    delete_account_desc: "ನೀವು ಖಾತೆಯನ್ನು ಅಳಿಸಲು ಖಚಿತವಾಗಿ ಬಯಸುತ್ತೀರಾ",
    delete_conform: "ಪ್ರೊಫೈಲ್?",
    log_out: "ಲಾಗ್ ಔಟ್",
    log_out_desc: "ನೀವು ಈ ಖಾತೆಯಿಂದ ಲಾಗ್ ಔಟ್ ಮಾಡಲು ಬಯಸುತ್ತೀರಾ?",
    pb_on_tv: "ಪ್ರಸಾರ್ ಭಾರತೀ ಟಿವಿಯಲ್ಲಿ ಬಳಸಿ",
    link_device: "ಸಾಧನವನ್ನು ಲಿಂಕ್ ಮಾಡಿ",
    linked_tv: "ಲಿಂಕ್ ಮಾಡಿದ ಟಿವಿ",
    link_with_tv: "ನೀವು ಟಿವಿಗೆ ಲಿಂಕ್ ಮಾಡಲು ಖಚಿತವಾಗಿ ಬಯಸುತ್ತೀರಾ?",
    no_result_found: "ಯಾವುದೇ ಫಲಿತಾಂಶ ಕಂಡುಬಂದಿಲ್ಲ",
    search_again: "ಮರುಹುಡುಕಿ",
    no_list_found: "ಯಾವುದೇ ಪಟ್ಟಿ ಕಂಡುಬಂದಿಲ್ಲ",
    no_list_found_desc:
      "ಯಾವುದೇ ಪಟ್ಟಿ ಕಂಡುಬಂದಿಲ್ಲ, ದಯವಿಟ್ಟು ಪರಿಶೀಲಿಸಿ ಮತ್ತು ನಿಮ್ಮ ಇಚ್ಛಿತ ಮಾಹಿತಿಯನ್ನು ಸೇರಿಸಿ",
    no_notifications: "ಯಾವುದೇ ಅಧಿಸೂಚನೆಗಳಿಲ್ಲ",
    no_notifications_desc:
      "ಈಗ ನೀವು ಯಾವುದೇ ಅಧಿಸೂಚನೆಗಳನ್ನು ಹೊಂದಿಲ್ಲ. ದಯವಿಟ್ಟು ನಂತರ ಪ್ರಯತ್ನಿಸಿ",
    network_error: "ನೆಟ್ವರ್ಕ್ ದೋಷ",
    retry: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
    open_setting: "ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ತೆರೆಯಿರಿ",
    internal_server: "ಆಂತರಿಕ ಸರ್ವರ್ ದೋಷ",
    internal_server_error:
      "ನಿಮ್ಮ ವಿನಂತಿಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸುವಾಗ ಸರ್ವರ್ ದೋಷ ಕಂಡುಬಂದಿದೆ.",
    go_back: "ಹಿಂದೆ ಹೋಗಿ",
    data_not_found: "ಡೇಟಾ ಕಂಡುಬಂದಿಲ್ಲ",
    page_not_found_desc: "ನೀವು ವೀಕ್ಷಿಸುತ್ತಿರುವ ಪುಟ ಲಭ್ಯವಿಲ್ಲ",
    popular_search: "ಜನಪ್ರಿಯ ಹುಡುಕಾಟ",
    top_results: "ಅತ್ಯುತ್ತಮ ಫಲಿತಾಂಶಗಳು",
    guest_user: "ಅತಿಥಿ ಬಳಕೆದಾರ",
    channels: "ಚಾನೆಲ್‌ಗಳು",
    Radio: "ರೇಡಿಯೋ",
    TV: "ಟಿವಿ",
    favorites: "ಆಚಿತ",
    content_language: "ವಿಷಯ ಭಾಷೆ",
    app_language: "ಆಪ್ ಭಾಷೆ",
    change_account: "ಪ್ರೊಫೈಲ್ ಬದಲಾಯಿಸಿ",
    move_account: "ನೀವು ಖಚಿತವಾಗಿ ಇನ್ನೊಂದು ಪ್ರೊಫೈಲ್‌ಗೆ ಬದಲಾಯಿಸಲು ಬಯಸುತ್ತೀರಾ?",
    update_profile: "ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ",
    added_profile: "ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಯಶಸ್ವಿಯಾಗಿ ಸೇರಿಸಲಾಗಿದೆ",
    edit_update: "ನವೀಕರಿಸಿ",
    cast_crew: "ಭಾಗವಹಿಸುವವರು ಮತ್ತು ಸಿಬ್ಬಂದಿ",
    episodes: "ಎಪಿಸೋಡ್‌ಗಳು",
    no_record: "ಯಾವುದೇ ದಾಖಲೆ ಕಂಡುಬಂದಿಲ್ಲ",
    free_time_up: "ಮೂಕ್ತ ಸಮಯ ಮುಗಿದಿದೆ!",
    free_create_account: "ಮುಂದುವರಿಯಲು ಲಾಗಿನ್ ಅಥವಾ ಉಚಿತ ಖಾತೆ ರಚಿಸಿ.",
    adventure: "ಸಾಹಸ",
    prasar_bharti: "ಪ್ರಸಾರ್ ಭಾರತೀ",
    ind_broadcast: "(ಭಾರತದ ಸಾರ್ವಜನಿಕ ಪ್ರಸಾರಕ)",
    back_to_home: "ಮನೆ ಪುಟಕ್ಕೆ ಹಿಂದಿರುಗಿ",
    oops_page_not_found: "ಅಯ್ಯೋ, ಪುಟ ಕಂಡುಬಂದಿಲ್ಲ",
    page_looking: "ನೀವು ಹುಡುಕುತ್ತಿರುವ ಪುಟ ಲಭ್ಯವಿಲ್ಲ",
    go_to_home: "ಮುಖಪುಟಕ್ಕೆ ಹೋಗಿ",
    popular_genres: "ಜನಪ್ರಿಯ ಶೈಲಿಗಳು",
    watchLanguage: "ನಿಮ್ಮ ಭಾಷೆಯಲ್ಲಿ ವೀಕ್ಷಿಸಿ",
    help_support: "ಸಹಾಯ ಮತ್ತು ಬೆಂಬಲ",
    customer_support: "ಗ್ರಾಹಕ ಬೆಂಬಲ",
    contact_number: "ಸಂಪರ್ಕ ಸಂಖ್ಯೆ",
    email_address: "ಇಮೇಲ್ ವಿಳಾಸ",
    share: "ಹಂಚಿಕೊಳ್ಳಿ",
    copy: "ನಕಲಿಸಿ",
    copied: "ನಕಲಿಸಲಾಗಿದೆ",
    bharat_ott: "ಭಾರತ್ OTT",
    home: "ಮುಖಪುಟ",
    policy: "ಹೊರತೆಗೆದ ಮತ್ತು ರದ್ದುಪಡಿಸುವ ನೀತಿ",
    terms_condition: "ಶರತ್ತುಗಳು ಮತ್ತು ನಿಯಮಗಳು",
    your_account: "ನಿಮ್ಮ ಬಳಿ ಖಾತೆ ಇದೆಯೆ?",
    continue: "ಮುಂದುವರಿಸಿ",
    "login_here!": "ಇಲ್ಲಿಗೆ ಲಾಗಿನ್ ಮಾಡಿ!",
    mobile: "ಮೊಬೈಲ್",
    password: "ಪಾಸ್ವರ್ಡ್",
    forgot_password: "ಪಾಸ್ವರ್ಡ್ ಮರೆತಿರಾ?",
    sign_up_here: "ಇಲ್ಲಿಗೆ ನೋಂದಾಯಿಸಿ!",
    social_media: "ಸಾಮಾಜಿಕ ಮಾಧ್ಯಮದೊಂದಿಗೆ ಮುಂದುವರಿಸಿ",
    search_data: "ಎಲ್ಲಾ ಹುಡುಕಾಟದ ಡೇಟಾ",
    description: "ವಿವರಣೆ",
    episode_name: "ಎಪಿಸೋಡ್ ಹೆಸರು",
    episode_num: "ಎಪಿಸೋಡ್ ಸಂಖ್ಯೆ",
    page_looking_might:
      "ನೀವು ಹುಡುಕುತ್ತಿರುವ ಪುಟವನ್ನು ಅಳಿಸಲಾಗಿದೆ ಅಥವಾ ತಾತ್ಕಾಲಿಕವಾಗಿ ಲಭ್ಯವಿಲ್ಲ.",
    Ok: "ಸರಿ",
    otp_sent: "OTP ಯಶಸ್ವಿಯಾಗಿ ಕಳುಹಿಸಲಾಗಿದೆ",
    success: "ಯಶಸ್ಸು",
    could_not_sent: "OTP ಕಳುಹಿಸಲಾಗಲಿಲ್ಲ",
    error: "ದೋಷ",
    resent_otp: "OTP ಮರುಕಳುಹಿಸಲಾಗಿದೆ",
    enter_valid_otp: "ದಯವಿಟ್ಟು ಮಾನ್ಯ OTP ನಮೂದಿಸಿ",
    enter_six_digit_valid: "ದಯವಿಟ್ಟು 6 ಅಂಕಿಗಳ ಮಾನ್ಯ OTP ನಮೂದಿಸಿ",
    profile_creation: "ಪ್ರೊಫೈಲ್ ಯಶಸ್ವಿಯಾಗಿ ರಚಿಸಲಾಗಿದೆ",
    error_name: "ದಯವಿಟ್ಟು ಪ್ರೊಫೈಲ್ ಹೆಸರು ನಮೂದಿಸಿ",
    "Delete-Profile": "ಪ್ರೊಫೈಲ್ ಅಳಿಸಿ",
    add_to_watchlist: "ವೀಕ್ಷಣಾ ಪಟ್ಟಿಗೆ ಸೇರಿಸಿ",
    added_to_watchlist: "ವೀಕ್ಷಣಾ ಪಟ್ಟಿಗೆ ಸೇರಿಸಲಾಗಿದೆ",
    like_it: "ಇಷ್ಟವಾಯಿತು",
    not_for_me: "ನನ್ನಿಗಾಗಿ ಅಲ್ಲ",
    "n-number": "ಸಂಖ್ಯೆ",
    "e-email": "ಇಮೇಲ್",
    "account-subscribe": "ಈಗ ಸದಸ್ಯತ್ವ ಪಡೆಯಿರಿ",
    "account-subscribe-upgrade": "ಈಗ ನವೀಕರಿಸಿ",
    "user-details-text": "ಬಳಕೆದಾರರ ವಿವರಗಳು",
    "acc-username": "ಬಳಕೆದಾರ ಹೆಸರು",
    "acc-enterusername": "ಬಳಕೆದಾರ ಹೆಸರು ನಮೂದಿಸಿ",
    "acc-mobile": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
    "acc-entermobile": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
    "acc-email": "ಇಮೇಲ್ ವಿಳಾಸ",
    "acc-enteremail": "ಇಮೇಲ್ ವಿಳಾಸ ನಮೂದಿಸಿ",
    "acc-Gender": "ಲಿಂಗ",
    "acc-Gender1": "ಪುರುಷ",
    "acc-Gender2": "ಸ್ತ್ರೀ",
    "acc-Gender3": "ಇತರರು",
    "acc-dob": "ಜನ್ಮ ದಿನಾಂಕ",
    "acc-save": "ವಿವರಗಳನ್ನು ಉಳಿಸಿ",
    "my-account": "ನನ್ನ ಖಾತೆ",
    "trans-history": "ವಹಿವಾಟುಗಳ ಇತಿಹಾಸ",
    "acc-varified": "ಸ್ಥಿರೀಕೃತವಾಗಿದೆ",
    "network-error": "ನೆಟ್ವರ್ಕ್ ದೋಷ",
    "network-unable":
      "ಸಂಪರ್ಕಿಸಲು ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಇಂಟರ್ನೆಟ್ ಸಂಪರ್ಕ ಪರಿಶೀಲಿಸಿ",
    "network-retry": "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
    "download-apps": "ನಮ್ಮ ಆಪ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    "PB-OTT": "ಪಿಬಿ OTT",
    "copy-right": "ಕಾಪಿರೈಟ್",
    all_right: "ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
    versions: "ಆವೃತ್ತಿ-",
    "Help-Support": "ಸಹಾಯ ಮತ್ತು ಬೆಂಬಲ",
    "internet-connection": "ಇಂಟರ್ನೆಟ್ ಸಂಪರ್ಕ",
    "nointernet-connection": "ಇಂಟರ್ನೆಟ್ ಸಂಪರ್ಕ ಲಭ್ಯವಿಲ್ಲ",
    "Terms-and-Conditions": "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
    "Help-&-Support": "ಸಹಾಯ ಮತ್ತು ಬೆಂಬಲ",
    "unmute-tra": "ಟ್ರೈಲರ್ ಧ್ವನಿ ಸಕ್ರಿಯಗೊಳಿಸಿ",
    "mute-tra": "ಟ್ರೈಲರ್ ಧ್ವನಿ ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಿ",
    favourite_lang: "ಇಷ್ಟದ ಭಾಷೆ ಸೇರಿಸಿ",
    added_lang: "ಸೇರಿಸಲಾಗಿದೆ",
    "no-notfication": "ಯಾವುದೇ ಅಧಿಸೂಚನೆಗಳಿಲ್ಲ",
    "notfication-dt":
      "ಈಗ ನೀವು ಯಾವುದೇ ಅಧಿಸೂಚನೆಗಳನ್ನು ಹೊಂದಿಲ್ಲ. ದಯವಿಟ್ಟು ನಂತರ ಪ್ರಯತ್ನಿಸಿ.",
    or: "ಅಥವಾ",
    and: "ಮತ್ತು",
    sahmat: "",
    "par-bheje": " ",
    "server-error": "ಆಂತರಿಕ ಸರ್ವರ್ ದೋಷ",
    "server-error-msg": "ನಿಮ್ಮ ವಿನಂತಿಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸುವಾಗ ದೋಷ ಸಂಭವಿಸಿದೆ.",
    "server-retry": "ಮುಖಪುಟಕ್ಕೆ ಹಿಂದಿರುಗಿ",
    "watch-lang": "ನಿಮ್ಮ ಭಾಷೆಯಲ್ಲಿ ವೀಕ್ಷಿಸಿ",
    "popular-genre": "ಜನಪ್ರಿಯ ಶೈಲಿಗಳು",
    subscription_heading: "PB OTTನಲ್ಲಿ ಎಲ್ಲ ವಿಷಯವನ್ನು ವೀಕ್ಷಿಸಲು ಚಂದಾದಾರರಾಗಿ",
    add: "ಸೇರಿಸಿ",
    proceed_to_pay_btn: "ಪಾವತಿಗೆ ಮುಂದುವರಿಸಿ",
    have_promo: "ನಿಮ್ಮ ಬಳಿ ಪ್ರೋಮೋ ಕೋಡ್ ಇದೆಯೆ?",
    promo_code: "ಪ್ರೋಮೋ ಕೋಡ್",
    enter_promo_code: "ಪ್ರೋಮೋ ಕೋಡ್ ನಮೂದಿಸಿ",
    apply_code_btn: "ಕೋಡ್ ಅನ್ವಯಿಸಿ",
    select_live_channel_radio: "ಲೈವ್ ಟಿವಿ ಮತ್ತು ರೇಡಿಯೋ ಆಯ್ಕೆಮಾಡಿ",
    radio_channels: "ರೇಡಿಯೋ ಚಾನೆಲ್‌ಗಳು",
    submit_btn: "ಸಲ್ಲಿಸಿ",
    add_channel_radio: "ಲೈವ್ ಟಿವಿ ಮತ್ತು ರೇಡಿಯೋ ಚಾನೆಲ್‌ಗಳನ್ನು ಸೇರಿಸಿ",
    live_tv_channels: "ಲೈವ್ ಟಿವಿ ಚಾನೆಲ್‌ಗಳು",
    live_radio_channels: "ಲೈವ್ ರೇಡಿಯೋ ಚಾನೆಲ್‌ಗಳು",
    upgrade_subscription: "ಚಂದಾದಾರಿಕೆಯನ್ನು ನವೀಕರಿಸಿ",
    you_pay: "ನೀವು ಪಾವತಿಸುವಿರಿ",
    rem_amt_curr_plan: "ಪ್ರಸ್ತುತ ಯೋಜನೆಯಲ್ಲಿ ಉಳಿದ ಮೊತ್ತ",
    payble_amt: "ಪಾವತಿಸಬೇಕಾದ ಮೊತ್ತ",
    live_channel: "ಲೈವ್ ಚಾನೆಲ್",
    continue_watching: "ವೀಕ್ಷಿಸುವುದನ್ನು ಮುಂದುವರಿಸಿ",
    Exit: "ನಿರ್ಗಮಿಸಿ",
    ExitMsg: "ನೀವು ಖಚಿತವಾಗಿಯೂ ಆಪ್ ನಿಂದ ನಿರ್ಗಮಿಸಲು ಬಯಸುವಿರಾ?",
  },
  Marathi: {
    "no_data_found":"कोणताही डेटा सापडला नाही",
    "Subscribe to watch":"पाहण्यासाठी आत्ता सदस्यता घ्या",
     "Drama": "नाटक",
  "Tracks": "ट्रॅक्स",
  "Romance": "प्रेमकथा",
  "Fantasy": "फॅन्टसी",
  "Contemporary Fiction": "आधुनिक काल्पनिक कथा",
  "History": "इतिहास",
  "Mystery": "गूढ कथा",
  "Wildlife": "वन्यजीव",
  "Thriller": "थ्रिलर",
  "Horror": "भयपट",
  "Educational": "शैक्षणिक",
   "Recent Live": "अलीकडील थेट",
  "Health": "आरोग्य",
  "Biography": "चरित्र",
  "Musical Drama": "संगीत नाटक",
  "Music & Dance": "संगीत आणि नृत्य",
  "Dance Drama": "नृत्य नाटक",
  "Music": "संगीत",
  "Sports": "क्रीडा",
  "Adventure": "साहस",
  "Animation": "अॅनिमेशन",
  "Literature": "साहित्य",
  "Arts & Culture": "कला आणि संस्कृती",
  "Religious": "धार्मिक",
  "Crime": "गुन्हेगारी",
  "Science Fiction": "विज्ञान कथा",
  "Spiritual": "आध्यात्मिक",
  "Detective": "गुप्तहेर कथा",
  "Mythology": "पुराणकथा",
  "Entertainment": "मनोरंजन",
  "Historical Fiction": "ऐतिहासिक काल्पनिक कथा",
  "Political": "राजकीय",
  "Classical Music": "शास्त्रीय संगीत",
  "Comedy": "विनोदी",
  "Satire": "उपहास",
  "Humor": "हास्य",
  "Autobiography": "आत्मचरित्र",
  "Lifestyle": "जीवनशैली",
  "Kids & Family": "मुले आणि कुटुंब",
  "Devotional": "भक्तिपर",
  "Survival": "सर्व्हायव्हल",
  "Nature & Wildlife": "निसर्ग आणि वन्यजीव",
  "Travelogue": "प्रवास वर्णन",
  "Folk Music": "लोकसंगीत",
  "Storytelling": "कथा सांगणे",
  "Dance": "नृत्य",
  "Talk Shows": "संवाद कार्यक्रम",
  "Inspirational": "प्रेरणादायी",
  "Reality": "रिअॅलिटी",
  "Action": "ऍक्शन",
  "Agriculture": "कृषी",
  "International": "आंतरराष्ट्रीय",
  "Anime": "अॅनिमे",
  "Period Drama": "ऐतिहासिक नाटक",
  "Sci-Fi": "विज्ञानकथा",
  "Patriotic": "देशभक्तीपर",
  "Performing Arts": "सादरीकरण कला",
  "Astrology": "ज्योतिष",
  "Fashion": "फॅशन",
  "War": "युद्ध",
"Rom-Com": "रॉम-कॉम",
  "Talent Hunt": "प्रतिभा शोध",
  "Cookery": "स्वयंपाक",
  "Talk Show": "संवाद शो",
  "Superhero": "सुपरहिरो",
  "Literary Fiction": "साहित्यिक कथा",
  "Science": "विज्ञान",
  "Scientific": "वैज्ञानिक",
  "Cooking": "स्वयंपाक",
  "Food": "अन्न",
  "Carnatic Music": "कर्नाटकी संगीत",
"Finance": "वित्त",
"Hobbies And Crafts": "छंद आणि हस्तकला",
"Business and Finance": "व्यवसाय आणि वित्त",
"Industrial design": "औद्योगिक डिझाइन",
  "Travel": "प्रवास",
  "Paintings": "चित्रकला",
  "Design": "डिझाइन",
  "Art": "कला",
  "Nature": "निसर्ग",
  "Arts And Culture": "कला आणि संस्कृती",
  "Educational Books": "शैक्षणिक पुस्तके",
  "Young Adult Fiction": "तरुणांसाठी कथा",
  "News": "बातम्या",
  "Technology": "तंत्रज्ञान",
  "Open World": "उघडं जग",
  "Business": "व्यवसाय",
  "Home Decor": "घर सजावट",
  "Chat Show": "चॅट शो",
  "Edutainment": "शैक्षणिक मनोरंजन",
  "Social Awareness": "सामाजिक जागरूकता",
  "Event": "कार्यक्रम",
  "Hindustani Classical Music": "हिंदुस्थानी शास्त्रीय संगीत",
  "Semi-Classical Music": "अर्ध-शास्त्रीय संगीत",
  "Kids": "मुले",
  "Celebration": "साजरा करणे",
  "Casual": "अनौपचारिक",
  "Medical": "वैद्यकीय",
  "Yojna": "योजना",
  "Sculptures": "शिल्पे",
  "Carbatic Music": "कर्नाटकी संगीत",
  "Digital Literacy": "डिजिटल साक्षरता",
  "Legal And Ethical": "कायदेशीर आणि नैतिक",
  "Digital art": "डिजिटल कला",
  "Parenting": "पालकत्व",
    Sports:"खेळ",
            inviteReferr:"आपल्या मित्राला या अनुभवात सहभागी होण्यासाठी आमंत्रित करा",
     refer_friend:"मित्राला रेफर करा",
    Left:"उरलेले",
    "pbApp":"तुमची प्रोफाईल संपादित करण्यासाठी Waves PB मोबाईल अ‍ॅप वापरा",
    dislike:"नापसंती",
    rentalDescriptionMsg:"www.wavespb.com वरून सामग्री खरेदी करणे सुरू ठेवा",
     "Okay, Got it":"ठीक आहे, समजले",
    Yes: "होय",
    No: "नाही",
    Begins_on:"हा कार्यक्रम सध्या थेट प्रक्षेपित होत नाही",
    "Referral code is empty": "रेफरल कोड रिक्त आहे",
    "Enter a valid referral code": "वैध रेफरल कोड प्रविष्ट करा",
    Movies: "चित्रपट",
   Audio: "ऑडिओ",
   Shows: "कार्यक्रम",
   Music: "संगीत",
   All: "सर्व",
  Live: "थेट", 
  Documentary: "दस्तऐवजी चित्रपट",
   "Recently Added": "अलीकडेच जोडलेले",
   Nostalgia: "जुनी आठवण",
   "News Features": "बातम्यांच्या वैशिष्ट्ये",
   "Waves Originals": "वेव्ह्स ओरिजिनल्स",
    Action: "ॲक्शन",
    Kids: "मुले",
    Romance: "रोमांस",
    Comedy: "कॉमेडी",
    startOver: "पुन्हा सुरू करा",
    Thriller: "थ्रिलर",
     Live_Events: "लाईव्ह इव्हेंट" ,
    Devotional: "भक्ती",
    Shorts: "लघुपट",
    Scan_using_app_or_mobile_camera1:
      "अ‍ॅप किंवा मोबाईल कॅमेरा वापरून स्कॅन करा",
    Having_Trouble_Logging_in:
      "लॉगिन करण्यात अडचण येत आहे? www.wavespb.com ला भेट द्या",
    have_refferel_code: "तुमच्याकडे रेफरल कोड आहे का?",
    view_more: "अधिक पहा",
    view_less: "कमी पहा",
    streaming_from: "पासून स्ट्रीमिंग",
    "Session-Expired": "सत्र संपले आहे",
    "session-desc": "तुमचा सत्र कालावधी संपला आहे.",
    RentAvailable: "₹ मध्ये भाड्याने उपलब्ध",
    RentMsg:
      "खरेदीच्या तारखेपासून हे सामग्री पाहण्यासाठी 30 दिवसांचा भाडे समाविष्ट आहे.",
    "Error!": "त्रुटी!",
    "Success!": "यश!",
    streaming_start: "स्ट्रीमिंग पासून",
    midnight: "मध्यरात्रीपासून सुरू होईल",
    WatchlistError: "वॉचलिस्टमध्ये जोडता आले नाही. कृपया पुन्हा प्रयत्न करा.",
    WatchlistSuccess: "यशस्वीरित्या वॉचलिस्टमध्ये जोडले गेले.",
    GamePlay: "मी कसे खेळू?",
    PlayMsg:
      "हे गेम खेळण्यासाठी, कृपया Waves PB अॅप वापरा किंवा www.wavespb.com ला भेट द्या.",
    "Login to Continue": "सुरू ठेवण्यासाठी लॉगिन करा",
    LoginContinue: "कृपया आमच्या अॅपचा पूर्ण प्रवेश मिळवण्यासाठी लॉगिन करा.",
    Prasar_Bharti_Mobile_App:
      "आणि प्रसार भारती मोबाइल अॅपवर तुमचे प्रोफाइल संपादित करा.",
    go_to_account: '"माझे खाते" वर जा',
    clear: "स्वच्छ करा",
    RefferalCode: "संदर्भ कोड",
    referal_code: "संदर्भ कोड",
    del: "काढा",
    RefferalMsg: "आधीच नोंदणीकृत असलेल्या क्रमांकांना हे लागू होत नाही!",
    space: "स्पेस",
    Apply: "लागू करा",
    Live_Events: "लाईव्ह इव्हेंट",
    having_trouble_loggin_in_please_visit_our_website:
      "लॉगिन करण्यात अडचण येत आहे? कृपया आमच्या वेबसाइटला भेट द्या.",
    Subscribewatch: "पाहण्यासाठी सदस्यता घ्या",
    SubscribeMsg:
      "हे सामग्री पाहण्यासाठी, कृपया आमच्या वेबसाइट www.wavespb.com वर तुमची खरेदी पूर्ण करा.",
    Subscribelisten: "ऐकण्यासाठी सदस्यता घ्या",
    available_to_rent: "भाड्याने उपलब्ध",
    login_with: "सह लॉगिन करा",
    LoginToWatch: "आता पाहा",
    Watchnow: "आता पाहा",
    ListenToWatch: "आता ऐका",
    Listennow: "आत्ताच ऐका",
    Logout: "लॉगआउट",
    done: "पूर्ण",
    availableOnRent: "भाड्याने उपलब्ध",
    or: "किंवा",
    ResuminWating: "पपुढे चालू ठेवा",
    subtitle: "उपशीर्षक",
    no_subtitle: "कोणतेही उपशीर्षक उपलब्ध नाहीत",
    proceed: "सुरुवात करा",
    skip_start_browsing: "वगळा आणि ब्राउजिंग सुरू करा",
    "Help&Support": "मदत आणि समर्थन",
    "Privacy-Policy": "गोपनीयता धोरण",
    "Term&Conditions": "शर्ती आणि अटी",
    get_a_new_code: "नवीन कोड मिळवा",
    "About-Us": "आमच्याबद्दल",
    Search_: "शोधा",
    "Top-Results": "सर्वोत्तम निकाल",
    "Popular-Searches": "लोकप्रिय शोध",
    "Popular-Search": "लोकप्रिय शोध",
    enter_mobile_number: "मोबाइल क्रमांक टाका",
    searchplaceholder: "कलाकार, शो, प्लेलिस्ट किंवा सामग्री शोधा",
    sign_in_with_mobile_or_email: "मोबाइल किंवा ईमेलवर साइन इन करा",
    enter_your_mobile_number_or_email_to_continue:
      "पुढे सुरु करण्यासाठी आपला मोबाइल नंबर किंवा ईमेल प्रविष्ट करा",
    Home_: "होम",
    Live_: "टीव्ही/रेडिओ",
    "Delete-Account": "खाते हटवा",
    Watchlist: "पाहण्याची यादी",
    "My-Profile": "माझे प्रोफाइल",
    Edit: "संपादन",
    Add: "जोडा",
    no_additional_track: "अतिरिक्त ऑडिओ ट्रॅक उपलब्ध नाही",
    "Edit-Profile": "प्रोफाइल संपादन",
    "Add-Profile": "प्रोफाइल जोडा",
    "Who’sWatching?": "कोण पाहत आहे?",
    "placeholder-profile": "प्रोफाइल नाव टाका",
    "Kid’sprofile?": "मुलाचे प्रोफाइल?",
    "Onlyshowkid-friendlyvideos": "फक्त मुलांसाठी मैत्रीपूर्ण व्हिडिओ दाखवा",
    "No-Result-Found": "कोणताही निकाल सापडला नाही",
    "try-other-keyword": "वेगळ्या कीवर्डने पुन्हा प्रयत्न करा",
    "No-data-found": "कोणताही डेटा सापडला नाही",
    "No-list-found":
      "कोणतीही यादी सापडली नाही. कृपया शोधा आणि तुमचे पसंदीदा जोडा",
    "Continue-Watching": "पाहणे सुरू ठेवा",
    welcome_to_dds_world_of_entertainment:
      "डीडीच्या मनोरंजनाच्या जगात आपले स्वागत आहे",
    Login: "लॉगिन",
    Guest: "अतिथी",
    left: "डावा",
    "Login-to-your-account": "तुमच्या खात्यात लॉगिन करा",
    Scan_using_app_or_mobile_camera: "मोबाइल ॲप वापरून स्कॅन करा",
    "Login-enter-no":
      "तुमचा नंबर टाका आणि विविध चित्रपट, क्रीडा आणि मालिका शोधा.",
    "Login-enter-no-email":
      "तुमचा ईमेल टाका आणि विविध चित्रपट, क्रीडा आणि मालिका शोधा.",
    "Phone-Number": "मोबाइल नंबर",
    "sms-verify": "तुमच्या मोबाइल नंबरवर ओटीपी प्राप्त होईल.",
    "email-verify": "तुमच्या ईमेलवर ओटीपी प्राप्त होईल.",
    "Send-OTP": "ओटीपी पाठवा",
    "confirm-that-agree":
      "पुढे जात असताना तुम्ही आमच्या शर्ती आणि अटींशी सहमत आहात.",
    "OTP-Verification": "ओटीपी सत्यापन",
    "verification-code":
      "आम्ही तुमच्या मोबाइल नंबरवर पाठवलेला सत्यापन कोड टाका",
    "not-receive-code": "कोड प्राप्त झाला नाही?",
    Resend: "पुन्हा पाठवा",
    "Having-Issue?": "समस्या येत आहे का?",
    "Contact-Us": "आमच्याशी संपर्क साधा!",
    "Enter-Phone-Number": "मोबाइल नंबर टाका",
    "Resend-OTP-in": "ओटीपी पुन्हा पाठवा",
    verify: "सत्यापन",
    "cofirm-logout": "तुम्हाला खात्री आहे का की तुम्ही ॲपमधून लॉगआउट करू इच्छिता?",
    Confirm: "सत्यापन",
    logout: "लॉगआउट",
    notifications: "सूचना",
    registered_devices: "नोंदणीकृत डिव्हाइस",
    clear_search_history: "शोध इतिहास साफ करा",
    subscription_and_devices: "सदस्यता आणि डिव्हाइस",
    subscription: "सदस्यता",
    my_device: "माझे डिव्हाइस",
    Cancel: "रद्द करा",
    payment_details: "पेमेंट तपशील",
    other_devices: "इतर डिव्हाइस",
    deregister: "नोंदणी रद्द करा",
    "Content-Language-Changed": "सामग्री भाषा बदलली",
    "App-Language-Changed": "अप्लिकेशन भाषा बदलली",
    "Change-Language": "भाषा बदला",
    Previous: "मागील",
    More: "अधिक",
    audio_quality: "ऑडिओ गुणवत्ता",
    speed: "गती",
    Delete: "हटवा",
    Notification: "सूचना",
    no_noti_found: "सूचना सापडली नाही",
    Artist: "कलाकार",
    just_now: "आता",
    title_activity_purchase_history: "खरेदी इतिहास",
    first_fragment_label: "पहिला टुकडा",
    second_fragment_label: "दुसरा टुकडा",
    Next: "पुढील",
    next_episode: "पुढील भाग",
    Download: "डाउनलोड",
    transaction_history: "लेनदेन इतिहास",
    no_transaction_history: "लेनदेन इतिहास सापडला नाही",
    str_watch_list: "पाहण्याची यादी",
    my_purchased_video: "माझे खरेदी केलेले व्हिडिओ",
    subscribe_: "सदस्यता घ्या",
    plan_price: "योजना किंमत",
    remaining_balance: "उरलेला बॅलन्स",
    total_amount: "एकूण रक्कम",
    n_a: "उपलब्ध नाही",
    run_on_physical_device_only: "फक्त भौतिक डिव्हाइसवर चालवा",
    btn_ok: "ओके",
    msg_vpn_error: "व्हीपीएन त्रुटी",
    note_your_code_will_be_updated_after_5_min:
      "नोंद: तुमचा कोड ५ मिनिटांनंतर अद्ययावत होईल.",
    payable_amount: "योजना नाव",
    didnt_receive_otp: "ओटीपी प्राप्त झाला नाही",
    hello_first_fragment: "नमस्कार",
    hello_second_fragment: "खरेदी तपशील",
    coming_soon: "लवकर येणार",
    packages: "पॅकेज",
    str_support: "सहाय्य",
    delete_acct: "खाते हटवा",
    delete_conform: "तुम्ही नक्कीच खाते हटवू इच्छिता?",
    delete_profile_success: "प्रोफाइल यशस्वीरित्या काढण्यात आले",
    Dlt_Accnt_msg: "खाते हटवण्याचे संदेश",
    some_error_occurred_please_try_again:
      "काही त्रुटी झाली. कृपया पुन्हा प्रयत्न करा.",
    auto: "ऑटो",
    player_not_ready_try_again: "प्लेयर तयार नाही. कृपया पुन्हा प्रयत्न करा.",
    edit_profile: "प्रोफाइल संपादन",
    learn_more: "अधिक शिका",
    wishlist: "इच्छा यादी",
    category_name: "वर्ग",
    str_my_download: "माझे डाउनलोड",
    language: "भाषा",
    added_watch_list: "पाहण्याच्या यादीत दाखल",
    removed_watch_list: "पाहण्याच्या यादीतून काढले",
    viewall: "सर्व पाहा",
    msg_video_expired:
      "हा व्हिडिओ कालबाह्य झाला आहे. पुन्हा खरेदी करा आणि पाहा.",
    skip_intro: "イント्रो सोडा",
    settings: "सेटिंग्ज",
    video_quality: "व्हिडिओ गुणवत्ता",
    video_speed: "व्हिडिओ वेग",
    like: "लाइक",
    unlike: "अनलाइक",
    refund: "परताव",
    userProfile: "वापरकर्ता प्रोफाइल",
    signup_create_new_account: "साइन अप: नवीन खाते तयार करा",
    already_acc_login: "आता खाते आहे? लॉगिन करा",
    accept_terms_and_condition: "शर्ती आणि अटी स्वीकारा",
    new_password: "नवीन पासवर्ड",
    api_failure_msg: "एपीआय फेल्युर मेसेज",
    remove_profile_pic: "प्रोफाइल चित्र काढा",
    remove: "काढा",
    msg_remove_profile_pic: "प्रोफाइल चित्र काढण्याचे संदेश",
    profile_photo: "प्रोफाइल फोटो",
    purchased_video: "खरेदी केलेले व्हिडिओ",
    upgrade: "अपग्रेड",
    msg_send_otp: "ओटीपी पाठवा",
    forgot_your_password: "तुमचा पासवर्ड विसरलात?",
    msg_search_content: "सामग्री शोधा",
    current_plan: "सद्य प्लान",
    more_like_this: "हे सारखे अधिक",
    download_channel_id: "डाउनलोड चॅनेल आयडी",
    download_video_service_channel: "डाउनलोड व्हिडिओ सेवा चॅनेल",
    searchLikehotStar: "डाउनलोड सापडले नाही",
    don_t_have_an_account: "खाते नाही?",
    delete_video: "व्हिडिओ हटवा",
    sign_up: "सहमती",
    having_forget_password: "पासवर्ड विसरलात?",
    complete_profile: "प्रोफाइल पूर्ण करा",
    add_profile: "प्रोफाइल जोडा",
    wait_to_play_video: "व्हिडिओ प्ले करण्यासाठी प्रतीक्षा करा",
    buy_now_at: "आता खरेदी करा",
    upgrade_now_at: "आता अपग्रेड करा",
    new_text: "नवीन टेक्स्ट",
    rate_app_title: "दर्जा",
    rate_app_message:
      "आमच्या अॅपचा आनंद घेत असाल तर कृपया प्लेस्टोरवर दर्जा द्या. धन्यवाद.",
    rate_btn_pos: "आता दर्जा द्या",
    rate_btn_neg: "नंतर सांगा",
    rate_btn_nut: "नाही धन्यवाद",
    change_name: "नाव बदला",
    download_options: "डाउनलोड पर्याय",
    low_quality: "कमी गुणवत्ता",
    medium_quality: "मध्यम गुणवत्ता",
    high_quality: "उच्च गुणवत्ता",
    downloading: "डाउनलोड होत आहे",
    download_pause: "डाउनलोड थांबवा",
    downloaded: "डाउनलोड झाले",
    download_url_is_not_found: "डाउनलोड यूआरएल सापडले नाही",
    download_running: "डाउनलोड चालू आहे",
    no_plan_subscribed: "कोणताही प्लान सदस्यता नाही",
    privacypolicy: "गोपनीयता धोरण",
    termsuse: "शर्ती आणि अटी",
    resendotp_in: "ओटीपी पुन्हा पाठवा (लॉगिनसाठी आवश्यक)",
    login_required: "लॉगिन आवश्यक",
    sorry_we_couldn_t_complete_your_request_please_try_again_in_a_moment:
      "क्षमस्व, आम्ही तुमची विनंती पूर्ण करू शकलो नाही. कृपया काही क्षणांनी पुन्हा प्रयत्न करा.",
    trailer: "ट्रेलर",
    subscribe_now_to_watch: "आता सदस्यता घ्या आणि पाहा",
    app_version: "अॅपची आवृत्ती",
    select_all: "सर्व निवडा",
    please_enter_valid_name: "कृपया वैध नाव टाका",
    choose_avatar: "कृपया अवतार निवडा",
    enter_name: "कृपया नाव टाका",
    unselect_all: "सर्व निवडा काढा",
    enter_mobile_number: "मोबाइल नंबर टाका",
    title_activity_scan_qr_code: "क्यूआर कोड स्कॅन करा",
    plz_enter_name: "कृपया नाव टाका",
    plz_change_name: "कृपया नाव बदला",
    plz_choose_avtar: "कृपया अवतार निवडा",
    plz_select_profile: "कृपया प्रोफाइल निवडा",
    who_s_watching: "कोण पाहत आहे?",
    my_profile: "माझे प्रोफाइल",
    profiles: "प्रोफाइल",
    clear: "साफ करा",
    recent_searches: "अलीकडील शोध",
    Recommended_searches: "शिफारस शोध",
    please_enter_your_number_to_discover_a_variety_nof_movies_sports_series:
      "कृपया तुमचा नंबर टाका आणि विविध चित्रपट, क्रीडा आणि मालिका शोधा.",
    mobile_number: "मोबाइल नंबर",
    having_issue_contact_us: "समस्या येत आहे? आमच्याशी संपर्क साधा!",
    didn_t_receive_code_resend: "कोड प्राप्त झाला नाही? पुन्हा पाठवा",
    enter_the_verification_code_we_just_sent_to_your_number:
      "तुमच्या नंबरवर आम्ही पाठवलेला सत्यापन कोड टाका",
    incorrect_otp_entered_please_enter_again:
      "चुकीचा ओटीपी टाकला. कृपया पुन्हा टाका.",
    app_update_title: "अॅप अद्ययावत",
    app_update_msg: "अॅपची नवीन आवृत्ती उपलब्ध आहे",
    watch_now: "आता पाहा",
    my_list: "माझी यादी",
    cast_and_crew: "कास्ट आणि क्रू",
    similar_to_this: "ह्यासारखे",
    similar_channels: "समान चॅनेल",
    delete_account: "खाते हटवा",
    delete_account_desc: "तुम्ही नक्कीच खाते हटवू इच्छिता",
    delete_conform: "प्रोफाईल?",
    log_out: "लॉगआउट",
    log_out_desc: "तुम्ही या खात्यातून लॉगआउट करू इच्छिता?",
    pb_on_tv: "प्रसार भारती टीव्हीवर वापरा",
    link_device: "डिव्हाइसशी जोडा",
    linked_tv: "जोडलेले टीव्ही",
    link_with_tv: "तुम्ही टीव्हीशी जोडा इच्छिता?",
    no_result_found: "कोणताही निकाल सापडला नाही",
    search_again: "पुन्हा शोधा",
    no_list_found: "कोणतीही यादी सापडली नाही",
    no_list_found_desc:
      "कोणतीही यादी सापडली नाही. कृपया तुमची पसंदीदा माहिती जोडा",
    no_notifications: "कोणतीही सूचना नाही",
    no_notifications_desc: "तुमच्याकडे कोणतीही सूचना नाही. कृपया नंतर परत या",
    network_error: "नेटवर्क त्रुटी",
    retry: "पुन्हा प्रयत्न करा",
    open_setting: "सेटिंग्ज उघडा",
    internal_server: "आंतरिक सर्व्हर त्रुटी",
    internal_server_error:
      "सर्व्हरने तुमची विनंती प्रक्रिया करताना त्रुटी झाली.",
    go_back: "मागे जा",
    data_not_found: "डेटा सापडला नाही",
    page_not_found_desc: "तुम्ही पाहत असलेला पान उपलब्ध नाही",
    popular_search: "लोकप्रिय शोध",
    top_results: "सर्वोत्तम निकाल",
    guest_user: "अतिथी वापरकर्ता",
    channels: "चॅनेल",
    Radio: "रेडिओ",
    TV: "टीव्ही",
    favorites: "पसंदीदा",
    content_language: "सामग्री भाषा",
    app_language: "ॲपची भाषा",
    change_account: "प्रोफाइल बदला",
    move_account: "तुम्ही दुसरे प्रोफाइलवर जा इच्छिता?",
    update_profile: "तुमचे प्रोफाइल अद्ययावत झाले",
    added_profile: "तुमची प्रोफाइल यशस्वीरित्या जोडली गेली आहे",
    edit_update: "अद्ययावत",
    cast_crew: "कास्ट आणि क्रू",
    episodes: "एपिसोड",
    no_record: "कोणताही नोंद सापडला नाही",
    free_time_up: "मोफत वेळ संपला!",
    free_create_account: "साइन इन किंवा मोफत खाते तयार करा आणि पाहा.",
    adventure: "साहस",
    prasar_bharti: "प्रसार भारती",
    ind_broadcast: "(भारताचे सार्वजनिक सेवा प्रसारक)",
    back_to_home: "होमपेजवर परत जा",
    oops_page_not_found: "ओप्स पान सापडले नाही",
    page_looking: "तुम्ही पाहत असलेला पान उपलब्ध नाही",
    go_to_home: "होमपेजवर जा",
    popular_genres: "लोकप्रिय शैली",
    watchLanguage: "तुमच्या भाषेत पाहा",
    help_support: "मदत आणि समर्थन",
    customer_support: "ग्राहक समर्थन",
    contact_number: "संपर्क नंबर",
    email_address: "ईमेल पत्ता",
    share: "शेअर",
    copy: "कॉपी",
    copied: "कॉपी केले",
    bharat_ott: "भारत ओटीटी",
    home: "होम",
    policy: "परताव आणि रद्द करण्याचे धोरण",
    terms_condition: "शर्ती आणि अटी",
    your_account: "तुमचे खाते आहे?",
    continue: "चालू ठेवा",
    "login_here!": "येथे लॉगिन करा!",
    mobile: "मोबाइल",
    password: "पासवर्ड",
    forgot_password: "पासवर्ड विसरलात?",
    sign_up_here: "येथे साइन अप करा!",
    social_media: "सोशल मीडियावर चालू ठेवा",
    search_data: "सर्व शोध डेटा",
    description: "वर्णन",
    episode_name: "एपिसोड नाव",
    episode_num: "एपिसोड क्रमांक",
    page_looking_might:
      "तुम्ही पाहत असलेला पान उपलब्ध नाही किंवा नाव बदलले आहे किंवा तात्पुरते उपलब्ध नाही.",
    Ok: "ओके",
    otp_sent: "ओटीपी पाठवले",
    success: "यशस्वी",
    could_not_sent: "ओटीपी पाठवू शकले नाही",
    error: "त्रुटी",
    resent_otp: "ओटीपी पुन्हा पाठवले",
    enter_valid_otp: "कृपया वैध ओटीपी टाका",
    enter_six_digit_valid: "कृपया ६ अंकी वैध ओटीपी टाका",
    profile_creation: "प्रोफाइल निर्मिती",
    error_name: "कृपया प्रोफाइल नाव टाका",
    "Delete-Profile": "प्रोफाइल हटवा",
    add_to_watchlist: "पाहण्याच्या यादीत दाखल",
    added_to_watchlist: "पाहण्याच्या यादीत दाखल",
    like_it: "मी पसंत आहे",
    not_for_me: "माझ्यासाठी नाही",
    "n-number": "क्रमांक",
    "e-email": "ईमेल",
    "account-subscribe": "सदस्यता घ्या",
    "account-subscribe-upgrade": "अपग्रेड करा",
    "user-details-text": "वापरकर्ता तपशील",
    "acc-username": "वापरकर्ता नाव",
    "acc-enterusername": "वापरकर्ता नाव टाका",
    "acc-mobile": "मोबाइल क्रमांक",
    "acc-entermobile": "मोबाइल क्रमांक टाका",
    "acc-email": "ई-मेल पत्ता",
    "acc-enteremail": "ई-मेल पत्ता टाका",
    "acc-Gender": "लिंग",
    "acc-Gender1": "पुरुष",
    "acc-Gender2": "स्त्री",
    "acc-Gender3": "इतर",
    "acc-dob": "जन्म तारीख",
    "acc-save": "तपशील संचय",
    "my-account": "माझा खाता",
    "trans-history": "व्यवहार इतिहास",
    "acc-varified": "सत्यापित",
    "network-error": "नेटवर्क त्रुटी",
    "network-unable": "आपला इंटरनेट कनेक्शन तपासा",
    "network-retry": "पुन्हा प्रयत्न करा",
    "download-apps": "आमचे अॅप डाउनलोड करा",
    "PB-OTT": "पीबी ओटीटी",
    "copy-right": "कॉपीराइट",
    all_right: "सर्व हक्क सुरक्षित",
    versions: "आवृत्ती -",
    "Help-Support": "मदत आणि साहाय्य",
    "internet-connection": "इंटरनेट कनेक्टेड",
    "nointernet-connection": "कोणताही इंटरनेट कनेक्शन नाही",
    "Terms-and-Conditions": "शर्ती आणि अटी",
    "Help-&-Support": "मदत आणि साहाय्य",
    "unmute-tra": "ट्रेलर अनम्यूट करा",
    "mute-tra": "ट्रेलर म्यूट करा",
    favourite_lang: "प्रिय भाषा जोडा",
    added_lang: "जोडले",
    "no-notfication": "कोणतीही सूचना नाही",
    "notfication-dt": "आपल्याकडे अद्याप कोणतीही सूचना नाही. नंतर परत या.",
    or: "किंवा",
    and: "आणि",
    sahmat: "",
    "par-bheje": " ",
    "server-error": "आंतरिक सर्व्हर त्रुटी",
    "server-error-msg": "आपल्या विनंतीची प्रक्रिया करताना सर्व्हर त्रुटी आली.",
    "server-retry": "होमपेजवर जा",
    "watch-lang": "आपल्या भाषेत पाहा",
    "popular-genre": "लोकप्रिय शैली",
    subscription_heading:
      "पीबी ओटीटीवरील सर्व सामग्री पाहण्यासाठी सदस्यता घ्या",
    add: "जोडा",
    proceed_to_pay_btn: "पेमेंट करा",
    have_promo: "प्रोमो कोड आहे का?",
    promo_code: "प्रोमो कोड",
    enter_promo_code: "प्रोमो कोड टाका",
    apply_code_btn: "कोड लागू करा",
    select_live_channel_radio: "लाइव्ह चॅनेल आणि रेडिओ निवडा",
    radio_channels: "रेडिओ चॅनेल्स",
    submit_btn: "सादर करा",
    add_channel_radio: "टीव्ही चॅनेल आणि रेडिओ जोडा",
    live_tv_channels: "लाइव्ह टीव्ही चॅनेल्स",
    live_radio_channels: "लाइव्ह रेडिओ चॅनेल्स",
    upgrade_subscription: "सदस्यता सुधारा",
    you_pay: "आपले पेमेंट",
    rem_amt_curr_plan: "आपल्या सध्याच्या प्लॅनमधील उरलेली रक्कम",
    payble_amt: "पेमेंट करण्याची रक्कम",
    live_channel: "लाइव्ह चॅनेल",
    continue_watching: "पाहणे सुरू ठेवा",
    Exit: "बाहेर पडा",
    ExitMsg: "तुम्हाला नक्की ॲपमधून बाहेर पडायचे आहे का?",
  },
  Gujarati: {
    "no_data_found":"કોઈ ડેટા મળ્યો નથી",
    "Subscribe to watch":"હમણાં જોવા માટે સબ્સ્ક્રાઇબ કરો",
      "Drama": "નાટક",
  "Tracks": "ટ્રેક્સ",
  "Romance": "પ્રેમકથા",
  "Fantasy": "ફૅન્ટેસી",
  "Contemporary Fiction": "આધુનિક કલ્પિત વાર્તા",
  "History": "ઇતિહાસ",
  "Mystery": "રહસ્ય",
  "Wildlife": "વન્યજીવન",
  "Thriller": "થ્રિલર",
  "Horror": "ભયાનક",
  "Educational": "શૈક્ષણિક",
  "Recent Live": "તાજેતરના લાઈવ",
  "Health": "આરોગ્ય",
  "Biography": "જીવનચરિત્ર",
  "Musical Drama": "સંગીત નાટક",
  "Music & Dance": "સંગીત અને નૃત્ય",
  "Dance Drama": "નૃત્ય નાટક",
  "Music": "સંગીત",
  "Sports": "રમતગમત",
  "Adventure": "સાહસ",
  "Animation": "એનિમેશન",
  "Literature": "સાહિત્ય",
  "Arts & Culture": "કલા અને સંસ્કૃતિ",
  "Religious": "ધાર્મિક",
  "Crime": "અપરાધ",
  "Science Fiction": "વિજ્ઞાન કથા",
  "Survival": "સર્વાઇવલ",
  "Spiritual": "આધ્યાત્મિક",
  "Detective": "ગુપ્તચર",
  "Mythology": "પુરાણકથા",
  "Entertainment": "મનોરંજન",
  "Historical Fiction": "ઇતિહાસ આધારિત વાર્તા",
  "Political": "રાજકીય",
  "Classical Music": "શાસ્ત્રીય સંગીત",
  "Comedy": "હાસ્ય",
  "Satire": "વ્યંગ્ય",
  "War": "યુદ્ધ",
"Rom-Com": "રોમ-કોમ",
  "Humor": "હાસ્યપ્રદ",
  "Autobiography": "આત્મકથા",
  "Lifestyle": "જીવનશૈલી",
  "Kids & Family": "બાળકો અને પરિવાર",
  "Devotional": "ભક્તિપૂર્ણ",
  "Nature & Wildlife": "પ્રકૃતિ અને જંગલી જીવન",
  "Travelogue": "પ્રવાસ વર્ણન",
  "Folk Music": "લોકસંગીત",
  "Storytelling": "વાર્તાકથન",
  "Dance": "નૃત્ય",
  "Carnatic Music": "કર્ણાટક સંગીત",
"Finance": "નાણાકીય",
"Hobbies And Crafts": "શોખ અને હસ્તકલા",
"Business and Finance": "વ્યવસાય અને નાણાકીય",
"Industrial design": "ઔદ્યોગિક ડિઝાઇન",
  "Talk Shows": "વાતચીત કાર્યક્રમો",
  "Inspirational": "પ્રેરણાદાયી",
  "Reality": "રિયલિટી",
  "Action": "એક્શન",
  "Agriculture": "કૃષિ",
  "International": "આંતરરાષ્ટ્રીય",
  "Anime": "એનિમે",
  "Period Drama": "ઇતિહાસ નાટક",
  "Sci-Fi": "વૈજ્ઞાનિક કલ્પના",
  "Patriotic": "દેશભક્તિપૂર્ણ",
  "Performing Arts": "અભિનય કલા",
  "Astrology": "જ્યોતિષ",
  "Fashion": "ફેશન",
  "Talent Hunt": "પ્રતિભા શોધ",
  "Cookery": "રસોઈ",
  "Talk Show": "વાતચીત કાર્યક્રમ",
  "Superhero": "સુપરહિરો",
  "Literary Fiction": "સાહિત્યિક કલ્પિત વાર્તા",
  "Science": "વિજ્ઞાન",
  "Scientific": "વૈજ્ઞાનિક",
  "Cooking": "રસોઈ",
  "Food": "અન્ન",
  "Travel": "પ્રવાસ",
  "Paintings": "ચિત્રો",
  "Design": "ડિઝાઇન",
  "Art": "કલા",
  "Nature": "પ્રકૃતિ",
  "Arts And Culture": "કલા અને સંસ્કૃતિ",
  "Educational Books": "શૈક્ષણિક પુસ્તકો",
  "Young Adult Fiction": "યુવાન વાચકો માટે વાર્તા",
  "News": "સમાચાર",
  "Technology": "ટેકનોલોજી",
  "Open World": "ખુલ્લી દુનિયા",
  "Business": "વ્યવસાય",
  "Home Decor": "ઘર સજાવટ",
  "Chat Show": "ચેટ શો",
  "Edutainment": "શૈક્ષણિક મનોરંજન",
  "Social Awareness": "સામાજિક જાગૃતિ",
  "Event": "પ્રસંગ",
  "Hindustani Classical Music": "હિંદુસ્તાની શાસ્ત્રીય સંગીત",
  "Semi-Classical Music": "અર્ધ શાસ્ત્રીય સંગીત",
  "Kids": "બાળકો",
  "Celebration": "ઉજવણી",
  "Casual": "અનૌપચારિક",
  "Medical": "તબીબી",
  "Yojna": "યોજના",
  "Sculptures": "શિલ્પો",
  "Carbatic Music": "કર્ણાટક સંગીત",
  "Digital Literacy": "ડિજિટલ સાક્ષરતા",
  "Legal And Ethical": "કાનૂની અને નૈતિક",
  "Digital art": "ડિજિટલ કલા",
  "Parenting": "પેરેન્ટિંગ",
    Sports:"રોમેન્ટિકકોમેડી",
        inviteReferr:"તમારા મિત્રને આ અનુભવે જોડાવા આમંત્રણ આપો",
     refer_friend:"મિત્રને ભલામણ કરો",
     Begins_on:"શુંતમેખરેખરપ્રોફાઇલડિલીટકરવામાગોચો?",
    Left:"બાકી",
    "pbApp":"wavespb.comપરહમણાંજસબ્સ્ક્રાઇબકરોઅનેતમામકન્ટેન્ટસુખમેળવોઆ",
    dislike:"નાપસંદ",
    rentalDescriptionMsg:"www.wavespb.com પરથી સામગ્રી ખરીદવાનું ચાલુ રાખો",
     "Okay, Got it":"માન્યઉપકરણો",
    Yes: "હા",
    No: "ના",
    "Referral code is empty": "રિફેરલ કોડ ખાલી છે",
    "Enter a valid referral code": "માન્ય રિફેરલ કોડ દાખલ કરો",
    Movies: "ફિલ્મો",
    Audio: "ઓડિયો",
    Shows: "શો",
    Music: "સંગીત",
    All: "બધા",  
    Live: "લાઇવ",
    Documentary: "દસ્તાવેજી",
    "Recently Added": "તાજેતરમાં ઉમેરેલ",
    Nostalgia: "નોસ્ટેલ્જિયા",
    "News Features": "સમાચાર ફીચર્સ",
    "Waves Originals": "વેવ્સ ઓરિજિનલ્સ",
    Action: "એક્શન",
    Kids: "બાળકો",
    Romance: "રોમાન્સ",
    Comedy: "કૉમેડી",
    startOver: "ફરીથી શરૂ કરો",
    Thriller: "થ્રિલર",
    Live_Events: "લાઇવ ઇવેન્ટ" ,
    Devotional: "ભક્તિ",
    Shorts: "શોર્ટ્સ",
    Scan_using_app_or_mobile_camera1: "એપ કે મોબાઇલ કેમેરા વડે સ્કેન કરો",
    Having_Trouble_Logging_in:
      "લોગિન કરવા માં તકલીફ છે? કૃપા કરીને www.wavespb.com મુલાકાત લો",
    have_refferel_code: "શું તમારા પાસે રેફરલ કોડ છે?",
    view_more: "વધુ જુઓ",
    view_less: "ઓછું જુઓ",
    streaming_from: "થી સ્ટ્રીમિંગ",
    "Session-Expired": "સત્ર સમાપ્ત થયું",
    "session-desc": "તમારી સત્ર સમય મર્યાદા પૂર્ણ થઈ ગઈ છે.",
    RentAvailable: "₹ પર ભાડે ઉપલબ્ધ",
    RentMsg: "ખરીદીના દિવસે આ કન્ટેન્ટ જોવા માટે 30 દિવસના ભાડા સમાવેશ થાય છે.",
    "Error!": "ભૂલ!",
    streaming_start: "સ્ટ્રીમિંગમાંથી",
    midnight: " મધરાતથી શરૂ થશે",
    "Success!": "સફળતા!",
    WatchlistError: "વૉચલિસ્ટમાં ઉમેરવામાં અસક્ષમ. કૃપા કરીને ફરી પ્રયાસ કરો.",
    WatchlistSuccess: "સફળતાપૂર્વક વૉચલિસ્ટમાં ઉમેર્યું.",
    GamePlay: "હું કેવી રીતે રમી શકું?",
    PlayMsg:
      "આ ગેમ રમવા માટે, કૃપા કરીને Waves PB એપ્લિકેશનનો ઉપયોગ કરો અથવા www.wavespb.com પર જાઓ.",
    "Login to Continue": "ચાલુ રાખવા માટે લૉગિન કરો",
    LoginContinue: "મહેરબાની કરીને અમારા એપની સંપૂર્ણ ઍક્સેસ માટે લૉગિન કરો.",
    Prasar_Bharti_Mobile_App:
      "અને પ્રસાર ભારતી મોબાઇલ ઍપ પર તમારું પ્રોફાઇલ સંપાદિત કરો.",
    go_to_account: '"મારું ખાતું" પર જાઓ',
    clear: "સાફ કરો",
    del: "કાઢો",
    space: "જગ્યા",
    RefferalMsg: "જે નંબર પહેલાથી જ નોંધાયેલ છે, તેમને લાગુ પડતું નથી!",
    referal_code: "રેફરલ કોડ",
    Live_Events: "લાઈવ ઇવેન્ટ",
    RefferalCode: "રેફરલ કોડ",
    Apply: "લાગુ કરો",
    ResuminWating: "ચાલુ રાખો",
    no_additional_track: "કોઈ વધારાનો ઓડિયો ટ્રેક ઉપલબ્ધ નથી",
    having_trouble_loggin_in_please_visit_our_website:
      "લોગિન કરવામાં મુશ્કેલી આવી રહી છે? કૃપા કરીને અમારી વેબસાઇટ પર જાઓ.",
    Subscribewatch: "વોચ પર સબ્સ્ક્રાઇબ",
    SubscribeMsg:
      "આ સામગ્રી જોવા માટે, કૃપા કરીને અમારી વેબસાઇટ www.wavespb.com પર તમારી ખરીદી પૂર્ણ કરો.",
    Subscribelisten: "લિસ્ટન પર સબ્સ્ક્રાઇબ",
    available_to_rent: "રેન્ટ પર ઉપલબ્ધ",
    login_with: "સાથે લોગિન",
    LoginToWatch: "હવે જુઓ",
    Watchnow: "હવે જુઓ",
    ListenToWatch: "હવે સાંભળો",
    availableOnRent: "ભાડા પર ઉપલબ્ધ",
    or: "અથવા",
    done: "પૂર્ણ",
    Listennow: "હવે સાંભળો",
    skip_start_browsing: "સ્કિપ કરો અને બ્રાઉઝ કરવું શરૂ કરો",
    Logout: "લોગઆઉટ",
    proceed: "આગળ વધો",
    get_a_new_code: "નવો કોડ મેળવો",
    "Help&Support": "મદદ અને સહાય",
    "Privacy-Policy": "પ્રાઇવસી પોલિસી",
    "Term&Conditions": "શરતો અને સ્થિતિઓ",
    enter_mobile_number: "મોબાઇલ નંબર દાખલ કરો",
    "About-Us": "અમારા વિશે",
    Search_: "શોધ",
    left: "ડાબુ",
    subtitle: "ઉપશીર્ષક",
    no_subtitle: "કોઈ ઉપશીર્ષક ઉપલબ્ધ નથી",
    "Top-Results": "ટોપ પરિણામો",
    "Popular-Searches": "લોકપ્રિય શોધો",
    "Popular-Search": "લોકપ્રિય શોધ",
    searchplaceholder: "કલાકાર, શોઅઝ, પ્લેલિસ્ટો કે સામગ્રી શોધો",
    welcome_to_dds_world_of_entertainment: "મનોરંજનની લહેર",
    enter_your_mobile_number_or_email_to_continue:
      "ચાલુ રાખવા માટે તમારો મોબાઇલ નંબર અથવા ઇમેલ દાખલ કરો",
    sign_in_with_mobile_or_email: "મોબાઇલ અથવા ઇમેલથી સાઇન ઇન કરો",
    Home_: "હોમ",
    Live_: "ટીવી/રેડિયો",
    "Delete-Account": "એકાઉન્ટ ડિલીટ",
    Watchlist: "વોચલિસ્ટ",
    "My-Profile": "મારું પ્રોફાઇલ",
    Edit: "સંપાદન",
    Add: "ઉમેરો",
    "Edit-Profile": "પ્રોફાઇલ સંપાદન",
    "Add-Profile": "પ્રોફાઇલ ઉમેરો",
    "Who’sWatching?": "કોણ જુએ છે?",
    "placeholder-profile": "પ્રોફાઇલ નામ દાખલ કરો",
    "Kid’sprofile?": "બાળકનું પ્રોફાઇલ?",
    "Onlyshowkid-friendlyvideos": "ફક્ત બાળક મિત્ર વિડિઓ દર્શાવો",
    "No-Result-Found": "કોઈ પરિણામ મળ્યું નથી",
    "try-other-keyword": "અન્ય કીવર્ડ પ્રયત્ન કરો",
    "No-data-found": "કોઈ ડેટા મળ્યું નથી",
    "No-list-found": "કોઈ યાદી મળ્યું નથી. તમે અન્ય યાદીઓ ઉમેરો",
    Scan_using_app_or_mobile_camera: "મોબાઇલ એપ્લિકેશનનો ઉપયોગ કરીને સ્કેન કરો",
    "Continue-Watching": "ચાલુ જુઓ",
    Login: "લોગિન",
    Guest: "અતિથિ",
    "Login-to-your-account": "તમારા   કાઉન્ટ પર લોગિન",
    "Login-enter-no":
      "તમારા મોબાઇલ નંબર દાખલ કરો અને વિવિધ ફિલ્મો, ખેલો અને સિરિઝ જુઓ",
    "Login-enter-no-email":
      "તમારા ઇમેઇલ દાખલ કરો અને વિવિધ ફિલ્મો, ખેલો અને સિરિઝ જુઓ",
    "Phone-Number": "મોબાઇલ નંબર",
    "sms-verify": "તમારા મોબાઇલ નંબર પર ઓટીપી મળશે",
    "email-verify": "તમારા ઇમેઇલ પર ઓટીપી મળશે",
    "Send-OTP": "ઓટીપી મોકલો",
    "confirm-that-agree":
      "તમે સંમતિ કરો કે તમે આ શરતો અને સ્થિતિઓ સાથે સંમતિ કરો છો",
    "OTP-Verification": "ઓટીપી વેરિફિકેશન",
    "verification-code": "વેરિફિકેશન કોડ દાખલ કરો",
    "not-receive-code": "કોડ મળ્યું નથી?",
    Resend: "ફરીથી મોકલો",
    "Having-Issue?": "કોઈ સમસ્યા છે?",
    "Contact-Us": "અમને સંપર્ક કરો!",
    "Enter-Phone-Number": "મોબાઇલ નંબર દાખલ કરો",
    "Resend-OTP-in": "ફરીથી ઓટીપી મોકલો આવતા",
    verify: "વેરિફાઇ",
    "cofirm-logout":
     "શું તમે ખરેખર એપમાંથી લૉગઆઉટ કરવા માંગો છો?",
    Confirm: "પુષ્ટિ કરો",
    logout: "લોગઆઉટ",
    notifications: "સંબંધિત સુચનાઓ",
    registered_devices: "સજાવાત ઉપકરણો",
    clear_search_history: "શોધો વિવરણની શુંભળ",
    subscription_and_devices: "સબ્સ્ક્રાઇબશન અને ઉપકરણો",
    subscription: "સબ્સ્ક્રાઇબશન",
    my_device: "મારી ઉપકરણ",
    Cancel: "રદ કરો",
    payment_details: "ચલાનું વિવરણ",
    other_devices: "દુઃખિત ઉપકરણો",
    deregister: "સજાવા કરો",
    "Content-Language-Changed": "વિગત ભાષા બદલી ગયો",
    "App-Language-Changed": "એપ ભાષા બદલી ગયો",
    "Change-Language": "ભાષા બદલો",
    Previous: "ગત",
    More: "વધુ",
    audio_quality: "ઓડિયો ગુણવત્તા",
    speed: "ગતિ",
    Delete: "કાઢીનાખો",
    Notification: "સુચના",
    no_noti_found: "સુચના મળ્યું નથી",
    Artist: "કલાકાર",
    just_now: "હમણાં જ",
    title_activity_purchase_history: "ખરીદી વિવરણ",
    first_fragment_label: "પ્રથમ ફ્રેગ્મેન્ટ",
    second_fragment_label: "બીજો ફ્રેગ્મેન્ટ",
    Next: "આગળ",
    next_episode: "આગળનો એપિસોડ",
    Download: "ડાઉનલોડ",
    transaction_history: "લેનદેની વિવરણ",
    no_transaction_history: "લેનદેની વિવરણ મળ્યું નથી",
    str_watch_list: "વોચલિસ્ટ",
    my_purchased_video: "મારા ખરીદેલા વિડિઓ",
    subscribe_: "સબ્સ્ક્રાઇબ કરો",
    plan_price: "પ્લાન કિંમત",
    remaining_balance: "બાકી રાશિ",
    total_amount: "કુલ રાશિ",
    n_a: "એન/એ",
    run_on_physical_device_only: "ફક્ત ભ  તિક ઉપકરણ પર ચલાવો",
    btn_ok: "ઠીક છે",
    msg_vpn_error: "વીપીએન ત્રુટિ",
    note_your_code_will_be_updated_after_5_min:
      "નોટ: તમારો કોડ 5 મિનિટ પછી અપડેટ થશે",
    payable_amount: "ચલાનું કિંમત",
    didnt_receive_otp: "ઓટીપી મળ્યું નથી",
    hello_first_fragment: "હેલો",
    hello_second_fragment: "ખરીદી વિવરણ",
    coming_soon: "આવતું છે",
    packages: "પેકેજો",
    str_support: "સહાય",
    delete_acct: "એકાઉન્ટ ડિલીટ",
    delete_conform: "તમે વિશ્વાસ કરો છો કે તમે આ ખાતા સે ડિલીટ કરવા માંગો છો?",
    delete_profile_success: "પ્રોફાઇલ સફળતાપૂર્વક દૂર કરી",
    Dlt_Accnt_msg: "એકાઉન્ટ ડિલીટ સંદેશ",
    some_error_occurred_please_try_again: "કોઈ ત્રુટિ થઈ છે. ફરીથી પ્રયત્ન કરો",
    auto: "ઓટો",
    player_not_ready_try_again: "ખેલાડી તૈયાર નથી. ફરી પ્રયત્ન કરો.",
    edit_profile: "પ્રોફાઇલ સંપાદિત કરો",
    learn_more: "વધુ જાણો",
    wishlist: "ઇચ્છાની યાદી",
    category_name: "વર્ગ",
    str_my_download: "મારા ડાઉનલોડ",
    language: "ભાષા",
    added_watch_list: "વોચલિસ્ટમાં ઉમેરવામાં આવ્યું",
    removed_watch_list: "વોચલિસ્ટમાંથી દૂર કરવામાં આવ્યું",
    viewall: "બધા જુઓ",
    msg_video_expired: "આ વિડિઓ સમય પૂર્ણ થયેલ છે. ફરી ખરીદો અને જુઓ.",
    skip_intro: "ઇન્ટ્રો સ્કિપ કરો",
    settings: "સેટિંગ્સ",
    video_quality: "વિડિઓ ગુણવત્તા",
    video_speed: "વિડિઓ સ્પીડ",
    like: "પસંદ",
    unlike: "અપસંદ",
    refund: "રિફંડ",
    userProfile: "યુઝર પ્રોફાઇલ",
    signup_create_new_account: "સાઇન અપ: નવું ખાતું બનાવો",
    already_acc_login: "પહેલેથી ખાતું છે? લોગિન કરો",
    accept_terms_and_condition: "શરતો અને સ્થિતિઓ સ્વીકારો",
    new_password: "નવું પાસવર્ડ",
    api_failure_msg: "એપીઆઇ નિષ્ફળતા સંદેશ",
    remove_profile_pic: "પ્રોફાઇલ ફોટો દૂર કરો",
    remove: "દૂર કરો",
    msg_remove_profile_pic: "પ્રોફાઇલ ફોટો દૂર કરવાનું સંદેશ",
    profile_photo: "પ્રફાઇલ ફોટો",
    purchased_video: "ખરીદેલ વિડિઓ",
    upgrade: "અપગ્રેડ",
    msg_send_otp: "ઓટીપી મોકલો",
    forgot_your_password: "તમારું પાસવર્ડ ભૂલી ગયું?",
    msg_search_content: "સાહિત્ય શોધો",
    current_plan: "હાલની યોજના",
    more_like_this: "આ જેવું વધુ",
    download_channel_id: "ડાઉનલોડ ચેનલ આઈડી",
    download_video_service_channel: "ડાઉનલોડ વિડિઓ સેવા ચેનલ",
    searchLikehotStar: "હોટસ્ટાર જેવું શોધો",
    don_t_have_an_account: "તમારું ખાતું નથી?",
    delete_video: "વિડિઓ દૂર કરો",
    sign_up: "સાઇન અપ",
    having_forget_password: "તમારું પાસવર્ડ ભૂલી ગયું?",
    complete_profile: "પૂર્ણ પ્રોફાઇલ",
    add_profile: "પ્રોફાઇલ ઉમેરો",
    wait_to_play_video: "વિડિઓ રમાવા માટે પ્રતીક્ષા કરો",
    buy_now_at: "હાલ ખરીદો આટ",
    upgrade_now_at: "હાલ અપગ્રેડ કરો આટ",
    new_text: "નવું ટેક્સ્ટ",
    rate_app_title: "રેટ કરો",
    rate_app_message: "આપને આપની એપ માટે આનંદ થયો છે, તો પ્લેસ્ટોર પર રેટ કરો.",
    rate_btn_pos: "હાલ રેટ કરો",
    rate_btn_neg: "પાછા યાદ કરો",
    rate_btn_nut: "ના માટે",
    change_name: "નામ બદલો",
    download_options: "ડાઉનલોડ વિકલ્પો",
    low_quality: "નીચી ગુણવત્તા",
    medium_quality: "મધ્યમ ગુણવત્તા",
    high_quality: "ઊંચી ગુણવત્તા",
    downloading: "ડાઉનલોડિંગ",
    download_pause: "ડાઉનલોડ પોઝ કરો",
    downloaded: "ડાઉનલોડ કર્યું",
    download_url_is_not_found: "ડાઉનલોડ યુઆરએલ મળી નથી",
    download_running: "ડાઉનલોડ ચાલું છે",
    no_plan_subscribed: "કોઈ યોજના સબસ્ક્રાઇબ નથી",
    privacypolicy: "પ્રાઇવસી પોલિસી",
    termsuse: "શરતો અને સ્થિતિઓ",
    resendotp_in: "ઓટીપી ફરી મોકલો (લોગિન માટે જરૂરી)",
    login_required: "લોગિન જરૂરી",
    sorry_we_couldn_t_complete_your_request_please_try_again_in_a_moment:
      "સોરી, આપની વિનંતી પૂરી કરી શક્ય નથી. કૃપા કરી ફરી પ્રયત્ન કરો.",
    trailer: "ટ્રેઇલર",
    subscribe_now_to_watch: "હાલ સબસ્ક્રાઇબ કરો અને જુઓ",
    app_version: "એપ વર્ઝન",
    select_all: "બધા પસંદ કરો",
    please_enter_valid_name: "કૃપા કરી વલિદ નામ દાખલ કરો",
    choose_avatar: "કૃપા કરીને અવતાર પસંદ કરો",
    enter_name: "કૃપા કરીને નામ દાખલ કરો",
    unselect_all: "બધા અપસંદ કરો",
    enter_mobile_number: "મોબાઇલ નંબર દાખલ કરો",
    title_activity_scan_qr_code: "ક્યુઆર કોડ સ્કેન કરો",
    plz_enter_name: "કૃપા કરી નામ દાખલ કરો",
    plz_change_name: "કૃપા કરી નામ બદલો",
    plz_choose_avtar: "કૃપા કરી અવતાર પસંદ કરો",
    plz_select_profile: "કૃપા કરી પ્રોફાઇલ પસંદ કરો",
    who_s_watching: "કોણ જુએ છે?",
    my_profile: "મારું પ્રોફાઇલ",
    profiles: "પ્રોફાઇલો",
    clear: "સાફ કરો",
    recent_searches: "હાલના શોધો",
    Recommended_searches: "સલાહ શોધો",
    please_enter_your_number_to_discover_a_variety_nof_movies_sports_series:
      "કૃપા કરી તમારું નંબર દાખલ કરો અને ફિલ્મો, સ્પોર્ટ્સ અને સીરીઝની વિવિધતા શોધો.",
    mobile_number: "મોબાઇલ નંબર",
    having_issue_contact_us: "મુદ્દા થયેલ છે? આપને સંપર્ક કરો",
    didn_t_receive_code_resend: "કોડ મળી નથી? ફરી મોકલો",
    enter_the_verification_code_we_just_sent_to_your_number:
      "તમારા નંબર પર આપણે મોકલેલ વેરિફિકેશન કોડ દાખલ કરો",
    incorrect_otp_entered_please_enter_again:
      "ખોટું ઓટીપી દાખલ કર્યું. ફરી દાખલ કરો.",
    app_update_title: "એપ અપડેટ",
    app_update_msg: "એપની નવી આવૃત્તિ હાલ ઉપલબ્ધ છે",
    watch_now: "હાલ જુઓ",
    my_list: "મારી યાદી",
    cast_and_crew: "કાસ્ટ અને ક્રૂ",
    similar_to_this: "આ જેવું",
    similar_channels: "સમાન ચેનલો",
    delete_account: "ખાતું દૂર કરો",
    delete_account_desc: "શું તમે તમારું ખાતું દૂર કરવા માંગો છો",
    delete_conform: "પ્રોફાઇલ?",
    log_out: "લોગ આઉટ",
    log_out_desc: "તમારું ખાતું લોગ આઉટ કરવાનું ખાતરી છે?",
    pb_on_tv: "ટીવી પર પ્રસાર ભારતી",
    link_device: "ડિવાઇસ સાથે લિંક",
    linked_tv: "લિંક કરેલી ટીવી",
    link_with_tv: "ટીવી સાથે લિંક કરવા માટે તમે ખાતરી કરો છો?",
    no_result_found: "કોઈ પરિણામ મળ્યા નથી",
    search_again: "ફરીથી શોધો",
    no_list_found: "કોઈ યાદી મળી નથી",
    no_list_found_desc:
      "તમારી પસંદગીની માહિતી સમાવતી યાદી મળી નથી, કૃપા કરીને તેને સમાવો",
    no_notifications: "કોઈ સૂચનાઓ નથી",
    no_notifications_desc: "તમારી પાસે હજુ કોઈ સૂચનાઓ નથી. કૃપા કરીને પાછા આવો",
    network_error: "નેટવર્ક ત્રુટિ",
    retry: "ફરીથી પ્રયત્ન કરો",
    open_setting: "સેટિંગ્સ ખોલો",
    internal_server: "આંતરિક સર્વર ત્રુટિ",
    internal_server_error:
      "સર્વર તમારી વિનંતી પ્રોસેસ કરતી વખતે એક ત્રુટિ થઈ છે.",
    go_back: "પાછા જાઓ",
    data_not_found: "ડેટા મળ્યા નથી",
    page_not_found_desc: "તમે જે પેજ જોઈ રહ્યા છો તે અસ્તિત્વમાં નથી",
    popular_search: "લોકપ્રિય શોધ",
    top_results: "ટોપ પરિણામ",
    guest_user: "અતિથિ વપરાસુ",
    channels: "ચેનલ્સ",
    Radio: "રેડિયો",
    TV: "ટીવી",
    favorites: "પ્રિય",
    content_language: "સામગ્રી ભાષા",
    app_language: "એપ્લિકેશન ભાષા",
    change_account: "ખાતા બદલો",
    move_account: "તમે અન્ય ખાતામાં જવા માટે ખાતરી કરો છો?",
    update_profile: "તમારું પ્રોફાઇલ સફળતાપૂર્વક અપડેટ થયું છે",
    added_profile: "તમારું પ્રોફાઇલ સફળતાપૂર્વક ઉમેરવામાં આવ્યું છે",
    edit_update: "અપડેટ કરો",
    cast_crew: "કાસ્ટ અને ક્રૂ",
    episodes: "એપિસોડ્સ",
    no_record: "કોઈ રેકોર્ડ મળ્યા નથી",
    free_time_up: "મફત સમય ઉપર!",
    free_create_account: "મફત ખાતા બનાવો અને આગળ જાઓ",
    adventure: "સાહસ",
    prasar_bharti: "પ્રસાર ભારતી",
    ind_broadcast: "(ભારતનો પ્રસાર સેવા)",
    back_to_home: "હોમ પાછા જાઓ",
    oops_page_not_found: "ઓહો! પેજ મળ્યા નથી",
    page_looking: "તમે જે પેજ જોઈ રહ્યા છો તે અસ્તિત્વમાં નથી",
    go_to_home: "હોમ પાછા જાઓ",
    popular_genres: "લોકપ્રિય પ્રકાર",
    watchLanguage: "તમારી ભાષામાં જુઓ",
    help_support: "મદદ અને સહાય",
    customer_support: "ગ્રાહક સહાય",
    contact_number: "સંપર્ક નંબર",
    email_address: "ઇમેઇલ સરનામા",
    share: "શેર",
    copy: "કોપી",
    copied: "કોપી કર્યું",
    bharat_ott: "ભારત ઓટીટી",
    home: "હોમ",
    policy: "રિફંડ અને કેન્સલેશન પોલિસી",
    terms_condition: "શરતો અને સ્થિતિઓ",
    your_account: "તમારું ખાતા",
    continue: "આગળ જાઓ",
    "login_here!": "અહીં લોગિન કરો!",
    mobile: "મોબાઇલ",
    password: "પાસવર્ડ",
    forgot_password: "પાસવર્ડ ભૂલી ગયું?",
    sign_up_here: "અહીં સાઇન અપ કરો!",
    social_media: "સોશિયલ મીડિયા દ્વારા આગળ જાઓ",
    search_data: "સર્ચ ડેટા",
    description: "વર્ણનવર્ણન",
    episode_name: "એપિસોડ નામ",
    episode_num: "એપિસોડ નંબર",
    page_looking_might:
      "તમે જે પેજ જોઈ રહ્યા છો તે અસ્તિત્વમાં નથી અથવા તેની નામ બદલી ગઈ હોય પર તે તપાસી શક્ય છે.",
    Ok: "ઓકે",
    otp_sent: "ઓ.ટી.પી સફળતાપૂર્વક બતાયો છે",
    success: "સફળતા",
    could_not_sent: "માત્ર મોબાઇલ નંબર બતાવી શકાય નથી",
    error: "ત્રુટિ",
    resent_otp: "ઓ.ટી.પી પુનઃ બતાયો છે",
    enter_valid_otp: "વધુ માન્ય ઓ.ટી.પી દાખલ કરો",
    enter_six_digit_valid: "વધુ શત્શબ્દ માન્ય ઓ.ટી.પી દાખલ કરો",
    profile_creation: "પ્રોફાઇલ સૃષ્ટિ સફળતાપૂર્વક થયું છે",
    error_name: "પ્રોફાઇલ નામ દાખલ કરો",
    "Delete-Profile": "પ્રોફાઇલ માટે વગાર કરો",
    add_to_watchlist: "વચ્ચે જોવા લિસ્ટ માં સફળતાપૂર્વક જોઇએ",
    added_to_watchlist: "વચ્ચે જોલિસ્ટ માં સફળતાપૂર્વક જોઇએ",
    like_it: "મારી પસંદ છે",
    not_for_me: "મારે માટે નથી",
    "n-number": "નંબર",
    "e-email": "ઇમેઇલ",
    "account-subscribe": "સબસ્ક્રાઇબ કરો",
    "account-subscribe-upgrade": "અપગ્રેડ કરો",
    "user-details-text": "વપરાસુ વિગતો",
    "acc-username": "વપરાસુ નામ",
    "acc-enterusername": "વપરાસુ નામ દાખલ કરો",
    "acc-mobile": "મોબાઇલ નંબર",
    "acc-entermobile": "મોબાઇલ નંબર દાખલ કરો",
    "acc-email": "ઇમેઇલ સરનામા",
    "acc-enteremail": "ઇમેઇલ સરનામા દાખલ કરો",
    "acc-Gender": "લિંગ",
    "acc-Gender1": "પુરુષ",
    "acc-Gender2": "સ્ત્રી",
    "acc-Gender3": "અન્ય",
    "acc-dob": "જન્મ તારીખ",
    "acc-save": "વિગતો સાચવો",
    "my-account": "મારું ખાતા",
    "trans-history": "લેન્ડન ઇતિહાસ",
    "acc-varified": "વેરિફાઇડ",
    "network-error": "નેટવર્ક ત્રુટિ",
    "network-unable": "નેટવર્ક સંપર્ક નથી",
    "network-retry": "ફરીથી પ્રયત્ન કરો",
    "download-apps": "એપ્લિકેશન ડાઉનલોડ કરો",
    "PB-OTT": "પીબી ઓટીટી",
    "copy-right": "કોપીરાઇટ",
    all_right: "બધા અધિકાર",
    versions: "વર્ઝન-",
    "Help-Support": "મદદ અને સહાય",
    "internet-connection": "ઇન્ટરનેટ સંપર્ક",
    "nointernet-connection": "ઇન્ટરનેટ સંપર્ક નથી",
    "Terms-and-Conditions": "नियम और शर्ते",
    "Help-&-Support": "सहायता और समर्थन",
    "unmute-tra": "ट्रे일र स्वचaalit करो",
    "mute-tra": "ट्रेलर बंद करो",
    favourite_lang: "पसंदीदा ढंग द्वारा थêm",
    added_lang: "थêm कर liye",
    "no-notfication": "कोई सूचना नहीं",
    "notfication-dt":
      "आपके पास अभी तक कोई सूचना नहीं है. कृपया बाद में वापस आएं.",
    or: "या",
    and: "और",
    sahmat: "",
    "par-bheje": " ",
    "server-error": "आंतरिक सर्वर त्रुटि",
    "server-error-msg": "आपके अनुरोध को संसाधित करते समय एक सर्वर त्रुटि हुई.",
    "server-retry": "होमपेज पर जाएं",
    "watch-lang": "आपकी भाषा में देखें",
    "popular-genre": "लोकप्रिय शैली",
    subscription_heading: "PB OTT पर सभी सामग्री देखने के लिए सदस्यता लें",
    add: "जोड़ें",
    proceed_to_pay_btn: "भुगतान करने के लिए आगे बढ़ें",
    have_promo: "क्या आपके पास प्रोमो कोड है?",
    promo_code: "प्रोमो कोड",
    enter_promo_code: "प्रोमो कोड दर्ज करें",
    apply_code_btn: "कोड लागू करें",
    select_live_channel_radio: "लाइव चैनल और रेडियो चुनें",
    radio_channels: "रेडियो चैनल",
    submit_btn: "प्रस्तुत करें",
    add_channel_radio: "टीवी चैनल और रेडियो जोड़ें",
    live_tv_channels: "लाइव टीवी चैनल",
    live_radio_channels: "लाइव रेडियो चैनल",
    upgrade_subscription: "सदस्यता अपग्रेड करें",
    you_pay: "आपका भुगतान",
    rem_amt_curr_plan: "आपकी वर्तमान योजना में शेष राशि",
    payble_amt: "देय राशि",
    live_channel: "लाइव चैनल",
    continue_watching: "देखना जारी रखें",
    Exit: "બહાર નીકળો",
    ExitMsg: "શું તમે ખરેખર એપમાંથી બહાર નીકળવા માંગો છો?",
  },
  Bangla: {
    "no_data_found":"কোনও ডেটা পাওয়া যায়নি।",
    "Subscribe to watch":"এখন দেখতে সাবস্ক্রাইব করুন",
   "Drama": "নাটক",
   "Tracks": "ট্র্যাকস",
  "Romance": "রোমান্স",
  "Fantasy": "ফ্যান্টাসি",
  "Contemporary Fiction": "আধুনিক গল্প",
  "History": "ইতিহাস",
  "Mystery": "রহস্য",
  "Wildlife": "বন্যজীবন",
  "Thriller": "থ্রিলার",
  "Horror": "ভয়",
  "Educational": "শিক্ষামূলক",
   "Recent Live": "সাম্প্রতিক লাইভ",
   "Survival": "সারভাইভাল",
  "Health": "স্বাস্থ্য",
  "Biography": "জীবনী",
  "Musical Drama": "সঙ্গীত নাটক",
  "Music & Dance": "সঙ্গীত ও নৃত্য",
  "Dance Drama": "নৃত্য নাটক",
  "Music": "সঙ্গীত",
  "Sports": "খেলা",
  "Adventure": "সাহসিক অভিযান",
  "Animation": "অ্যানিমেশন",
  "Literature": "সাহিত্য",
  "Arts & Culture": "কলা ও সংস্কৃতি",
  "Religious": "ধর্মীয়",
  "Crime": "অপরাধ",
  "Spiritual": "আধ্যাত্মিক",
  "Detective": "গুপ্তচর",
  "Mythology": "পুরাণ",
  "Entertainment": "বিনোদন",
  "Historical Fiction": "ঐতিহাসিক উপন্যাস",
  "Political": "রাজনৈতিক",
  "Classical Music": "শাস্ত্রীয় সঙ্গীত",
  "Comedy": "হাস্য",
  "Science Fiction": "বিজ্ঞান কল্পকাহিনী",
  "Satire": "ব্যঙ্গ",
  "Humor": "হাস্যরস",
  "Autobiography": "আত্মজীবনী",
  "Lifestyle": "জীবনধারা",
  "Kids & Family": "শিশু ও পরিবার",
  "Devotional": "ভক্তিমূলক",
  "Nature & Wildlife": "প্রকৃতি ও বন্যজীবন",
  "Travelogue": "ভ্রমণকাহিনী",
  "Folk Music": "লোকসঙ্গীত",
  "Storytelling": "গল্পকথা",
  "Dance": "নৃত্য",
  "Talk Shows": "আলোচনা অনুষ্ঠান",
  "Inspirational": "অনুপ্রেরণামূলক",
  "Reality": "বাস্তবতা",
  "War": "যুদ্ধ",
"Rom-Com": "রম-কম",
  "Action": "অ্যাকশন",
  "Agriculture": "কৃষি",
  "International": "আন্তর্জাতিক",
  "Anime": "অ্যানিমে",
  "Period Drama": "ঐতিহাসিক নাটক",
  "Sci-Fi": "বিজ্ঞান কল্পকাহিনী",
  "Patriotic": "দেশপ্রেম",
  "Performing Arts": "মঞ্চকলা",
  "Astrology": "জ্যোতিষশাস্ত্র",
  "Fashion": "ফ্যাশন",
  "Talent Hunt": "প্রতিভা অনুসন্ধান",
  "Cookery": "রান্না",
  "Talk Show": "আলোচনা অনুষ্ঠান",
  "Superhero": "সুপারহিরো",
  "Literary Fiction": "সাহিত্যিক কল্পকাহিনী",
  "Science": "বিজ্ঞান",
  "Scientific": "বৈজ্ঞানিক",
  "Cooking": "রান্না",
  "Carnatic Music": "কর্ণাটকী সঙ্গীত",
"Finance": "অর্থসংস্থান",
"Hobbies And Crafts": "শখ এবং কারুশিল্প",
"Business and Finance": "ব্যবসা এবং অর্থ",
"Industrial design": "শিল্প নকশা",
  "Food": "খাদ্য",
  "Travel": "ভ্রমণ",
  "Paintings": "চিত্রকলা",
  "Design": "ডিজাইন",
  "Art": "কলা",
  "Nature": "প্রকৃতি",
  "Arts And Culture": "কলা ও সংস্কৃতি",
  "Educational Books": "শিক্ষামূলক বই",
  "Young Adult Fiction": "তরুণ প্রাপ্তবয়স্ক গল্প",
  "News": "সংবাদ",
  "Technology": "প্রযুক্তি",
  "Open World": "খোলা বিশ্ব",
  "Business": "ব্যবসা",
  "Home Decor": "গৃহসজ্জা",
  "Chat Show": "আলোচনা অনুষ্ঠান",
  "Edutainment": "শিক্ষা ও বিনোদন",
  "Social Awareness": "সামাজিক সচেতনতা",
  "Event": "ঘটনা",
  "Hindustani Classical Music": "হিন্দুস্তানি শাস্ত্রীয় সঙ্গীত",
  "Semi-Classical Music": "অর্ধ-শাস্ত্রীয় সঙ্গীত",
  "Kids": "শিশু",
  "Celebration": "উৎসব",
  "Casual": "সাধারণ",
  "Medical": "চিকিৎসা",
  "Yojna": "পরিকল্পনা",
  "Sculptures": "ভাস্কর্য",
  "Carbatic Music": "কর্ণাটক সঙ্গীত",
  "Digital Literacy": "ডিজিটাল সাক্ষরতা",
  "Legal And Ethical": "আইনগত ও নৈতিক",
  "Digital art": "ডিজিটাল শিল্প",
  "Parenting": "পিতৃত্ব / মাতৃত্ব",
    Sports:"খেলা",
            inviteReferr:"আপনার বন্ধুকে এই অভিজ্ঞতায় যোগ দিতে আমন্ত্রণ জানান",
     refer_friend:"একটি বন্ধু পরিচিত করুন",
     Begins_on:"এই অনুষ্ঠানটি এখনও লাইভ নয়",
    Left: "বাম",
    "pbApp":"আপনার প্রোফাইল সম্পাদনা করতে Waves PB মোবাইল অ্যাপ ব্যবহার করুন",
    dislike:"অপছন্দ করুন",
    rentalDescriptionMsg:"www.wavespb.com থেকে কনটেন্ট কেনা চালিয়ে যান",
     "Okay, Got it":"ঠিক আছে, বুঝেছি",
    Yes: "হ্যাঁ",
    No: "না",
    "Referral code is empty": "রেফারেল কোড খালি",
    "Enter a valid referral code": "একটি বৈধ রেফারেল কোড লিখুন",
    Movies: "চলচ্চিত্র",
    Audio: "অডিও",
    Shows: "শো",
    Music: "সঙ্গীত",
    All: "সব",
    Live: "লাইভ",
    Documentary: "ডকুমেন্টারি",
    "Recently Added": "সম্প্রতি যোগ করা হয়েছে",
    Nostalgia: "নস্টালজিয়া",
    "News Features": "সংবাদ বৈশিষ্ট্য",
    "Waves Originals": "ওয়েভস অরিজিনালস",
    Action: "অ্যাকশন",
    Kids: "বাচ্চাদের",
    Romance: "রোমান্স",
    Comedy: "কমেডি",
    Thriller: "থ্রিলার",
    Devotional: "ভক্তি",
    Shorts: "শর্টস",
    Scan_using_app_or_mobile_camera1:
      "অ্যাপ বা মোবাইল ক্যামেরা দিয়ে স্ক্যান করুন",
    Having_Trouble_Logging_in:
      "লগইন করতে সমস্যা হচ্ছে? অনুগ্রহ করে www.wavespb.com-এ যান",
    have_refferel_code: "আপনার কাছে রেফারেল কোড আছে?",
    view_more: "আরও দেখুন",
    view_less: "কম দেখুন",
    streaming_from: "થી સ્ટ્રીમિંગ",
    "Session-Expired": "সেশন শেষ হয়েছে",
    "session-desc": "আপনার সেশনের সময়সীমা শেষ হয়ে গেছে।",
    RentAvailable: "₹ এ ভাড়ার জন্য উপলব্ধ",
    RentMsg:
      "ক্রয়ের দিন থেকে এই সামগ্রী দেখার জন্য ৩০ দিনের ভাড়া অন্তর্ভুক্ত রয়েছে।",
    "Error!": "ত্রুটি!",
    streaming_start: "স্ট্রিমিং থেকে",
    midnight: "মধ্যরাত থেকে",
    "Success!": "সফলতা!",
    WatchlistError: "ওয়াচলিস্টে যোগ করতে অক্ষম। অনুগ্রহ করে আবার চেষ্টা করুন।",
    WatchlistSuccess: "সফলভাবে ওয়াচলিস্টে যোগ করা হয়েছে।",
    GamePlay: "আমি কীভাবে খেলব?",
    PlayMsg:
      "এই গেমটি খেলতে, দয়া করে Waves PB অ্যাপ ব্যবহার করুন বা www.wavespb.com এ যান।",
    "Login to Continue": "চালিয়ে যেতে লগইন করুন",
    LoginContinue: "আমাদের অ্যাপের সম্পূর্ণ অ্যাক্সেস উপভোগ করতে লগইন করুন।",
    Prasar_Bharti_Mobile_App:
      "এবং প্রসার ভারতী মোবাইল অ্যাপে আপনার প্রোফাইল সম্পাদনা করুন।",
    go_to_account: '"আমার অ্যাকাউন্ট"-এ যান',
    RefferalMsg:
      "যেসব নম্বর ইতিমধ্যেই নিবন্ধিত হয়েছে, তাদের জন্য এটি প্রযোজ্য নয়!",
    clear: "পরিষ্কার",
    del: "মুছুন",
    space: "স্পেস",
    Apply: "প্রয়োগ করুন",
    Live_Events: "লাইভ ইভেন্ট",
    RefferalCode: "রেফারেল কোড",
    referal_code: "রেফারেল কোড",
    ResuminWating: "চালিয়ে যান",
    no_additional_track: "কোনও অতিরিক্ত অডিও ট্র্যাক উপলব্ধ নয়",
    having_trouble_loggin_in_please_visit_our_website:
      "লগ ইন করতে সমস্যা হচ্ছে? দয়া করে আমাদের ওয়েবসাইটে যান।",
    Subscribewatch: "সাবস্ক্রাইব ওয়াচ",
    SubscribeMsg:
      "এই কনটেন্ট দেখার জন্য, অনুগ্রহ করে আমাদের ওয়েবসাইট www.wavespb.com-এ আপনার ক্রয় সম্পূর্ণ করুন।",
    Subscribelisten: "সাবস্ক্রাইব লিস্টেন",
    available_to_rent: "রেন্টের জন্য উপলব্ধ",
    login_with: "সাথে লগইন",
    LoginToWatch: "এখনি দেখুন",
    Watchnow: "এখনি দেখুন",
    ListenToWatch: "এখনি শুনুন",
    Listennow: "এখন শুনুন",
    Logout: "লগআউট",
    proceed: "এগিয়ে যান",
    "Help&Support": "সহায়তা ও সমর্থন",
    skip_start_browsing: "ব্রাউজিং শুরু করুন",
    "Privacy-Policy": "গোপনীয়তা নীতি",
    "Term&Conditions": "শর্তাবলী ও শর্ত",
    "About-Us": "আমাদের সম্পর্কে",
    Search_: "সার্চ",
    done: "সম্পন্ন",
     Live_Events: "লাইভ ইভেন্ট" ,
    availableOnRent: "ভাড়ায় উপলব্ধ",
    "Top-Results": "শীর্ষ ফলাফল",
    enter_mobile_number: "মোবাইল নম্বর লিখুন",
    "Popular-Searches": "জনপ্রিয় অনুসন্ধান",
    "Popular-Search": "জনপ্রিয় অনুসন্ধান",
    sign_in_with_mobile_or_email: "মোবাইল বা ইমেল দিয়ে সাইন ইন করুন",
    searchplaceholder: "শিল্পী, শো, প্লেলিস্ট বা কন্টেন্ট অনুসন্ধান করুন",
    Scan_using_app_or_mobile_camera: "মোবাইল অ্যাপ ব্যবহার করে স্ক্যান করুন",
    enter_your_mobile_number_or_email_to_continue:
      "চালিয়ে যাওয়ার জন্য আপনার মোবাইল নম্বর বা ইমেল লিখুন",
    Home_: "হোম",
    Live_: "টিভি/রেডিও",
    subtitle: "সাবটাইটেল",
    no_subtitle: "কোনো সাবটাইটেল উপলব্ধ নেই",
    left: "বাম",
    "Delete-Account": "অ্যাকাউন্ট মুছে ফেলুন",
    Watchlist: "ওয়াচলিস্ট",
    "My-Profile": "আমার প্রোফাইল",
    get_a_new_code: "নতুন কোড পান",
    or: "বা",
    Edit: "সম্পাদনা",
    Add: "যোগ করুন",
    "Edit-Profile": "প্রোফাইল সম্পাদনা করুন",
    "Add-Profile": "প্রোফাইল যোগ করুন",
    "Who’sWatching?": "কে দেখছে?",
    "placeholder-profile": "প্রোফাইল নাম লিখুন",
    "Kid’sprofile?": "শিশুর প্রোফাইল?",
    "Onlyshowkid-friendlyvideos": "শুধুমাত্র শিশু-বান্ধব ভিডিও দেখান",
    "No-Result-Found": "কোন ফলাফল পাওয়া যায়নি",
    "try-other-keyword": "অন্য কীওয়ার্ড চেষ্টা করুন",
    "No-data-found": "কোন ডাটা পাওয়া যায়নি",
    "No-list-found": "কোন তালিকা পাওয়া যায়নি। আপনার পছন্দ যোগ করুন",
    "Continue-Watching": "দেখা চালিয়ে যান",
    Login: "লগলগইন",
    Guest: "অতিথি",
    "Login-to-your-account": "আপনার অ্যাকাউন্টে লগইন করুন",
    welcome_to_dds_world_of_entertainment: "ডিডির বিনোদন জগতে স্বাগতম",
    "Login-enter-no":
      "আপনার মোবাইল নম্বর লিখুন এবং চলচ্চিত্র, খেলা ও সিরিজ আবিষ্কার করুন",
    "Login-enter-no-email":
      "আপনার ইমেইল লিখুন এবং চলচ্চিত্র, খেলা ও সিরিজ আবিষ্কার করুন",
    "Phone-Number": "মোবাইল নম্বর",
    "sms-verify": "আপনার মোবাইল নম্বর যাচাই করার জন্য একটি ওটিপি পাঠানো হবে",
    "email-verify": "আপনার ইমেইল যাচাই করার জন্য একটি ওটিপি পাঠানো হবে",
    "Send-OTP": "ওটিপি পাঠান",
    "confirm-that-agree": "আপনি নিশ্চিত যে আপনি এই শর্তাবলীর সাথে একমত হন",
    "OTP-Verification": "ওটিপি যাচাই",
    "verification-code": "যাচাই কোড লিখুন",
    "not-receive-code": "কোড পাওয়া যায়নি?",
    Resend: "পুনরায় পাঠান",
    "Having-Issue?": "কোন সমস্যা আছে?",
    "Contact-Us": "আমাদের সাথে যোগাযোগ করুন!",
    "Enter-Phone-Number": "মোবাইল নম্বর লিখুন",
    "Resend-OTP-in": "পুনরায় ওটিপি পাঠানো হবে",
    verify: "যাচাই",
    "cofirm-logout":"আপনি কি নিশ্চিত যে আপনি অ্যাপ থেকে লগআউট করতে চান?",
    Confirm: "নিশ্চিত করুন",
    logout: "লগআউট",
    notifications: "নোটিফিকেশন",
    registered_devices: "নিবন্ধিত ডিভাইস",
    clear_search_history: "অনুসন্ধান ইতিহাস মুছে ফেলুন",
    subscription_and_devices: "সাবস্ক্রিপশন ও ডিভাইস",
    subscription: "সাবস্ক্রিপশন",
    my_device: "আমার ডিভাইস",
    Cancel: "বাতিল",
    payment_details: "পেমেন্ট বিবরণ",
    other_devices: "অন্যান্য ডিভাইস",
    deregister: "ডিরেজিস্টার",
    "Content-Language-Changed": "কন্টেন্ট ভাষা পরিবর্তন করা হয়েছে",
    "App-Language-Changed": "অ্যাপ ভাষা পরিবর্তন করা হয়েছে",
    "Change-Language": "ভাষা পরিবর্তন করুন",
    Previous: "পূর্ববর্তী",
    More: "আরও",
    audio_quality: "অডিও গুণমান",
    speed: "গতি",
    Delete: "মুছুন",
    Notification: "নোটিফিকেশন",
    no_noti_found: "নোটিফিকেশন পাওয়া যায়নি",
    Artist: "শিল্পী",
    just_now: "এইমাত্র",
    title_activity_purchase_history: "ক্রয় ইতিহাস",
    first_fragment_label: "প্রথম ফ্র্যাগমেন্ট",
    second_fragment_label: "দ্বিতীয় ফ্র্যাগমেন্ট",
    Next: "পরবর্তী",
    next_episode: "পরবর্তী এপিসোড",
    Download: "ডাউনলোড",
    transaction_history: "লেনদেন ইতিহাস",
    no_transaction_history: "লেনদেন ইতিহাস পাওয়া যায়নি",
    str_watch_list: "ওয়াচলিস্ট",
    my_purchased_video: "আমার ক্রয় ভিডিও",
    subscribe_: "সাবস্ক্রাইব করুন",
    plan_price: "পরিকল্পনা মূল্য",
    remaining_balance: "অবশিষ্ট ব্যালেন্স",
    total_amount: "মোট পরিমাণ",
    n_a: "এন/এ",
    run_on_physical_device_only: "শুধুমাত্র পদার্থ ডিভাইসে চালান",
    btn_ok: "ঠিক আছে",
    msg_vpn_error: "ভিপিএন ত্রুটি",
    note_your_code_will_be_updated_after_5_min:
      "নোট: আপনার কোড ৫ মিনিট পরে আপডেট হবে",
    payable_amount: "পরিশোধ্য পরিমাণ",
    didnt_receive_otp: "ওটিপি পাওয়া যায়নি",
    hello_first_fragment: "হ্যালো",
    hello_second_fragment: "ক্রয় বিবরণ",
    coming_soon: "শীঘ্রই আসছে",
    packages: "প্যাকেজ",
    str_support: "সমর্থন",
    delete_acct: "অ্যাকাউন্ট মুছে ফেলুন",
    delete_conform: "আপনি নিশ্চিত যেআপনি অ্যাকাউন্ট মুছে ফেলতে চান?",
    delete_profile_success: "প্রোফাইল সফলভাবে সরানো হয়েছে",
    Dlt_Accnt_msg: "অ্যাকাউন্ট মুছে ফেলা নিশ্চিত করুন বার্তা",
    some_error_occurred_please_try_again:
      "কোন ত্রুটি  happend. Please try again.",
    auto: "স্বয়ংক্রিয়",
    player_not_ready_try_again: "খেলোয়াড় প্রস্তুত নয়। আবার চেষ্টা করুন。",
    edit_profile: "প্রোফাইল সম্পাদনা",
    learn_more: "আরও জানুন",
    wishlist: "ইচ্ছার তালিকা",
    category_name: "বিভাগ",
    str_my_download: "আমার ডাউনলোড",
    language: "ভাষা",
    added_watch_list: "ওয়াচ তালিকায় যোগ করা হয়েছে",
    removed_watch_list: "ওয়াচ তালিকা থেকে সরানো হয়েছে",
    viewall: "সব দেখুন",
    msg_video_expired:
      "এই ভিডিও মেয়াদোত্তীর্ণ হয়েছে। আবার কিনতে হবে দেখার জন্য。",
    skip_intro: "ইন্ট্রো এড়িয়ে যান",
    settings: "সেটিংস",
    video_quality: "ভিডিও মান",
    video_speed: "ভিডিও গতি",
    like: "পছন্দ",
    unlike: "অপছন্দ",
    refund: "ফেরত",
    userProfile: "ব্যবহারকারীর প্রোফাইল",
    signup_create_new_account: "সাইন আপ: নতুন অ্যাকাউন্ট তৈরি করুন",
    already_acc_login: "ইতিমধ্যে অ্যাকাউন্ট আছে? লগইন করুন",
    accept_terms_and_condition: "শর্তাবলী গ্রহণ করুন",
    new_password: "নতুন পাসওয়ার্ড",
    api_failure_msg: "এপিআই ব্যর্থতা",
    remove_profile_pic: "প্রোফাইল ছবি সরান",
    remove: "সরান",
    msg_remove_profile_pic: "প্রোফাইল ছবি সরানোর নিশ্চিতকরণ বার্তা",
    profile_photo: "প্রোফাইল ছবি",
    purchased_video: "ক্রয় করা ভিডিও",
    upgrade: "আপগ্রেড",
    msg_send_otp: "ওটিপি পাঠান",
    forgot_your_password: "আপনার পাসওয়ার্ড ভুলে গেছেন?",
    msg_search_content: "সামগ্রী খুঁজুন",
    current_plan: "বর্তমান পরিকল্পনা",
    more_like_this: "এর মতো আরও",
    download_channel_id: "ডাউনলোড চ্যানআইডি",
    download_video_service_channel: "ডাউনলোড ভিডিও সার্ভিস চ্যানেল",
    searchLikehotStar: "হট স্টারের মতো খুঁজুন",
    don_t_have_an_account: "অ্যাকাউন্ট নেই?",
    delete_video: "ভিডিও মুছে ফেলুন",
    sign_up: "সাইন আপ",
    having_forget_password: "পাসওয়ার্ড ভুলে গেছেন?",
    complete_profile: "প্রোফাইল সম্পূর্ণ করুন",
    add_profile: "প্রোফাইল যোগ করুন",
    wait_to_play_video: "ভিডিও চালানোর জন্য অপেক্ষা করুন",
    buy_now_at: "এখনি কিনুন @",
    upgrade_now_at: "এখনি আপগ্রেড করুন @",
    new_text: "নতুন টেক্সট",
    rate_app_title: "রেট করুন",
    rate_app_message:
      "আমাদের অ্যাপ উপভোগ করছেন, তাহলে প্লে স্টোরে রেট করুন। আমাদের সমর্থনের জন্য ধন্যবাদ",
    rate_btn_pos: "রেট করুন এখনি",
    rate_btn_neg: "পরে মনে করুন",
    rate_btn_nut: "না, ধন্যবাদ",
    change_name: "নাম পরিবর্তন করুন",
    download_options: "ডাউনলোড অপশন",
    low_quality: "নিম্ন মান",
    medium_quality: "মধ্যম মান",
    high_quality: "উচ্চ মান",
    downloading: "ডাউনলোডিং",
    download_pause: "ডাউনলোড স্থগিত করুন",
    downloaded: "ডাউনলোড করা হয়েছে",
    download_url_is_not_found: "ডাউনলোড ইউআরএল পাওয়া যায়নি",
    download_running: "ডাউনলোড চলছে",
    no_plan_subscribed: "কোন পরিকল্পনা সাবস্ক্রাইব করা হয়নি",
    privacypolicy: "গোপনীয়তা নীতি",
    termsuse: "শর্তাবলী ব্যবহার",
    resendotp_in: "ওটিপি পুনরায় পাঠান (লগইনের জন্য প্রয়োজন)",
    login_required: "লগইন প্রয়োজন",
    sorry_we_couldn_t_complete_your_request_please_try_again_in_a_moment:
      "আমরা আপনার অনুরোধ সম্পন্ন করতে পারিনি। কিছুক্ষণ পরে আবার চেষ্টা করুন।",
    trailer: "ট্রেলার",
    subscribe_now_to_watch: "এখনই সাবস্ক্রাইব করুন দেখার জন্য",
    app_version: "অ্যাপ সংস্করণ",
    select_all: "সব নির্বাচন করুন",
    please_enter_valid_name: "অনুগ্রহ করে বৈধ নাম প্রবেশ করুন",
    choose_avatar: "অনুগ্রহ করে অবতার বাছাই করুন",
    enter_name: "অনুগ্রহ করে নাম অন্তর্ভুক্ত করুন",
    unselect_all: "সব অনির্বাচন করুন",
    enter_mobile_number: "মোবাইল নম্বর প্রবেশ করুন",
    title_activity_scan_qr_code: "কিউআর কোড স্ক্যান করুন",
    plz_enter_name: "অনুগ্রহ করে নাম প্রবেশ করুন",
    plz_change_name: "অনুগ্রহ করে নাম পরিবর্তন করুন",
    plz_choose_avtar: "অনুগ্রহ করে অভতার নির্বাচন করুন",
    plz_select_profile: "অনুগ্রহ করে প্রোফাইল নির্বাচন করুন",
    who_s_watching: "কে দেখছে",
    my_profile: "আমার প্রোফাইল",
    profiles: "প্রোফাইলসমূহ",
    clear: "পরিষ্কার",
    recent_searches: "সাম্প্রতিক অনুসন্ধান",
    Recommended_searches: "সুপারিশকৃত অনুসন্ধান",
    please_enter_your_number_to_discover_a_variety_nof_movies_sports_series:
      "আপনার নম্বর প্রবেশ করুন চলচ্চিত্র, খেলা এবং সিরিজের বৈচিত্র্য আবিষ্কার করতে",
    mobile_number: "মোবাইল নম্বর",
    having_issue_contact_us: "সমস্যা হচ্ছে? আমাদের সাথে যোগাযোগ করুন",
    didn_t_receive_code_resend: "কোড পাইনি? আবার পাঠান",
    enter_the_verification_code_we_just_sent_to_your_number:
      "আপনার নম্বরে আমরা সম্প্রতি পাঠানো যাচাইকরণ কোড প্রবেশ করুন",
    incorrect_otp_entered_please_enter_again:
      "ভুল ওটিপি প্রবেশ করুন। আবার প্রবেশ করুন",
    app_update_title: "অ্যাপ আপডেট",
    app_update_msg: "অ্যাপের নতুন সংস্করণ এখনই উপলব্ধ",
    watch_now: "এখনই দেখুন",
    my_list: "আমার তালিকা",
    cast_and_crew: "অভিনয় এবং ক্রু",
    similar_to_this: "এর মতো",
    similar_channels: "একই ধরনের চ্যানেলসমূহ",
    delete_account: "অ্যাকাউন্ট মুছে ফেলুন",
    delete_account_desc: "আপনি কি নিশ্চিত যে আপনার অ্যাকাউন্ট মুছে ফেলতে চান",
    delete_conform: "প্রোফাইল?",
    log_out: "লগ আউট",
    log_out_desc: "আপনি এই অ্যাকাউন্ট থেকে লগ আউট করতে চান?",
    pb_on_tv: "টিভিতে প্রসার ভারতি",
    link_device: "ডিভাইস লিঙ্ক করুন",
    linked_tv: "লিঙ্ক করা টিভি",
    link_with_tv: "আপনি টিভির সাথে লিঙ্ক করতে চান?",
    no_result_found: "কোনো ফলাফল পাওয়া যায়নি",
    search_again: "আবার অনুসন্ধান করুন",
    no_list_found: "কোনো তালিকা পাওয়া যায়নি",
    no_list_found_desc:
      "আপনার পছন্দের তথ্য পাওয়া যায়নি, অনুগ্রহ করে আবার পর্যালোচনা করুন",
    no_notifications: "কোনো নোটিফিকেশন পাওয়া যায়নি",
    no_notifications_desc: "আপনার কোনো নোটিফিকেশন নেই, আবার ফিরে আসুন",
    network_error: "নেটওয়ার্ক ত্রুটি",
    retry: "আবার চেষ্টা করুন",
    open_setting: "সেটিং খুলুন",
    internal_server: "অভ্যন্তরীণ সার্ভার ত্রুটি",
    internal_server_error:
      "সার্ভার একটি ত্রুটি পেয়েছে আপনার অনুরোধ প্রক্রিয়াকরণের সময়",
    go_back: "ফিরে যান",
    data_not_found: "তথ্য পাওয়া যায়নি1/2",
    page_not_found_desc: "আপনি দেখছেন একটি অস্তিত্ব নেই পাতা",
    popular_search: "জনপ্রিয় অনুসন্ধান",
    top_results: "শীর্ষ ফলাফল",
    guest_user: "অতিথি ব্যবহারকারী",
    channels: "চ্যানেলস",
    Radio: "রেডিও",
    TV: "টিভি",
    favorites: "প্রিয়",
    content_language: "কন্টেন্ট ভাষা",
    app_language: "অ্যাপ ভাষা",
    change_account: "প্রোফাইল পরিবর্তন",
    move_account: "আপনি কি অন্য একটি প্রোফাইলে স্থানান্তরিত হতে চান?",
    update_profile: "আপনার প্রোফাইল সফলভাবে আপডেট করা হয়েছে",
    added_profile: "আপনার প্রোফাইল সফলভাবে যোগ করা হয়েছে",
    edit_update: "আপডেট করুন",
    cast_crew: "অভিনয় এবং ক্রু",
    episodes: "অ্যাপিসোড",
    no_record: "কোনো রেকর্ড পাওয়া যায়নি",
    free_time_up: "নেক্সট থেকে ফ্রি টাইম শেষ!",
    free_create_account:
      "সাইন ইন বা নতুন একটি খাতে তৈরি করুন চলুন দেখা শেষ হতে হবে",
    adventure: "অ্যাডভেনচার",
    prasar_bharti: "প্রসার ভারতী",
    ind_broadcast: "(ভারতের জনপ্রসারক)",
    back_to_home: "বাড়িতে ফিরে যান",
    oops_page_not_found: "ওহো! পাতা খুঁজে পাওয়া যায়নি",
    page_looking: "আপনি খুঁজছেন একটি পাতা নেই",
    go_to_home: "হোম পেজে যান",
    popular_genres: "জনপ্রিয় জান্র",
    watchLanguage: "আপনার ভাষায় দেখুন",
    help_support: "সহায়তা এবং সমর্থন",
    customer_support: "গ্রাহক সমর্থন",
    contact_number: "যোগাযোগ নম্বর",
    email_address: "ইমেইল ঠিকানা",
    share: "ভাগ করুন",
    copy: "কপি করুন",
    copied: "কপি করা হয়েছে",
    bharat_ott: "ভারত অটি টি",
    Home_: "বাড়ি",
    policy: "ফেরত এবং বাতিল নীতি",
    policy: "ফেরত ও বাতিল নীতি",
    terms_condition: "শর্তাবলী ও শর্ত",
    your_account: "আপনার একটি অ্যাকাউন্ট আছে?",
    continue: "চালিয়ে যান",
    "login_here!": "এখানে লগইন করুন!",
    mobile: "মোবাইল",
    password: "পাসওয়ার্ড",
    forgot_password: "পাসওয়ার্ড ভুলে গেছেন?",
    sign_up_here: "এখানে সাইন আপ করুন!",
    social_media: "সামাজিক মিডিয়ার সাহায্যে চালিয়ে যান",
    search_data: "সমস্ত সার্চ ডেটা",
    description: "বিবরণ",
    episode_name: "পর্বের নাম",
    episode_num: "পর্ব নং",
    page_looking_might:
      "আপনি যে পেজটি খুঁজছেন তা সম্ভবত সরিয়ে নেওয়া হয়েছে, নাম পরিবর্তন করা হয়েছে বা অস্থায়ীভাবে অনুপলব্ধ",
    Ok: "ঠিক আছে",
    otp_sent: "ওটিপি সফলভাবে পাঠানো হয়েছে",
    success: "সফল",
    could_not_sent: "ওটিপি পাঠানো যায়নি",
    error: "ত্রুটি",
    resent_otp: "ওটিপি সফলভাবে পাঠানো হয়েছে",
    enter_valid_otp: "সঠিক ওটিপি প্রবেশ করুন",
    enter_six_digit_valid: "৬ অঙ্কের সঠিক ওটিপি প্রবেশ করুন",
    profile_creation: "প্রোফাইল সফলভাবে তৈরি করা হয়েছে",
    error_name: "প্রোফাইল নাম প্রবেশ করুন",
    "Delete-Profile": "প্রোফাইল মুছে ফেলুন",
    add_to_watchlist: "ওয়াচলিস্টে যোগ করুন",
    added_to_watchlist: "ওয়াচলিস্টে যোগ করা হয়েছে",
    like_it: "আমি এটা পছন্দ করি",
    not_for_me: "আমার জন্য নয়",
    "n-number": "নম্বসংখ্যা",
    "e-email": "ই-মেইল",
    "account-subscribe": "সাবস্ক্রাইব করুন",
    "account-subscribe-upgrade": "আপগ্রেড করুন",
    "user-details-text": "ব্যবহারকারীর বিবরণ",
    "acc-username": "ব্যবহারকারীর নাম",
    "acc-enterusername": "ব্যবহারকারীর নাম প্রবেশ করুন",
    "acc-mobile": "মোবাইল নম্বর",
    "acc-entermobile": "মোবাইল নম্বর প্রবেশ করুন",
    "acc-email": "ই-মেইল ঠিকানা",
    "acc-enteremail": "ই-মেইল ঠিকানা প্রবেশ করুন",
    "acc-Gender": "লিঙ্গ",
    "acc-Gender1": "পুরুষ",
    "acc-Gender2": "মহিলা",
    "acc-Gender3": "অন্যান্য",
    "acc-dob": "জন্ম তারিখ",
    "acc-save": "বিবরণ সংরক্ষণ করুন",
    "my-account": "আমার অ্যাকাউন্ট",
    "trans-history": "লেনদেন ইতিহাস",
    "acc-varified": "সত্যায়িত",
    "network-error": "নেটওয়ার্ক ত্রুটি",
    "network-unable": "নেটওয়ার্ক সংযোগ করা যায়নি",
    "network-retry": "আবার চেষ্টা করুন",
    "download-apps": "আমাদের অ্যাপ ডাউনলোড করুন",
    "PB-OTT": "পিবি ওটিটি",
    "copy-right": "কপিরাইট",
    all_right: "সমস্ত অধিকার সংরক্ষিত",
    versions: "সংস্করণ-",
    "Help-Support": "সাহায্য ও সমর্থন",
    "internet-connection": "ইন্টারনেট সংযোগ",
    "nointernet-connection": "ইন্টারনেট সংযোগ নেই",
    "Terms-and-Conditions": "শর্তাবলী ও শর্ত",
    "Help-&-Support": "সাহায্য ও সমর্থন",
    "unmute-tra": "ট্রেইলার আনমিউট করুন",
    "mute-tra": "ট্রেইলার মিউট করুন",
    favourite_lang: "পছন্দ ভাষা যোগ করুন",
    added_lang: "যোগ করা হয়েছে",
    "no-notfication": "কোন নোটিফিকেশননেই",
    "notfication-dt": "আপনার কোন নোটিফিকেশন নেই। পরে আবার চেষ্টা করুন",
    or: "অথবা",
    and: "এবং",
    sahmat: "",
    "par-bheje": " ",
    "server-error": "সার্ভার ত্রুটি",
    "server-error-msg": "আপনার অনুরোধ প্রক্রিয়াকরণে সার্ভার ত্রুটি হয়েছে",
    "server-retry": "হোমপেজে যান",
    "watch-lang": "আপনার ভাষায় দেখুন",
    "popular-genre": "জনপ্রিয় ধারা",
    subscription_heading:
      "সমস্ত কন্টেন্ট দেখার জন্য পিবি ওটিটিতে সাবস্ক্রাইব করুন",
    add: "যোগ করুন",
    proceed_to_pay_btn: "পরিশোধ করার জন্য এগিয়ে যান",
    have_promo: "প্রমো কোড আছে?",
    promo_code: "প্রমো কোড",
    enter_promo_code: "প্রমো কোড প্রবেশ করুন",
    apply_code_btn: "কোড প্রয়োগ করুন",
    select_live_channel_radio: "লাইভ চ্যানেল ও রেডিও নির্বাচন করুন",
    radio_channels: "রেডিও চ্যানেল",
    submit_btn: "জমা দিন",
    add_channel_radio: "টিভি চ্যানেল ও রেডিও যোগ করুন",
    live_tv_channels: "লাইভ টিভি চ্যানেল",
    live_radio_channels: "লাইভ রেডিও চ্যানেল",
    upgrade_subscription: "সাবস্ক্রাইব আপগ্রেড করুন",
    you_pay: "আপনি পরিশোধ করবেন",
    rem_amt_curr_plan: "বর্তমান পরিকল্পনার অবশিষ্ট পরিমাণ",
    payble_amt: "পরিশোধযোগ্য পরিমাণ",
    live_channel: "লাইভ চ্যানেল",
    continue_watching: "দেখা চালিয়ে যান",
    Exit: "প্রস্থান করুন",
    ExitMsg: "আপনি কি নিশ্চিত যে আপনি অ্যাপ থেকে প্রস্থান করতে চান?",
  },
};

export const Translate = ({ langKey }) => {
  // console.log(langKey);
  const lang = localStorage.getItem("AppLanguage");
  const selectedLanguage = lang ? lang : "English";
  const getTranslation = (key) => {
    return Languages[selectedLanguage]?.[key] || Languages.English[key];
  };
  return <>{getTranslation(langKey)}</>;
};